/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdCopy,
  AdCopyCreate,
  AdCopyList,
  AdCopyUpdate,
  AdStructure,
  AdStructureUpdate,
  AdSwapApproval,
  AdSwapDraft,
  AdSwapDraftWrite,
  AdSwapScriptAsk,
  AiActor,
  AiActorCompleteRequest,
  AiActorFromGenerationRequest,
  AiActorFromLibraryRequest,
  AiActorList,
  AiActorPage,
  AiActorUploadRequest,
  AiActorUploadTicket,
  BalloonAdBlankScript,
  BalloonAdDraft,
  BalloonAdDraftWrite,
  BalloonAdScriptApproval,
  BalloonAdScriptAsk,
  CartoonApproval,
  CartoonCloneApproval,
  CartoonCloneDraft,
  CartoonCloneDraftWrite,
  CartoonCloneScriptAsk,
  CartoonDraft,
  CartoonDraftWrite,
  CartoonScriptAsk,
  CartoonVillainApproval,
  CartoonVillainDraft,
  CartoonVillainDraftWrite,
  CartoonVillainScriptAsk,
  Catalog,
  ChalkExplainerAdApproval,
  ChalkExplainerAdDraft,
  ChalkExplainerAdDraftWrite,
  ChalkExplainerAdScriptAsk,
  ClaymationAdDraft,
  ClaymationAdDraftWrite,
  ClaymationAdScriptApproval,
  ClaymationAdScriptAsk,
  ClaymationAdVoiceApproval,
  ErrorEnvelope,
  FirstAdApprove,
  FirstAdDeliveryView,
  FirstAdOfferRequest,
  FirstAdPick,
  FirstAdPreviewSeen,
  FirstAdProductIntake,
  FirstAdProductRequest,
  FirstAdProductSave,
  FirstAdRetryRequest,
  FirstAdState,
  FirstAdTiles,
  FlatCartoonApproval,
  FlatCartoonDraft,
  FlatCartoonDraftWrite,
  FlatCartoonScriptAsk,
  GenerationType,
  GreenScreenApproval,
  GreenScreenDraft,
  GreenScreenDraftWrite,
  GreenScreenScriptAsk,
  GrwmApproval,
  GrwmDraft,
  GrwmDraftWrite,
  GrwmScriptAsk,
  ImportedGeneration,
  Job,
  JobDetails,
  JobPage,
  JobQuote,
  JobQuoteRequest,
  JobRequest,
  LayerDocument,
  LayerEditList,
  ListActorsParams,
  ListAdCopiesParams,
  ListJobsParams,
  ListPromptTemplatesParams,
  ListTemplatesParams,
  ListVoicesParams,
  PixarSingingAdDraft,
  PixarSingingAdDraftWrite,
  PixarSingingAdLyricsApproval,
  PixarSingingAdLyricsAsk,
  PixarSingingAdSongApproval,
  PixarTalkingAdApproval,
  PixarTalkingAdDraft,
  PixarTalkingAdDraftWrite,
  PixarTalkingAdScriptAsk,
  PixarWhiteboardAdApproval,
  PixarWhiteboardAdDraft,
  PixarWhiteboardAdDraftWrite,
  PixarWhiteboardAdPick,
  PixarWhiteboardAdScriptAsk,
  PixarWhiteboardAdShoot,
  PodcastAdApproval,
  PodcastAdDraft,
  PodcastAdDraftWrite,
  PodcastAdScriptAsk,
  PromptTemplate,
  PromptTemplatePage,
  PromptTemplateRequest,
  StartJobHeaders,
  StreetInterviewAdApproval,
  StreetInterviewAdDraft,
  StreetInterviewAdDraftWrite,
  StreetInterviewAdScriptAsk,
  TemplateCaptionStyleList,
  TemplateCategoryList,
  TemplateDetail,
  TemplateForm,
  TemplatePage,
  TwoSpeakerApproval,
  TwoSpeakerDraft,
  TwoSpeakerDraftWrite,
  TwoSpeakerScriptAsk,
  Voice,
  VoiceCompleteRequest,
  VoiceFromDesignRequest,
  VoicePage,
  VoiceUploadRequest,
  VoiceUploadTicket,
  YapperAdApproval,
  YapperAdDraft,
  YapperAdDraftWrite,
  YapperAdScriptAsk
} from '../../model';

import { apiRequest } from '../../../client';
import type { ErrorType } from '../../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetCatalogUrl = () => {




  return `/api/v1/catalog`
}

/**
 * The models a job can use, with every option and default, and the job types.
 * @summary Get Catalog
 */
export const getCatalog = async ( options?: Parameters<typeof apiRequest>[1]): Promise<Catalog> => {

  return apiRequest<Catalog>(getGetCatalogUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCatalogQueryKey = () => {
    return [
    `/api/v1/catalog`
    ] as const;
    }


export const getGetCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getCatalog>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalog>>> = ({ signal }) => getCatalog({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getCatalog>>>
export type GetCatalogQueryError = ErrorType<ErrorEnvelope>


export function useGetCatalog<TData = Awaited<ReturnType<typeof getCatalog>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalog>>,
          TError,
          Awaited<ReturnType<typeof getCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCatalog<TData = Awaited<ReturnType<typeof getCatalog>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalog>>,
          TError,
          Awaited<ReturnType<typeof getCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCatalog<TData = Awaited<ReturnType<typeof getCatalog>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Catalog
 */

export function useGetCatalog<TData = Awaited<ReturnType<typeof getCatalog>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCatalogQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFirstAdTilesUrl = () => {




  return `/api/v1/catalog/first-ad`
}

/**
 * Anonymous landing tiles. Prod never offers the dev-only funnel.
 * @summary Get First Ad Tiles
 */
export const getFirstAdTiles = async ( options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdTiles> => {

  return apiRequest<FirstAdTiles>(getGetFirstAdTilesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFirstAdTilesQueryKey = () => {
    return [
    `/api/v1/catalog/first-ad`
    ] as const;
    }


export const getGetFirstAdTilesQueryOptions = <TData = Awaited<ReturnType<typeof getFirstAdTiles>>, TError = ErrorType<ErrorEnvelope>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdTiles>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFirstAdTilesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFirstAdTiles>>> = ({ signal }) => getFirstAdTiles({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFirstAdTiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFirstAdTilesQueryResult = NonNullable<Awaited<ReturnType<typeof getFirstAdTiles>>>
export type GetFirstAdTilesQueryError = ErrorType<ErrorEnvelope>


export function useGetFirstAdTiles<TData = Awaited<ReturnType<typeof getFirstAdTiles>>, TError = ErrorType<ErrorEnvelope>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdTiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirstAdTiles>>,
          TError,
          Awaited<ReturnType<typeof getFirstAdTiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFirstAdTiles<TData = Awaited<ReturnType<typeof getFirstAdTiles>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdTiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirstAdTiles>>,
          TError,
          Awaited<ReturnType<typeof getFirstAdTiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFirstAdTiles<TData = Awaited<ReturnType<typeof getFirstAdTiles>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdTiles>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get First Ad Tiles
 */

export function useGetFirstAdTiles<TData = Awaited<ReturnType<typeof getFirstAdTiles>>, TError = ErrorType<ErrorEnvelope>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdTiles>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFirstAdTilesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetJobTypeCatalogUrl = (jobType: GenerationType,) => {




  return `/api/v1/catalog/${jobType}`
}

/**
 * The catalog narrowed to one listed job type, its models with that type's block
 * alone; 404 for a type the catalog does not list (today it lists every one).
 * @summary Get Job Type Catalog
 */
export const getJobTypeCatalog = async (jobType: GenerationType, options?: Parameters<typeof apiRequest>[1]): Promise<Catalog> => {

  return apiRequest<Catalog>(getGetJobTypeCatalogUrl(jobType),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobTypeCatalogQueryKey = (jobType: GenerationType,) => {
    return [
    `/api/v1/catalog/${jobType}`
    ] as const;
    }


export const getGetJobTypeCatalogQueryOptions = <TData = Awaited<ReturnType<typeof getJobTypeCatalog>>, TError = ErrorType<ErrorEnvelope>>(jobType: GenerationType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobTypeCatalog>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobTypeCatalogQueryKey(jobType);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobTypeCatalog>>> = ({ signal }) => getJobTypeCatalog(jobType, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: jobType !== null && jobType !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobTypeCatalog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobTypeCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof getJobTypeCatalog>>>
export type GetJobTypeCatalogQueryError = ErrorType<ErrorEnvelope>


export function useGetJobTypeCatalog<TData = Awaited<ReturnType<typeof getJobTypeCatalog>>, TError = ErrorType<ErrorEnvelope>>(
 jobType: GenerationType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobTypeCatalog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobTypeCatalog>>,
          TError,
          Awaited<ReturnType<typeof getJobTypeCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobTypeCatalog<TData = Awaited<ReturnType<typeof getJobTypeCatalog>>, TError = ErrorType<ErrorEnvelope>>(
 jobType: GenerationType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobTypeCatalog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobTypeCatalog>>,
          TError,
          Awaited<ReturnType<typeof getJobTypeCatalog>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobTypeCatalog<TData = Awaited<ReturnType<typeof getJobTypeCatalog>>, TError = ErrorType<ErrorEnvelope>>(
 jobType: GenerationType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobTypeCatalog>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Job Type Catalog
 */

export function useGetJobTypeCatalog<TData = Awaited<ReturnType<typeof getJobTypeCatalog>>, TError = ErrorType<ErrorEnvelope>>(
 jobType: GenerationType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobTypeCatalog>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobTypeCatalogQueryOptions(jobType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getRunFirstAdProductUrl = () => {




  return `/api/v1/me/first-ad-product`
}

/**
 * @summary Run First Ad Product
 */
export const runFirstAdProduct = async (firstAdProductRequest: FirstAdProductRequest, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdProductIntake> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FirstAdProductIntake>(getRunFirstAdProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(firstAdProductRequest)
  }
);}





export const getRunFirstAdProductMutationKey = () => ['runFirstAdProduct'] as const;

export const getRunFirstAdProductMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runFirstAdProduct>>, TError,RunFirstAdProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof runFirstAdProduct>>, TError,RunFirstAdProductMutationVariables, TContext> => {

const mutationKey = getRunFirstAdProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runFirstAdProduct>>, RunFirstAdProductMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  runFirstAdProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunFirstAdProductMutationResult = NonNullable<Awaited<ReturnType<typeof runFirstAdProduct>>>
    export type RunFirstAdProductMutationBody = FirstAdProductRequest
    export type RunFirstAdProductMutationError = ErrorType<ErrorEnvelope>
    export type RunFirstAdProductMutationVariables = {data: FirstAdProductRequest}

    /**
 * @summary Run First Ad Product
 */
export const useRunFirstAdProduct = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runFirstAdProduct>>, TError,RunFirstAdProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runFirstAdProduct>>,
        TError,
        RunFirstAdProductMutationVariables,
        TContext
      > => {
      return useMutation(getRunFirstAdProductMutationOptions(options), queryClient);
    }
    export const getGetFirstAdProductUrl = (intakeId: string,) => {




  return `/api/v1/me/first-ad-product/${intakeId}`
}

/**
 * @summary Get First Ad Product
 */
export const getFirstAdProduct = async (intakeId: string, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdProductIntake> => {

  return apiRequest<FirstAdProductIntake>(getGetFirstAdProductUrl(intakeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFirstAdProductQueryKey = (intakeId: string,) => {
    return [
    `/api/v1/me/first-ad-product/${intakeId}`
    ] as const;
    }


export const getGetFirstAdProductQueryOptions = <TData = Awaited<ReturnType<typeof getFirstAdProduct>>, TError = ErrorType<ErrorEnvelope>>(intakeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdProduct>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFirstAdProductQueryKey(intakeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFirstAdProduct>>> = ({ signal }) => getFirstAdProduct(intakeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: intakeId !== null && intakeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFirstAdProduct>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFirstAdProductQueryResult = NonNullable<Awaited<ReturnType<typeof getFirstAdProduct>>>
export type GetFirstAdProductQueryError = ErrorType<ErrorEnvelope>


export function useGetFirstAdProduct<TData = Awaited<ReturnType<typeof getFirstAdProduct>>, TError = ErrorType<ErrorEnvelope>>(
 intakeId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdProduct>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirstAdProduct>>,
          TError,
          Awaited<ReturnType<typeof getFirstAdProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFirstAdProduct<TData = Awaited<ReturnType<typeof getFirstAdProduct>>, TError = ErrorType<ErrorEnvelope>>(
 intakeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdProduct>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirstAdProduct>>,
          TError,
          Awaited<ReturnType<typeof getFirstAdProduct>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFirstAdProduct<TData = Awaited<ReturnType<typeof getFirstAdProduct>>, TError = ErrorType<ErrorEnvelope>>(
 intakeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdProduct>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get First Ad Product
 */

export function useGetFirstAdProduct<TData = Awaited<ReturnType<typeof getFirstAdProduct>>, TError = ErrorType<ErrorEnvelope>>(
 intakeId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdProduct>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFirstAdProductQueryOptions(intakeId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdvanceFirstAdProductUrl = (intakeId: string,) => {




  return `/api/v1/me/first-ad-product/${intakeId}/advance`
}

/**
 * @summary Advance First Ad Product
 */
export const advanceFirstAdProduct = async (intakeId: string, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdProductIntake> => {

  return apiRequest<FirstAdProductIntake>(getAdvanceFirstAdProductUrl(intakeId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdvanceFirstAdProductMutationKey = () => ['advanceFirstAdProduct'] as const;

export const getAdvanceFirstAdProductMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advanceFirstAdProduct>>, TError,AdvanceFirstAdProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof advanceFirstAdProduct>>, TError,AdvanceFirstAdProductMutationVariables, TContext> => {

const mutationKey = getAdvanceFirstAdProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof advanceFirstAdProduct>>, AdvanceFirstAdProductMutationVariables> = (props) => {
          const {intakeId} = props ?? {};

          return  advanceFirstAdProduct(intakeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdvanceFirstAdProductMutationResult = NonNullable<Awaited<ReturnType<typeof advanceFirstAdProduct>>>

    export type AdvanceFirstAdProductMutationError = ErrorType<ErrorEnvelope>
    export type AdvanceFirstAdProductMutationVariables = {intakeId: string}

    /**
 * @summary Advance First Ad Product
 */
export const useAdvanceFirstAdProduct = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advanceFirstAdProduct>>, TError,AdvanceFirstAdProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof advanceFirstAdProduct>>,
        TError,
        AdvanceFirstAdProductMutationVariables,
        TContext
      > => {
      return useMutation(getAdvanceFirstAdProductMutationOptions(options), queryClient);
    }
    export const getSaveFirstAdProductPanelUrl = (intakeId: string,) => {




  return `/api/v1/me/first-ad-product/${intakeId}/save`
}

/**
 * @summary Save First Ad Product Panel
 */
export const saveFirstAdProductPanel = async (intakeId: string,
    firstAdProductSave: FirstAdProductSave, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdProductIntake> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FirstAdProductIntake>(getSaveFirstAdProductPanelUrl(intakeId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(firstAdProductSave)
  }
);}





export const getSaveFirstAdProductPanelMutationKey = () => ['saveFirstAdProductPanel'] as const;

export const getSaveFirstAdProductPanelMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveFirstAdProductPanel>>, TError,SaveFirstAdProductPanelMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof saveFirstAdProductPanel>>, TError,SaveFirstAdProductPanelMutationVariables, TContext> => {

const mutationKey = getSaveFirstAdProductPanelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveFirstAdProductPanel>>, SaveFirstAdProductPanelMutationVariables> = (props) => {
          const {intakeId,data} = props ?? {};

          return  saveFirstAdProductPanel(intakeId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveFirstAdProductPanelMutationResult = NonNullable<Awaited<ReturnType<typeof saveFirstAdProductPanel>>>
    export type SaveFirstAdProductPanelMutationBody = FirstAdProductSave
    export type SaveFirstAdProductPanelMutationError = ErrorType<ErrorEnvelope>
    export type SaveFirstAdProductPanelMutationVariables = {intakeId: string;data: FirstAdProductSave}

    /**
 * @summary Save First Ad Product Panel
 */
export const useSaveFirstAdProductPanel = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveFirstAdProductPanel>>, TError,SaveFirstAdProductPanelMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveFirstAdProductPanel>>,
        TError,
        SaveFirstAdProductPanelMutationVariables,
        TContext
      > => {
      return useMutation(getSaveFirstAdProductPanelMutationOptions(options), queryClient);
    }
    export const getDeleteActorUrl = (teamId: string,
    actorId: string,) => {




  return `/api/v1/teams/${teamId}/actors/${actorId}`
}

/**
 * One of the team's actors, from any brand, by its maker, an admin or the owner. A
 * global actor is not found here.
 * @summary Delete Actor
 */
export const deleteActor = async (teamId: string,
    actorId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteActorUrl(teamId,actorId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteActorMutationKey = () => ['deleteActor'] as const;

export const getDeleteActorMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActor>>, TError,DeleteActorMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteActor>>, TError,DeleteActorMutationVariables, TContext> => {

const mutationKey = getDeleteActorMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteActor>>, DeleteActorMutationVariables> = (props) => {
          const {teamId,actorId} = props ?? {};

          return  deleteActor(teamId,actorId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteActorMutationResult = NonNullable<Awaited<ReturnType<typeof deleteActor>>>

    export type DeleteActorMutationError = ErrorType<ErrorEnvelope>
    export type DeleteActorMutationVariables = {teamId: string;actorId: string}

    /**
 * @summary Delete Actor
 */
export const useDeleteActor = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteActor>>, TError,DeleteActorMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteActor>>,
        TError,
        DeleteActorMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteActorMutationOptions(options), queryClient);
    }
    export const getGetTeamActorUrl = (teamId: string,
    actorId: string,) => {




  return `/api/v1/teams/${teamId}/actors/${actorId}`
}

/**
 * One of the team's actors, from any brand, with its signed portrait (a picture clip's
 * source in the editor). A global actor is not found here.
 * @summary Get Team Actor
 */
export const getTeamActor = async (teamId: string,
    actorId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AiActor> => {

  return apiRequest<AiActor>(getGetTeamActorUrl(teamId,actorId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTeamActorQueryKey = (teamId: string,
    actorId: string,) => {
    return [
    `/api/v1/teams/${teamId}/actors/${actorId}`
    ] as const;
    }


export const getGetTeamActorQueryOptions = <TData = Awaited<ReturnType<typeof getTeamActor>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    actorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamActor>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTeamActorQueryKey(teamId,actorId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeamActor>>> = ({ signal }) => getTeamActor(teamId,actorId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && actorId !== null && actorId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTeamActor>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTeamActorQueryResult = NonNullable<Awaited<ReturnType<typeof getTeamActor>>>
export type GetTeamActorQueryError = ErrorType<ErrorEnvelope>


export function useGetTeamActor<TData = Awaited<ReturnType<typeof getTeamActor>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    actorId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamActor>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamActor>>,
          TError,
          Awaited<ReturnType<typeof getTeamActor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamActor<TData = Awaited<ReturnType<typeof getTeamActor>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    actorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamActor>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeamActor>>,
          TError,
          Awaited<ReturnType<typeof getTeamActor>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTeamActor<TData = Awaited<ReturnType<typeof getTeamActor>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    actorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamActor>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Team Actor
 */

export function useGetTeamActor<TData = Awaited<ReturnType<typeof getTeamActor>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    actorId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTeamActor>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTeamActorQueryOptions(teamId,actorId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListActorsUrl = (teamId: string,
    brandId: string,
    params?: ListActorsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["gender","age","skin_tone","situation","clothing","accessories","created_by"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/actors?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/actors`
}

/**
 * Live's Global Actors, newest first, each with its portrait's and preview's signed
 * URLs and its voice; `kind=team`, My Actors: every actor of the team, from every brand.
 * Each facet may repeat: OR within one, AND across them, as live's. My Actors takes
 * `gender`, `created_by` and `product_id` (the actors saved from a generation that showed
 * it); a global actor has neither a maker nor a product.
 * @summary List Actors
 */
export const listActors = async (teamId: string,
    brandId: string,
    params?: ListActorsParams, options?: Parameters<typeof apiRequest>[1]): Promise<AiActorPage> => {

  return apiRequest<AiActorPage>(getListActorsUrl(teamId,brandId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListActorsQueryKey = (teamId: string,
    brandId: string,
    params?: ListActorsParams,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/actors`, ...(params ? [params] : [])
    ] as const;
    }


export const getListActorsQueryOptions = <TData = Awaited<ReturnType<typeof listActors>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    params?: ListActorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActors>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActorsQueryKey(teamId,brandId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActors>>> = ({ signal }) => listActors(teamId,brandId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListActorsQueryResult = NonNullable<Awaited<ReturnType<typeof listActors>>>
export type ListActorsQueryError = ErrorType<ErrorEnvelope>


export function useListActors<TData = Awaited<ReturnType<typeof listActors>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: undefined |  ListActorsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActors>>,
          TError,
          Awaited<ReturnType<typeof listActors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActors<TData = Awaited<ReturnType<typeof listActors>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListActorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listActors>>,
          TError,
          Awaited<ReturnType<typeof listActors>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListActors<TData = Awaited<ReturnType<typeof listActors>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListActorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActors>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Actors
 */

export function useListActors<TData = Awaited<ReturnType<typeof listActors>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListActorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listActors>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListActorsQueryOptions(teamId,brandId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSaveGeneratedActorsUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/actors/from-generation`
}

/**
 * Keep portraits of one of your `image.actor` generations in this brand as the team's
 * actors (live's Save, on one image or all of them), in the order asked. A portrait saved
 * before returns its actor. 404 for a generation not yours here or an image it lacks, as
 * live's; 422 for an image not delivered.
 * @summary Save Generated Actors
 */
export const saveGeneratedActors = async (teamId: string,
    brandId: string,
    aiActorFromGenerationRequest: AiActorFromGenerationRequest, options?: Parameters<typeof apiRequest>[1]): Promise<AiActorList> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AiActorList>(getSaveGeneratedActorsUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(aiActorFromGenerationRequest)
  }
);}





export const getSaveGeneratedActorsMutationKey = () => ['saveGeneratedActors'] as const;

export const getSaveGeneratedActorsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveGeneratedActors>>, TError,SaveGeneratedActorsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof saveGeneratedActors>>, TError,SaveGeneratedActorsMutationVariables, TContext> => {

const mutationKey = getSaveGeneratedActorsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveGeneratedActors>>, SaveGeneratedActorsMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  saveGeneratedActors(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveGeneratedActorsMutationResult = NonNullable<Awaited<ReturnType<typeof saveGeneratedActors>>>
    export type SaveGeneratedActorsMutationBody = AiActorFromGenerationRequest
    export type SaveGeneratedActorsMutationError = ErrorType<ErrorEnvelope>
    export type SaveGeneratedActorsMutationVariables = {teamId: string;brandId: string;data: AiActorFromGenerationRequest}

    /**
 * @summary Save Generated Actors
 */
export const useSaveGeneratedActors = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveGeneratedActors>>, TError,SaveGeneratedActorsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveGeneratedActors>>,
        TError,
        SaveGeneratedActorsMutationVariables,
        TContext
      > => {
      return useMutation(getSaveGeneratedActorsMutationOptions(options), queryClient);
    }
    export const getMoveLibraryImageToActorUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/actors/from-library`
}

/**
 * Move one of the team's library images into a team actor (live's Add From Library):
 * the actor takes the image's name and gender other, and the image goes to the library's
 * trash. 422 at `asset_id` for anything but a ready image of the team's library; 403 for
 * an image you may not delete there; 409 for a brand's logo or a product's image.
 * @summary Move Library Image To Actor
 */
export const moveLibraryImageToActor = async (teamId: string,
    brandId: string,
    aiActorFromLibraryRequest: AiActorFromLibraryRequest, options?: Parameters<typeof apiRequest>[1]): Promise<AiActor> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AiActor>(getMoveLibraryImageToActorUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(aiActorFromLibraryRequest)
  }
);}





export const getMoveLibraryImageToActorMutationKey = () => ['moveLibraryImageToActor'] as const;

export const getMoveLibraryImageToActorMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveLibraryImageToActor>>, TError,MoveLibraryImageToActorMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof moveLibraryImageToActor>>, TError,MoveLibraryImageToActorMutationVariables, TContext> => {

const mutationKey = getMoveLibraryImageToActorMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveLibraryImageToActor>>, MoveLibraryImageToActorMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  moveLibraryImageToActor(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveLibraryImageToActorMutationResult = NonNullable<Awaited<ReturnType<typeof moveLibraryImageToActor>>>
    export type MoveLibraryImageToActorMutationBody = AiActorFromLibraryRequest
    export type MoveLibraryImageToActorMutationError = ErrorType<ErrorEnvelope>
    export type MoveLibraryImageToActorMutationVariables = {teamId: string;brandId: string;data: AiActorFromLibraryRequest}

    /**
 * @summary Move Library Image To Actor
 */
export const useMoveLibraryImageToActor = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveLibraryImageToActor>>, TError,MoveLibraryImageToActorMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof moveLibraryImageToActor>>,
        TError,
        MoveLibraryImageToActorMutationVariables,
        TContext
      > => {
      return useMutation(getMoveLibraryImageToActorMutationOptions(options), queryClient);
    }
    export const getPrepareActorUploadUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/actors/uploads`
}

/**
 * A new actor's id and the form to post its portrait with: a PNG, JPEG or WebP of up
 * to 20 MB. Nothing is kept until `complete`.
 * @summary Prepare Actor Upload
 */
export const prepareActorUpload = async (teamId: string,
    brandId: string,
    aiActorUploadRequest: AiActorUploadRequest, options?: Parameters<typeof apiRequest>[1]): Promise<AiActorUploadTicket> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AiActorUploadTicket>(getPrepareActorUploadUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(aiActorUploadRequest)
  }
);}





export const getPrepareActorUploadMutationKey = () => ['prepareActorUpload'] as const;

export const getPrepareActorUploadMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareActorUpload>>, TError,PrepareActorUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof prepareActorUpload>>, TError,PrepareActorUploadMutationVariables, TContext> => {

const mutationKey = getPrepareActorUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prepareActorUpload>>, PrepareActorUploadMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  prepareActorUpload(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PrepareActorUploadMutationResult = NonNullable<Awaited<ReturnType<typeof prepareActorUpload>>>
    export type PrepareActorUploadMutationBody = AiActorUploadRequest
    export type PrepareActorUploadMutationError = ErrorType<ErrorEnvelope>
    export type PrepareActorUploadMutationVariables = {teamId: string;brandId: string;data: AiActorUploadRequest}

    /**
 * @summary Prepare Actor Upload
 */
export const usePrepareActorUpload = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareActorUpload>>, TError,PrepareActorUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prepareActorUpload>>,
        TError,
        PrepareActorUploadMutationVariables,
        TContext
      > => {
      return useMutation(getPrepareActorUploadMutationOptions(options), queryClient);
    }
    export const getCompleteActorUploadUrl = (teamId: string,
    brandId: string,
    actorId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/actors/${actorId}/complete`
}

/**
 * The posted portrait becomes the team's actor once read, with gender other and a
 * random name, as live's. 404 while no file is there (none uploaded under this id, or
 * another team's or brand's id); 422 for a file that is not an image.
 * @summary Complete Actor Upload
 */
export const completeActorUpload = async (teamId: string,
    brandId: string,
    actorId: string,
    aiActorCompleteRequest: AiActorCompleteRequest, options?: Parameters<typeof apiRequest>[1]): Promise<AiActor> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AiActor>(getCompleteActorUploadUrl(teamId,brandId,actorId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(aiActorCompleteRequest)
  }
);}





export const getCompleteActorUploadMutationKey = () => ['completeActorUpload'] as const;

export const getCompleteActorUploadMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeActorUpload>>, TError,CompleteActorUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof completeActorUpload>>, TError,CompleteActorUploadMutationVariables, TContext> => {

const mutationKey = getCompleteActorUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeActorUpload>>, CompleteActorUploadMutationVariables> = (props) => {
          const {teamId,brandId,actorId,data} = props ?? {};

          return  completeActorUpload(teamId,brandId,actorId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteActorUploadMutationResult = NonNullable<Awaited<ReturnType<typeof completeActorUpload>>>
    export type CompleteActorUploadMutationBody = AiActorCompleteRequest
    export type CompleteActorUploadMutationError = ErrorType<ErrorEnvelope>
    export type CompleteActorUploadMutationVariables = {teamId: string;brandId: string;actorId: string;data: AiActorCompleteRequest}

    /**
 * @summary Complete Actor Upload
 */
export const useCompleteActorUpload = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeActorUpload>>, TError,CompleteActorUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeActorUpload>>,
        TError,
        CompleteActorUploadMutationVariables,
        TContext
      > => {
      return useMutation(getCompleteActorUploadMutationOptions(options), queryClient);
    }
    export const getListAdCopiesUrl = (teamId: string,
    brandId: string,
    params?: ListAdCopiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/ad-copies?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/ad-copies`
}

/**
 * The brand's copies of its live products, last changed first, as live's Ad copies
 * modal lists them: for one product, and whose name or product's name holds `search`. A
 * job's draft is listed `in_progress` from its start until its output fills it.
 * @summary List Ad Copies
 */
export const listAdCopies = async (teamId: string,
    brandId: string,
    params?: ListAdCopiesParams, options?: Parameters<typeof apiRequest>[1]): Promise<AdCopyList> => {

  return apiRequest<AdCopyList>(getListAdCopiesUrl(teamId,brandId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAdCopiesQueryKey = (teamId: string,
    brandId: string,
    params?: ListAdCopiesParams,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/ad-copies`, ...(params ? [params] : [])
    ] as const;
    }


export const getListAdCopiesQueryOptions = <TData = Awaited<ReturnType<typeof listAdCopies>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    params?: ListAdCopiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdCopies>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAdCopiesQueryKey(teamId,brandId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAdCopies>>> = ({ signal }) => listAdCopies(teamId,brandId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAdCopies>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAdCopiesQueryResult = NonNullable<Awaited<ReturnType<typeof listAdCopies>>>
export type ListAdCopiesQueryError = ErrorType<ErrorEnvelope>


export function useListAdCopies<TData = Awaited<ReturnType<typeof listAdCopies>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: undefined |  ListAdCopiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdCopies>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdCopies>>,
          TError,
          Awaited<ReturnType<typeof listAdCopies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdCopies<TData = Awaited<ReturnType<typeof listAdCopies>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListAdCopiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdCopies>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdCopies>>,
          TError,
          Awaited<ReturnType<typeof listAdCopies>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAdCopies<TData = Awaited<ReturnType<typeof listAdCopies>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListAdCopiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdCopies>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Ad Copies
 */

export function useListAdCopies<TData = Awaited<ReturnType<typeof listAdCopies>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListAdCopiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAdCopies>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAdCopiesQueryOptions(teamId,brandId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreateAdCopyUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/ad-copies`
}

/**
 * Live's Write tab: a copy of one of the brand's products, written by hand. 422 for
 * another brand's product or a deleted one ("Product not found").
 * @summary Create Ad Copy
 */
export const createAdCopy = async (teamId: string,
    brandId: string,
    adCopyCreate: AdCopyCreate, options?: Parameters<typeof apiRequest>[1]): Promise<AdCopy> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AdCopy>(getCreateAdCopyUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adCopyCreate)
  }
);}





export const getCreateAdCopyMutationKey = () => ['createAdCopy'] as const;

export const getCreateAdCopyMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdCopy>>, TError,CreateAdCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof createAdCopy>>, TError,CreateAdCopyMutationVariables, TContext> => {

const mutationKey = getCreateAdCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAdCopy>>, CreateAdCopyMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  createAdCopy(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAdCopyMutationResult = NonNullable<Awaited<ReturnType<typeof createAdCopy>>>
    export type CreateAdCopyMutationBody = AdCopyCreate
    export type CreateAdCopyMutationError = ErrorType<ErrorEnvelope>
    export type CreateAdCopyMutationVariables = {teamId: string;brandId: string;data: AdCopyCreate}

    /**
 * @summary Create Ad Copy
 */
export const useCreateAdCopy = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAdCopy>>, TError,CreateAdCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createAdCopy>>,
        TError,
        CreateAdCopyMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAdCopyMutationOptions(options), queryClient);
    }
    export const getDeleteAdCopyUrl = (teamId: string,
    brandId: string,
    copyId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/ad-copies/${copyId}`
}

/**
 * By its creator, an admin or the owner.
 * @summary Delete Ad Copy
 */
export const deleteAdCopy = async (teamId: string,
    brandId: string,
    copyId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteAdCopyUrl(teamId,brandId,copyId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAdCopyMutationKey = () => ['deleteAdCopy'] as const;

export const getDeleteAdCopyMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdCopy>>, TError,DeleteAdCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAdCopy>>, TError,DeleteAdCopyMutationVariables, TContext> => {

const mutationKey = getDeleteAdCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAdCopy>>, DeleteAdCopyMutationVariables> = (props) => {
          const {teamId,brandId,copyId} = props ?? {};

          return  deleteAdCopy(teamId,brandId,copyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAdCopyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAdCopy>>>

    export type DeleteAdCopyMutationError = ErrorType<ErrorEnvelope>
    export type DeleteAdCopyMutationVariables = {teamId: string;brandId: string;copyId: string}

    /**
 * @summary Delete Ad Copy
 */
export const useDeleteAdCopy = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAdCopy>>, TError,DeleteAdCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteAdCopy>>,
        TError,
        DeleteAdCopyMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAdCopyMutationOptions(options), queryClient);
    }
    export const getUpdateAdCopyUrl = (teamId: string,
    brandId: string,
    copyId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/ad-copies/${copyId}`
}

/**
 * A new name, and each text sent in place of its values (null clears one); the texts
 * left out stay. By its creator, an admin or the owner.
 * @summary Update Ad Copy
 */
export const updateAdCopy = async (teamId: string,
    brandId: string,
    copyId: string,
    adCopyUpdate: AdCopyUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<AdCopy> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AdCopy>(getUpdateAdCopyUrl(teamId,brandId,copyId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adCopyUpdate)
  }
);}





export const getUpdateAdCopyMutationKey = () => ['updateAdCopy'] as const;

export const getUpdateAdCopyMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdCopy>>, TError,UpdateAdCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAdCopy>>, TError,UpdateAdCopyMutationVariables, TContext> => {

const mutationKey = getUpdateAdCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAdCopy>>, UpdateAdCopyMutationVariables> = (props) => {
          const {teamId,brandId,copyId,data} = props ?? {};

          return  updateAdCopy(teamId,brandId,copyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAdCopyMutationResult = NonNullable<Awaited<ReturnType<typeof updateAdCopy>>>
    export type UpdateAdCopyMutationBody = AdCopyUpdate
    export type UpdateAdCopyMutationError = ErrorType<ErrorEnvelope>
    export type UpdateAdCopyMutationVariables = {teamId: string;brandId: string;copyId: string;data: AdCopyUpdate}

    /**
 * @summary Update Ad Copy
 */
export const useUpdateAdCopy = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAdCopy>>, TError,UpdateAdCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAdCopy>>,
        TError,
        UpdateAdCopyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAdCopyMutationOptions(options), queryClient);
    }
    export const getDuplicateAdCopyUrl = (teamId: string,
    brandId: string,
    copyId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/ad-copies/${copyId}/duplicate`
}

/**
 * The same texts under live's next name: "Name (copy)", then "Name (copy 2)".
 * @summary Duplicate Ad Copy
 */
export const duplicateAdCopy = async (teamId: string,
    brandId: string,
    copyId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AdCopy> => {

  return apiRequest<AdCopy>(getDuplicateAdCopyUrl(teamId,brandId,copyId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getDuplicateAdCopyMutationKey = () => ['duplicateAdCopy'] as const;

export const getDuplicateAdCopyMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateAdCopy>>, TError,DuplicateAdCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateAdCopy>>, TError,DuplicateAdCopyMutationVariables, TContext> => {

const mutationKey = getDuplicateAdCopyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateAdCopy>>, DuplicateAdCopyMutationVariables> = (props) => {
          const {teamId,brandId,copyId} = props ?? {};

          return  duplicateAdCopy(teamId,brandId,copyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateAdCopyMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateAdCopy>>>

    export type DuplicateAdCopyMutationError = ErrorType<ErrorEnvelope>
    export type DuplicateAdCopyMutationVariables = {teamId: string;brandId: string;copyId: string}

    /**
 * @summary Duplicate Ad Copy
 */
export const useDuplicateAdCopy = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateAdCopy>>, TError,DuplicateAdCopyMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof duplicateAdCopy>>,
        TError,
        DuplicateAdCopyMutationVariables,
        TContext
      > => {
      return useMutation(getDuplicateAdCopyMutationOptions(options), queryClient);
    }
    export const getGetAssetAdStructureUrl = (teamId: string,
    brandId: string,
    sourceAssetId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/ad-structures/assets/${sourceAssetId}`
}

/**
 * A library image's latest analysis: `in_progress`, `failed`, or `completed` with what it
 * read. 404 while it has none.
 * @summary Get Asset Ad Structure
 */
export const getAssetAdStructure = async (teamId: string,
    brandId: string,
    sourceAssetId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AdStructure> => {

  return apiRequest<AdStructure>(getGetAssetAdStructureUrl(teamId,brandId,sourceAssetId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAssetAdStructureQueryKey = (teamId: string,
    brandId: string,
    sourceAssetId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/ad-structures/assets/${sourceAssetId}`
    ] as const;
    }


export const getGetAssetAdStructureQueryOptions = <TData = Awaited<ReturnType<typeof getAssetAdStructure>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    sourceAssetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAdStructure>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAssetAdStructureQueryKey(teamId,brandId,sourceAssetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssetAdStructure>>> = ({ signal }) => getAssetAdStructure(teamId,brandId,sourceAssetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && sourceAssetId !== null && sourceAssetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAssetAdStructure>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAssetAdStructureQueryResult = NonNullable<Awaited<ReturnType<typeof getAssetAdStructure>>>
export type GetAssetAdStructureQueryError = ErrorType<ErrorEnvelope>


export function useGetAssetAdStructure<TData = Awaited<ReturnType<typeof getAssetAdStructure>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    sourceAssetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAdStructure>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetAdStructure>>,
          TError,
          Awaited<ReturnType<typeof getAssetAdStructure>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetAdStructure<TData = Awaited<ReturnType<typeof getAssetAdStructure>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    sourceAssetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAdStructure>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssetAdStructure>>,
          TError,
          Awaited<ReturnType<typeof getAssetAdStructure>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAssetAdStructure<TData = Awaited<ReturnType<typeof getAssetAdStructure>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    sourceAssetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAdStructure>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Asset Ad Structure
 */

export function useGetAssetAdStructure<TData = Awaited<ReturnType<typeof getAssetAdStructure>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    sourceAssetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAssetAdStructure>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAssetAdStructureQueryOptions(teamId,brandId,sourceAssetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateAssetAdStructureUrl = (teamId: string,
    brandId: string,
    sourceAssetId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/ad-structures/assets/${sourceAssetId}`
}

/**
 * Live's edit of a completed structure: the texts and the visual pairs sent replace
 * theirs, the categories sent replace the list. 404 while there is none to edit.
 * @summary Update Asset Ad Structure
 */
export const updateAssetAdStructure = async (teamId: string,
    brandId: string,
    sourceAssetId: string,
    adStructureUpdate: AdStructureUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<AdStructure> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AdStructure>(getUpdateAssetAdStructureUrl(teamId,brandId,sourceAssetId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adStructureUpdate)
  }
);}





export const getUpdateAssetAdStructureMutationKey = () => ['updateAssetAdStructure'] as const;

export const getUpdateAssetAdStructureMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssetAdStructure>>, TError,UpdateAssetAdStructureMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAssetAdStructure>>, TError,UpdateAssetAdStructureMutationVariables, TContext> => {

const mutationKey = getUpdateAssetAdStructureMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAssetAdStructure>>, UpdateAssetAdStructureMutationVariables> = (props) => {
          const {teamId,brandId,sourceAssetId,data} = props ?? {};

          return  updateAssetAdStructure(teamId,brandId,sourceAssetId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssetAdStructureMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssetAdStructure>>>
    export type UpdateAssetAdStructureMutationBody = AdStructureUpdate
    export type UpdateAssetAdStructureMutationError = ErrorType<ErrorEnvelope>
    export type UpdateAssetAdStructureMutationVariables = {teamId: string;brandId: string;sourceAssetId: string;data: AdStructureUpdate}

    /**
 * @summary Update Asset Ad Structure
 */
export const useUpdateAssetAdStructure = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssetAdStructure>>, TError,UpdateAssetAdStructureMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAssetAdStructure>>,
        TError,
        UpdateAssetAdStructureMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAssetAdStructureMutationOptions(options), queryClient);
    }
    export const getGetOutputAdStructureUrl = (teamId: string,
    brandId: string,
    sourceJobId: string,
    outputIndex: number,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/ad-structures/jobs/${sourceJobId}/outputs/${outputIndex}`
}

/**
 * A job output's latest analysis, as a library image's.
 * @summary Get Output Ad Structure
 */
export const getOutputAdStructure = async (teamId: string,
    brandId: string,
    sourceJobId: string,
    outputIndex: number, options?: Parameters<typeof apiRequest>[1]): Promise<AdStructure> => {

  return apiRequest<AdStructure>(getGetOutputAdStructureUrl(teamId,brandId,sourceJobId,outputIndex),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetOutputAdStructureQueryKey = (teamId: string,
    brandId: string,
    sourceJobId: string,
    outputIndex: number,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/ad-structures/jobs/${sourceJobId}/outputs/${outputIndex}`
    ] as const;
    }


export const getGetOutputAdStructureQueryOptions = <TData = Awaited<ReturnType<typeof getOutputAdStructure>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    sourceJobId: string,
    outputIndex: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutputAdStructure>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOutputAdStructureQueryKey(teamId,brandId,sourceJobId,outputIndex);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOutputAdStructure>>> = ({ signal }) => getOutputAdStructure(teamId,brandId,sourceJobId,outputIndex, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && sourceJobId !== null && sourceJobId !== undefined && outputIndex !== null && outputIndex !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOutputAdStructure>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOutputAdStructureQueryResult = NonNullable<Awaited<ReturnType<typeof getOutputAdStructure>>>
export type GetOutputAdStructureQueryError = ErrorType<ErrorEnvelope>


export function useGetOutputAdStructure<TData = Awaited<ReturnType<typeof getOutputAdStructure>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    sourceJobId: string,
    outputIndex: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutputAdStructure>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutputAdStructure>>,
          TError,
          Awaited<ReturnType<typeof getOutputAdStructure>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutputAdStructure<TData = Awaited<ReturnType<typeof getOutputAdStructure>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    sourceJobId: string,
    outputIndex: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutputAdStructure>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOutputAdStructure>>,
          TError,
          Awaited<ReturnType<typeof getOutputAdStructure>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOutputAdStructure<TData = Awaited<ReturnType<typeof getOutputAdStructure>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    sourceJobId: string,
    outputIndex: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutputAdStructure>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Output Ad Structure
 */

export function useGetOutputAdStructure<TData = Awaited<ReturnType<typeof getOutputAdStructure>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    sourceJobId: string,
    outputIndex: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOutputAdStructure>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOutputAdStructureQueryOptions(teamId,brandId,sourceJobId,outputIndex,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdateOutputAdStructureUrl = (teamId: string,
    brandId: string,
    sourceJobId: string,
    outputIndex: number,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/ad-structures/jobs/${sourceJobId}/outputs/${outputIndex}`
}

/**
 * Live's edit of a job output's completed structure, as a library image's.
 * @summary Update Output Ad Structure
 */
export const updateOutputAdStructure = async (teamId: string,
    brandId: string,
    sourceJobId: string,
    outputIndex: number,
    adStructureUpdate: AdStructureUpdate, options?: Parameters<typeof apiRequest>[1]): Promise<AdStructure> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AdStructure>(getUpdateOutputAdStructureUrl(teamId,brandId,sourceJobId,outputIndex),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adStructureUpdate)
  }
);}





export const getUpdateOutputAdStructureMutationKey = () => ['updateOutputAdStructure'] as const;

export const getUpdateOutputAdStructureMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOutputAdStructure>>, TError,UpdateOutputAdStructureMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof updateOutputAdStructure>>, TError,UpdateOutputAdStructureMutationVariables, TContext> => {

const mutationKey = getUpdateOutputAdStructureMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateOutputAdStructure>>, UpdateOutputAdStructureMutationVariables> = (props) => {
          const {teamId,brandId,sourceJobId,outputIndex,data} = props ?? {};

          return  updateOutputAdStructure(teamId,brandId,sourceJobId,outputIndex,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateOutputAdStructureMutationResult = NonNullable<Awaited<ReturnType<typeof updateOutputAdStructure>>>
    export type UpdateOutputAdStructureMutationBody = AdStructureUpdate
    export type UpdateOutputAdStructureMutationError = ErrorType<ErrorEnvelope>
    export type UpdateOutputAdStructureMutationVariables = {teamId: string;brandId: string;sourceJobId: string;outputIndex: number;data: AdStructureUpdate}

    /**
 * @summary Update Output Ad Structure
 */
export const useUpdateOutputAdStructure = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateOutputAdStructure>>, TError,UpdateOutputAdStructureMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateOutputAdStructure>>,
        TError,
        UpdateOutputAdStructureMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateOutputAdStructureMutationOptions(options), queryClient);
    }
    export const getRunBrandFirstAdProductUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad-product`
}

/**
 * @summary Run Brand First Ad Product
 */
export const runBrandFirstAdProduct = async (teamId: string,
    brandId: string,
    firstAdProductRequest: FirstAdProductRequest, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdProductIntake> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FirstAdProductIntake>(getRunBrandFirstAdProductUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(firstAdProductRequest)
  }
);}





export const getRunBrandFirstAdProductMutationKey = () => ['runBrandFirstAdProduct'] as const;

export const getRunBrandFirstAdProductMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runBrandFirstAdProduct>>, TError,RunBrandFirstAdProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof runBrandFirstAdProduct>>, TError,RunBrandFirstAdProductMutationVariables, TContext> => {

const mutationKey = getRunBrandFirstAdProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runBrandFirstAdProduct>>, RunBrandFirstAdProductMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  runBrandFirstAdProduct(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunBrandFirstAdProductMutationResult = NonNullable<Awaited<ReturnType<typeof runBrandFirstAdProduct>>>
    export type RunBrandFirstAdProductMutationBody = FirstAdProductRequest
    export type RunBrandFirstAdProductMutationError = ErrorType<ErrorEnvelope>
    export type RunBrandFirstAdProductMutationVariables = {teamId: string;brandId: string;data: FirstAdProductRequest}

    /**
 * @summary Run Brand First Ad Product
 */
export const useRunBrandFirstAdProduct = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runBrandFirstAdProduct>>, TError,RunBrandFirstAdProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runBrandFirstAdProduct>>,
        TError,
        RunBrandFirstAdProductMutationVariables,
        TContext
      > => {
      return useMutation(getRunBrandFirstAdProductMutationOptions(options), queryClient);
    }
    export const getGetFirstAdDeliveryUrl = (teamId: string,
    brandId: string,
    runId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad-runs/${runId}/delivery`
}

/**
 * @summary Get First Ad Delivery
 */
export const getFirstAdDelivery = async (teamId: string,
    brandId: string,
    runId: string, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdDeliveryView> => {

  return apiRequest<FirstAdDeliveryView>(getGetFirstAdDeliveryUrl(teamId,brandId,runId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFirstAdDeliveryQueryKey = (teamId: string,
    brandId: string,
    runId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/first-ad-runs/${runId}/delivery`
    ] as const;
    }


export const getGetFirstAdDeliveryQueryOptions = <TData = Awaited<ReturnType<typeof getFirstAdDelivery>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdDelivery>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFirstAdDeliveryQueryKey(teamId,brandId,runId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFirstAdDelivery>>> = ({ signal }) => getFirstAdDelivery(teamId,brandId,runId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && runId !== null && runId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFirstAdDelivery>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFirstAdDeliveryQueryResult = NonNullable<Awaited<ReturnType<typeof getFirstAdDelivery>>>
export type GetFirstAdDeliveryQueryError = ErrorType<ErrorEnvelope>


export function useGetFirstAdDelivery<TData = Awaited<ReturnType<typeof getFirstAdDelivery>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    runId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdDelivery>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirstAdDelivery>>,
          TError,
          Awaited<ReturnType<typeof getFirstAdDelivery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFirstAdDelivery<TData = Awaited<ReturnType<typeof getFirstAdDelivery>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdDelivery>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirstAdDelivery>>,
          TError,
          Awaited<ReturnType<typeof getFirstAdDelivery>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFirstAdDelivery<TData = Awaited<ReturnType<typeof getFirstAdDelivery>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdDelivery>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get First Ad Delivery
 */

export function useGetFirstAdDelivery<TData = Awaited<ReturnType<typeof getFirstAdDelivery>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    runId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdDelivery>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFirstAdDeliveryQueryOptions(teamId,brandId,runId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetFirstAdStateUrl = (teamId: string,
    brandId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad/${templateId}`
}

/**
 * @summary Get First Ad State
 */
export const getFirstAdState = async (teamId: string,
    brandId: string,
    templateId: string, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdState> => {

  return apiRequest<FirstAdState>(getGetFirstAdStateUrl(teamId,brandId,templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFirstAdStateQueryKey = (teamId: string,
    brandId: string,
    templateId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/first-ad/${templateId}`
    ] as const;
    }


export const getGetFirstAdStateQueryOptions = <TData = Awaited<ReturnType<typeof getFirstAdState>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdState>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFirstAdStateQueryKey(teamId,brandId,templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFirstAdState>>> = ({ signal }) => getFirstAdState(teamId,brandId,templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFirstAdState>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFirstAdStateQueryResult = NonNullable<Awaited<ReturnType<typeof getFirstAdState>>>
export type GetFirstAdStateQueryError = ErrorType<ErrorEnvelope>


export function useGetFirstAdState<TData = Awaited<ReturnType<typeof getFirstAdState>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    templateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdState>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirstAdState>>,
          TError,
          Awaited<ReturnType<typeof getFirstAdState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFirstAdState<TData = Awaited<ReturnType<typeof getFirstAdState>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdState>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirstAdState>>,
          TError,
          Awaited<ReturnType<typeof getFirstAdState>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFirstAdState<TData = Awaited<ReturnType<typeof getFirstAdState>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdState>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get First Ad State
 */

export function useGetFirstAdState<TData = Awaited<ReturnType<typeof getFirstAdState>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFirstAdState>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFirstAdStateQueryOptions(teamId,brandId,templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAdvanceFirstAdCastUrl = (teamId: string,
    brandId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad/${templateId}/advance`
}

/**
 * @summary Advance First Ad Cast
 */
export const advanceFirstAdCast = async (teamId: string,
    brandId: string,
    templateId: string, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdState> => {

  return apiRequest<FirstAdState>(getAdvanceFirstAdCastUrl(teamId,brandId,templateId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAdvanceFirstAdCastMutationKey = () => ['advanceFirstAdCast'] as const;

export const getAdvanceFirstAdCastMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advanceFirstAdCast>>, TError,AdvanceFirstAdCastMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof advanceFirstAdCast>>, TError,AdvanceFirstAdCastMutationVariables, TContext> => {

const mutationKey = getAdvanceFirstAdCastMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof advanceFirstAdCast>>, AdvanceFirstAdCastMutationVariables> = (props) => {
          const {teamId,brandId,templateId} = props ?? {};

          return  advanceFirstAdCast(teamId,brandId,templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AdvanceFirstAdCastMutationResult = NonNullable<Awaited<ReturnType<typeof advanceFirstAdCast>>>

    export type AdvanceFirstAdCastMutationError = ErrorType<ErrorEnvelope>
    export type AdvanceFirstAdCastMutationVariables = {teamId: string;brandId: string;templateId: string}

    /**
 * @summary Advance First Ad Cast
 */
export const useAdvanceFirstAdCast = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof advanceFirstAdCast>>, TError,AdvanceFirstAdCastMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof advanceFirstAdCast>>,
        TError,
        AdvanceFirstAdCastMutationVariables,
        TContext
      > => {
      return useMutation(getAdvanceFirstAdCastMutationOptions(options), queryClient);
    }
    export const getApproveFirstAdScriptUrl = (teamId: string,
    brandId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad/${templateId}/approve`
}

/**
 * @summary Approve First Ad Script
 */
export const approveFirstAdScript = async (teamId: string,
    brandId: string,
    templateId: string,
    firstAdApprove: FirstAdApprove, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdState> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FirstAdState>(getApproveFirstAdScriptUrl(teamId,brandId,templateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(firstAdApprove)
  }
);}





export const getApproveFirstAdScriptMutationKey = () => ['approveFirstAdScript'] as const;

export const getApproveFirstAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveFirstAdScript>>, TError,ApproveFirstAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveFirstAdScript>>, TError,ApproveFirstAdScriptMutationVariables, TContext> => {

const mutationKey = getApproveFirstAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveFirstAdScript>>, ApproveFirstAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,templateId,data} = props ?? {};

          return  approveFirstAdScript(teamId,brandId,templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveFirstAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveFirstAdScript>>>
    export type ApproveFirstAdScriptMutationBody = FirstAdApprove
    export type ApproveFirstAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveFirstAdScriptMutationVariables = {teamId: string;brandId: string;templateId: string;data: FirstAdApprove}

    /**
 * @summary Approve First Ad Script
 */
export const useApproveFirstAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveFirstAdScript>>, TError,ApproveFirstAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveFirstAdScript>>,
        TError,
        ApproveFirstAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveFirstAdScriptMutationOptions(options), queryClient);
    }
    export const getRedeemFirstAdOfferUrl = (teamId: string,
    brandId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad/${templateId}/offer`
}

/**
 * @summary Redeem First Ad Offer
 */
export const redeemFirstAdOffer = async (teamId: string,
    brandId: string,
    templateId: string,
    firstAdOfferRequest: FirstAdOfferRequest, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdState> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FirstAdState>(getRedeemFirstAdOfferUrl(teamId,brandId,templateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(firstAdOfferRequest)
  }
);}





export const getRedeemFirstAdOfferMutationKey = () => ['redeemFirstAdOffer'] as const;

export const getRedeemFirstAdOfferMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemFirstAdOffer>>, TError,RedeemFirstAdOfferMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof redeemFirstAdOffer>>, TError,RedeemFirstAdOfferMutationVariables, TContext> => {

const mutationKey = getRedeemFirstAdOfferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof redeemFirstAdOffer>>, RedeemFirstAdOfferMutationVariables> = (props) => {
          const {teamId,brandId,templateId,data} = props ?? {};

          return  redeemFirstAdOffer(teamId,brandId,templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RedeemFirstAdOfferMutationResult = NonNullable<Awaited<ReturnType<typeof redeemFirstAdOffer>>>
    export type RedeemFirstAdOfferMutationBody = FirstAdOfferRequest
    export type RedeemFirstAdOfferMutationError = ErrorType<ErrorEnvelope>
    export type RedeemFirstAdOfferMutationVariables = {teamId: string;brandId: string;templateId: string;data: FirstAdOfferRequest}

    /**
 * @summary Redeem First Ad Offer
 */
export const useRedeemFirstAdOffer = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof redeemFirstAdOffer>>, TError,RedeemFirstAdOfferMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof redeemFirstAdOffer>>,
        TError,
        RedeemFirstAdOfferMutationVariables,
        TContext
      > => {
      return useMutation(getRedeemFirstAdOfferMutationOptions(options), queryClient);
    }
    export const getSaveFirstAdPickUrl = (teamId: string,
    brandId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad/${templateId}/picks`
}

/**
 * @summary Save First Ad Pick
 */
export const saveFirstAdPick = async (teamId: string,
    brandId: string,
    templateId: string,
    firstAdPick: FirstAdPick, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdState> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FirstAdState>(getSaveFirstAdPickUrl(teamId,brandId,templateId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(firstAdPick)
  }
);}





export const getSaveFirstAdPickMutationKey = () => ['saveFirstAdPick'] as const;

export const getSaveFirstAdPickMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveFirstAdPick>>, TError,SaveFirstAdPickMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof saveFirstAdPick>>, TError,SaveFirstAdPickMutationVariables, TContext> => {

const mutationKey = getSaveFirstAdPickMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveFirstAdPick>>, SaveFirstAdPickMutationVariables> = (props) => {
          const {teamId,brandId,templateId,data} = props ?? {};

          return  saveFirstAdPick(teamId,brandId,templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveFirstAdPickMutationResult = NonNullable<Awaited<ReturnType<typeof saveFirstAdPick>>>
    export type SaveFirstAdPickMutationBody = FirstAdPick
    export type SaveFirstAdPickMutationError = ErrorType<ErrorEnvelope>
    export type SaveFirstAdPickMutationVariables = {teamId: string;brandId: string;templateId: string;data: FirstAdPick}

    /**
 * @summary Save First Ad Pick
 */
export const useSaveFirstAdPick = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveFirstAdPick>>, TError,SaveFirstAdPickMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveFirstAdPick>>,
        TError,
        SaveFirstAdPickMutationVariables,
        TContext
      > => {
      return useMutation(getSaveFirstAdPickMutationOptions(options), queryClient);
    }
    export const getAcknowledgeFirstAdPreviewUrl = (teamId: string,
    brandId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad/${templateId}/preview-seen`
}

/**
 * @summary Acknowledge First Ad Preview
 */
export const acknowledgeFirstAdPreview = async (teamId: string,
    brandId: string,
    templateId: string,
    firstAdPreviewSeen: FirstAdPreviewSeen, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdState> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FirstAdState>(getAcknowledgeFirstAdPreviewUrl(teamId,brandId,templateId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(firstAdPreviewSeen)
  }
);}





export const getAcknowledgeFirstAdPreviewMutationKey = () => ['acknowledgeFirstAdPreview'] as const;

export const getAcknowledgeFirstAdPreviewMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgeFirstAdPreview>>, TError,AcknowledgeFirstAdPreviewMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof acknowledgeFirstAdPreview>>, TError,AcknowledgeFirstAdPreviewMutationVariables, TContext> => {

const mutationKey = getAcknowledgeFirstAdPreviewMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acknowledgeFirstAdPreview>>, AcknowledgeFirstAdPreviewMutationVariables> = (props) => {
          const {teamId,brandId,templateId,data} = props ?? {};

          return  acknowledgeFirstAdPreview(teamId,brandId,templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcknowledgeFirstAdPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof acknowledgeFirstAdPreview>>>
    export type AcknowledgeFirstAdPreviewMutationBody = FirstAdPreviewSeen
    export type AcknowledgeFirstAdPreviewMutationError = ErrorType<ErrorEnvelope>
    export type AcknowledgeFirstAdPreviewMutationVariables = {teamId: string;brandId: string;templateId: string;data: FirstAdPreviewSeen}

    /**
 * @summary Acknowledge First Ad Preview
 */
export const useAcknowledgeFirstAdPreview = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acknowledgeFirstAdPreview>>, TError,AcknowledgeFirstAdPreviewMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acknowledgeFirstAdPreview>>,
        TError,
        AcknowledgeFirstAdPreviewMutationVariables,
        TContext
      > => {
      return useMutation(getAcknowledgeFirstAdPreviewMutationOptions(options), queryClient);
    }
    export const getRetryFirstAdOfferUrl = (teamId: string,
    brandId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad/${templateId}/retry`
}

/**
 * @summary Retry First Ad Offer
 */
export const retryFirstAdOffer = async (teamId: string,
    brandId: string,
    templateId: string,
    firstAdRetryRequest: FirstAdRetryRequest, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdState> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FirstAdState>(getRetryFirstAdOfferUrl(teamId,brandId,templateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(firstAdRetryRequest)
  }
);}





export const getRetryFirstAdOfferMutationKey = () => ['retryFirstAdOffer'] as const;

export const getRetryFirstAdOfferMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryFirstAdOffer>>, TError,RetryFirstAdOfferMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof retryFirstAdOffer>>, TError,RetryFirstAdOfferMutationVariables, TContext> => {

const mutationKey = getRetryFirstAdOfferMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryFirstAdOffer>>, RetryFirstAdOfferMutationVariables> = (props) => {
          const {teamId,brandId,templateId,data} = props ?? {};

          return  retryFirstAdOffer(teamId,brandId,templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryFirstAdOfferMutationResult = NonNullable<Awaited<ReturnType<typeof retryFirstAdOffer>>>
    export type RetryFirstAdOfferMutationBody = FirstAdRetryRequest
    export type RetryFirstAdOfferMutationError = ErrorType<ErrorEnvelope>
    export type RetryFirstAdOfferMutationVariables = {teamId: string;brandId: string;templateId: string;data: FirstAdRetryRequest}

    /**
 * @summary Retry First Ad Offer
 */
export const useRetryFirstAdOffer = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryFirstAdOffer>>, TError,RetryFirstAdOfferMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryFirstAdOffer>>,
        TError,
        RetryFirstAdOfferMutationVariables,
        TContext
      > => {
      return useMutation(getRetryFirstAdOfferMutationOptions(options), queryClient);
    }
    export const getAskFirstAdScriptUrl = (teamId: string,
    brandId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad/${templateId}/script`
}

/**
 * @summary Ask First Ad Script
 */
export const askFirstAdScript = async (teamId: string,
    brandId: string,
    templateId: string,
    firstAdPick: FirstAdPick, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdState> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FirstAdState>(getAskFirstAdScriptUrl(teamId,brandId,templateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(firstAdPick)
  }
);}





export const getAskFirstAdScriptMutationKey = () => ['askFirstAdScript'] as const;

export const getAskFirstAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof askFirstAdScript>>, TError,AskFirstAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof askFirstAdScript>>, TError,AskFirstAdScriptMutationVariables, TContext> => {

const mutationKey = getAskFirstAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof askFirstAdScript>>, AskFirstAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,templateId,data} = props ?? {};

          return  askFirstAdScript(teamId,brandId,templateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AskFirstAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof askFirstAdScript>>>
    export type AskFirstAdScriptMutationBody = FirstAdPick
    export type AskFirstAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type AskFirstAdScriptMutationVariables = {teamId: string;brandId: string;templateId: string;data: FirstAdPick}

    /**
 * @summary Ask First Ad Script
 */
export const useAskFirstAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof askFirstAdScript>>, TError,AskFirstAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof askFirstAdScript>>,
        TError,
        AskFirstAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getAskFirstAdScriptMutationOptions(options), queryClient);
    }
    export const getStartFirstAdVideoUrl = (teamId: string,
    brandId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/first-ad/${templateId}/video`
}

/**
 * @summary Start First Ad Video
 */
export const startFirstAdVideo = async (teamId: string,
    brandId: string,
    templateId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Job> => {

  return apiRequest<Job>(getStartFirstAdVideoUrl(teamId,brandId,templateId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getStartFirstAdVideoMutationKey = () => ['startFirstAdVideo'] as const;

export const getStartFirstAdVideoMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startFirstAdVideo>>, TError,StartFirstAdVideoMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof startFirstAdVideo>>, TError,StartFirstAdVideoMutationVariables, TContext> => {

const mutationKey = getStartFirstAdVideoMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startFirstAdVideo>>, StartFirstAdVideoMutationVariables> = (props) => {
          const {teamId,brandId,templateId} = props ?? {};

          return  startFirstAdVideo(teamId,brandId,templateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartFirstAdVideoMutationResult = NonNullable<Awaited<ReturnType<typeof startFirstAdVideo>>>

    export type StartFirstAdVideoMutationError = ErrorType<ErrorEnvelope>
    export type StartFirstAdVideoMutationVariables = {teamId: string;brandId: string;templateId: string}

    /**
 * @summary Start First Ad Video
 */
export const useStartFirstAdVideo = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startFirstAdVideo>>, TError,StartFirstAdVideoMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startFirstAdVideo>>,
        TError,
        StartFirstAdVideoMutationVariables,
        TContext
      > => {
      return useMutation(getStartFirstAdVideoMutationOptions(options), queryClient);
    }
    export const getGetImportedGenerationUrl = (teamId: string,
    brandId: string,
    assetId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/imported-generations/${assetId}`
}

/**
 * A file of this brand that live's generation made: its prompt, aspect ratio, live's
 * kind of generation and an Advanced image's specification. 404 for any other file.
 * @summary Get Imported Generation
 */
export const getImportedGeneration = async (teamId: string,
    brandId: string,
    assetId: string, options?: Parameters<typeof apiRequest>[1]): Promise<ImportedGeneration> => {

  return apiRequest<ImportedGeneration>(getGetImportedGenerationUrl(teamId,brandId,assetId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetImportedGenerationQueryKey = (teamId: string,
    brandId: string,
    assetId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/imported-generations/${assetId}`
    ] as const;
    }


export const getGetImportedGenerationQueryOptions = <TData = Awaited<ReturnType<typeof getImportedGeneration>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportedGeneration>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetImportedGenerationQueryKey(teamId,brandId,assetId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getImportedGeneration>>> = ({ signal }) => getImportedGeneration(teamId,brandId,assetId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined && assetId !== null && assetId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getImportedGeneration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetImportedGenerationQueryResult = NonNullable<Awaited<ReturnType<typeof getImportedGeneration>>>
export type GetImportedGenerationQueryError = ErrorType<ErrorEnvelope>


export function useGetImportedGeneration<TData = Awaited<ReturnType<typeof getImportedGeneration>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    assetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportedGeneration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImportedGeneration>>,
          TError,
          Awaited<ReturnType<typeof getImportedGeneration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImportedGeneration<TData = Awaited<ReturnType<typeof getImportedGeneration>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportedGeneration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getImportedGeneration>>,
          TError,
          Awaited<ReturnType<typeof getImportedGeneration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetImportedGeneration<TData = Awaited<ReturnType<typeof getImportedGeneration>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportedGeneration>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Imported Generation
 */

export function useGetImportedGeneration<TData = Awaited<ReturnType<typeof getImportedGeneration>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    assetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getImportedGeneration>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetImportedGenerationQueryOptions(teamId,brandId,assetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getStartJobUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/jobs`
}

/**
 * Quote the job, hold its credits and queue it. 402 when the team's credits do not
 * cover it, 429 at a cap, 409 when it costs more than `expected_quote_max`.
 * @summary Start Job
 */
export const startJob = async (teamId: string,
    brandId: string,
    jobRequest: JobRequest,
    headers: StartJobHeaders, options?: Parameters<typeof apiRequest>[1]): Promise<Job> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Job>(getStartJobUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(jobRequest)
  }
);}





export const getStartJobMutationKey = () => ['startJob'] as const;

export const getStartJobMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startJob>>, TError,StartJobMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof startJob>>, TError,StartJobMutationVariables, TContext> => {

const mutationKey = getStartJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startJob>>, StartJobMutationVariables> = (props) => {
          const {teamId,brandId,data,headers} = props ?? {};

          return  startJob(teamId,brandId,data,headers,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartJobMutationResult = NonNullable<Awaited<ReturnType<typeof startJob>>>
    export type StartJobMutationBody = JobRequest
    export type StartJobMutationError = ErrorType<ErrorEnvelope>
    export type StartJobMutationVariables = {teamId: string;brandId: string;data: JobRequest;headers: StartJobHeaders}

    /**
 * @summary Start Job
 */
export const useStartJob = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startJob>>, TError,StartJobMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof startJob>>,
        TError,
        StartJobMutationVariables,
        TContext
      > => {
      return useMutation(getStartJobMutationOptions(options), queryClient);
    }
    export const getQuoteJobUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/jobs/quote`
}

/**
 * What the same request would cost now, before its prompt is written too, as the price
 * never reads it. Holds nothing.
 * @summary Quote Job
 */
export const quoteJob = async (teamId: string,
    brandId: string,
    jobQuoteRequest: JobQuoteRequest, options?: Parameters<typeof apiRequest>[1]): Promise<JobQuote> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<JobQuote>(getQuoteJobUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobQuoteRequest)
  }
);}





export const getQuoteJobMutationKey = () => ['quoteJob'] as const;

export const getQuoteJobMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quoteJob>>, TError,QuoteJobMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof quoteJob>>, TError,QuoteJobMutationVariables, TContext> => {

const mutationKey = getQuoteJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof quoteJob>>, QuoteJobMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  quoteJob(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type QuoteJobMutationResult = NonNullable<Awaited<ReturnType<typeof quoteJob>>>
    export type QuoteJobMutationBody = JobQuoteRequest
    export type QuoteJobMutationError = ErrorType<ErrorEnvelope>
    export type QuoteJobMutationVariables = {teamId: string;brandId: string;data: JobQuoteRequest}

    /**
 * @summary Quote Job
 */
export const useQuoteJob = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof quoteJob>>, TError,QuoteJobMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof quoteJob>>,
        TError,
        QuoteJobMutationVariables,
        TContext
      > => {
      return useMutation(getQuoteJobMutationOptions(options), queryClient);
    }
    export const getListPromptTemplatesUrl = (teamId: string,
    brandId: string,
    params?: ListPromptTemplatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/prompt-templates?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/prompt-templates`
}

/**
 * Live's two tabs, newest first (`order=oldest`: Oldest First), 24 a page: `custom`,
 * the brand's own (`search` in the name or the prompt), or `global`, live's (`search` in
 * the prompt). Covers are signed until `urls_expire_at`.
 * @summary List Prompt Templates
 */
export const listPromptTemplates = async (teamId: string,
    brandId: string,
    params?: ListPromptTemplatesParams, options?: Parameters<typeof apiRequest>[1]): Promise<PromptTemplatePage> => {

  return apiRequest<PromptTemplatePage>(getListPromptTemplatesUrl(teamId,brandId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPromptTemplatesQueryKey = (teamId: string,
    brandId: string,
    params?: ListPromptTemplatesParams,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/prompt-templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPromptTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listPromptTemplates>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    params?: ListPromptTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTemplates>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPromptTemplatesQueryKey(teamId,brandId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPromptTemplates>>> = ({ signal }) => listPromptTemplates(teamId,brandId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPromptTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPromptTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listPromptTemplates>>>
export type ListPromptTemplatesQueryError = ErrorType<ErrorEnvelope>


export function useListPromptTemplates<TData = Awaited<ReturnType<typeof listPromptTemplates>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: undefined |  ListPromptTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptTemplates>>,
          TError,
          Awaited<ReturnType<typeof listPromptTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptTemplates<TData = Awaited<ReturnType<typeof listPromptTemplates>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListPromptTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPromptTemplates>>,
          TError,
          Awaited<ReturnType<typeof listPromptTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPromptTemplates<TData = Awaited<ReturnType<typeof listPromptTemplates>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListPromptTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTemplates>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Prompt Templates
 */

export function useListPromptTemplates<TData = Awaited<ReturnType<typeof listPromptTemplates>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListPromptTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPromptTemplates>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPromptTemplatesQueryOptions(teamId,brandId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSavePromptTemplateUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/prompt-templates`
}

/**
 * Live's "Save Prompt": a library picture of this brand, saved from a simple image
 * job, becomes a template's cover, with that job's prompt and reference images. 404 for a
 * file the team cannot see, 422 at `asset_id` for any other file; 409
 * `PROMPT_TEMPLATE_EXISTS` for a picture that is one's cover already.
 * @summary Save Prompt Template
 */
export const savePromptTemplate = async (teamId: string,
    brandId: string,
    promptTemplateRequest: PromptTemplateRequest, options?: Parameters<typeof apiRequest>[1]): Promise<PromptTemplate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PromptTemplate>(getSavePromptTemplateUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(promptTemplateRequest)
  }
);}





export const getSavePromptTemplateMutationKey = () => ['savePromptTemplate'] as const;

export const getSavePromptTemplateMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePromptTemplate>>, TError,SavePromptTemplateMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof savePromptTemplate>>, TError,SavePromptTemplateMutationVariables, TContext> => {

const mutationKey = getSavePromptTemplateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof savePromptTemplate>>, SavePromptTemplateMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  savePromptTemplate(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SavePromptTemplateMutationResult = NonNullable<Awaited<ReturnType<typeof savePromptTemplate>>>
    export type SavePromptTemplateMutationBody = PromptTemplateRequest
    export type SavePromptTemplateMutationError = ErrorType<ErrorEnvelope>
    export type SavePromptTemplateMutationVariables = {teamId: string;brandId: string;data: PromptTemplateRequest}

    /**
 * @summary Save Prompt Template
 */
export const useSavePromptTemplate = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof savePromptTemplate>>, TError,SavePromptTemplateMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof savePromptTemplate>>,
        TError,
        SavePromptTemplateMutationVariables,
        TContext
      > => {
      return useMutation(getSavePromptTemplateMutationOptions(options), queryClient);
    }
    export const getResetAdSwapDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/ad-swap/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Ad Swap Draft
 */
export const resetAdSwapDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AdSwapDraft> => {

  return apiRequest<AdSwapDraft>(getResetAdSwapDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetAdSwapDraftMutationKey = () => ['resetAdSwapDraft'] as const;

export const getResetAdSwapDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetAdSwapDraft>>, TError,ResetAdSwapDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetAdSwapDraft>>, TError,ResetAdSwapDraftMutationVariables, TContext> => {

const mutationKey = getResetAdSwapDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetAdSwapDraft>>, ResetAdSwapDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetAdSwapDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetAdSwapDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetAdSwapDraft>>>

    export type ResetAdSwapDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetAdSwapDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Ad Swap Draft
 */
export const useResetAdSwapDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetAdSwapDraft>>, TError,ResetAdSwapDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetAdSwapDraft>>,
        TError,
        ResetAdSwapDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetAdSwapDraftMutationOptions(options), queryClient);
    }
    export const getGetAdSwapDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/ad-swap/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Ad Swap Draft
 */
export const getAdSwapDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AdSwapDraft> => {

  return apiRequest<AdSwapDraft>(getGetAdSwapDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAdSwapDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/ad-swap/draft`
    ] as const;
    }


export const getGetAdSwapDraftQueryOptions = <TData = Awaited<ReturnType<typeof getAdSwapDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdSwapDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdSwapDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdSwapDraft>>> = ({ signal }) => getAdSwapDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdSwapDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdSwapDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getAdSwapDraft>>>
export type GetAdSwapDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetAdSwapDraft<TData = Awaited<ReturnType<typeof getAdSwapDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdSwapDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdSwapDraft>>,
          TError,
          Awaited<ReturnType<typeof getAdSwapDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdSwapDraft<TData = Awaited<ReturnType<typeof getAdSwapDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdSwapDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdSwapDraft>>,
          TError,
          Awaited<ReturnType<typeof getAdSwapDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdSwapDraft<TData = Awaited<ReturnType<typeof getAdSwapDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdSwapDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Ad Swap Draft
 */

export function useGetAdSwapDraft<TData = Awaited<ReturnType<typeof getAdSwapDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdSwapDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdSwapDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteAdSwapDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/ad-swap/draft`
}

/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a step works or once the script is approved.
 * @summary Write Ad Swap Draft
 */
export const writeAdSwapDraft = async (teamId: string,
    brandId: string,
    adSwapDraftWrite: AdSwapDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<AdSwapDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AdSwapDraft>(getWriteAdSwapDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adSwapDraftWrite)
  }
);}





export const getWriteAdSwapDraftMutationKey = () => ['writeAdSwapDraft'] as const;

export const getWriteAdSwapDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeAdSwapDraft>>, TError,WriteAdSwapDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeAdSwapDraft>>, TError,WriteAdSwapDraftMutationVariables, TContext> => {

const mutationKey = getWriteAdSwapDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeAdSwapDraft>>, WriteAdSwapDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeAdSwapDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteAdSwapDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeAdSwapDraft>>>
    export type WriteAdSwapDraftMutationBody = AdSwapDraftWrite
    export type WriteAdSwapDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteAdSwapDraftMutationVariables = {teamId: string;brandId: string;data: AdSwapDraftWrite}

    /**
 * @summary Write Ad Swap Draft
 */
export const useWriteAdSwapDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeAdSwapDraft>>, TError,WriteAdSwapDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeAdSwapDraft>>,
        TError,
        WriteAdSwapDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteAdSwapDraftMutationOptions(options), queryClient);
    }
    export const getApproveAdSwapScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/ad-swap/draft/approve`
}

/**
 * Approve script: every part's line, the actor and both packs (422 at `script`); then
 * the new actor's still, a paid picture.
 * @summary Approve Ad Swap Script
 */
export const approveAdSwapScript = async (teamId: string,
    brandId: string,
    adSwapApproval: AdSwapApproval, options?: Parameters<typeof apiRequest>[1]): Promise<AdSwapDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AdSwapDraft>(getApproveAdSwapScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adSwapApproval)
  }
);}





export const getApproveAdSwapScriptMutationKey = () => ['approveAdSwapScript'] as const;

export const getApproveAdSwapScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdSwapScript>>, TError,ApproveAdSwapScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveAdSwapScript>>, TError,ApproveAdSwapScriptMutationVariables, TContext> => {

const mutationKey = getApproveAdSwapScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveAdSwapScript>>, ApproveAdSwapScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveAdSwapScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveAdSwapScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveAdSwapScript>>>
    export type ApproveAdSwapScriptMutationBody = AdSwapApproval
    export type ApproveAdSwapScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveAdSwapScriptMutationVariables = {teamId: string;brandId: string;data: AdSwapApproval}

    /**
 * @summary Approve Ad Swap Script
 */
export const useApproveAdSwapScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveAdSwapScript>>, TError,ApproveAdSwapScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveAdSwapScript>>,
        TError,
        ApproveAdSwapScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveAdSwapScriptMutationOptions(options), queryClient);
    }
    export const getWriteAdSwapScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/ad-swap/draft/script`
}

/**
 * Generate Script: the product, the source ad (a ready video of 4 to 30 s, 300 px or
 * more) and the rights checked (422 at each); an uploaded packshot with no name or no text
 * read first; the source ad's cuts, words and one frame a shot read (`reading_director`);
 * then the swap director, its script off its plan or its page redone once, then kept with
 * its problems (`script_problems`).
 * @summary Write Ad Swap Script
 */
export const writeAdSwapScript = async (teamId: string,
    brandId: string,
    adSwapScriptAsk: AdSwapScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<AdSwapDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<AdSwapDraft>(getWriteAdSwapScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(adSwapScriptAsk)
  }
);}





export const getWriteAdSwapScriptMutationKey = () => ['writeAdSwapScript'] as const;

export const getWriteAdSwapScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeAdSwapScript>>, TError,WriteAdSwapScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeAdSwapScript>>, TError,WriteAdSwapScriptMutationVariables, TContext> => {

const mutationKey = getWriteAdSwapScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeAdSwapScript>>, WriteAdSwapScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeAdSwapScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteAdSwapScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeAdSwapScript>>>
    export type WriteAdSwapScriptMutationBody = AdSwapScriptAsk
    export type WriteAdSwapScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteAdSwapScriptMutationVariables = {teamId: string;brandId: string;data: AdSwapScriptAsk}

    /**
 * @summary Write Ad Swap Script
 */
export const useWriteAdSwapScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeAdSwapScript>>, TError,WriteAdSwapScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeAdSwapScript>>,
        TError,
        WriteAdSwapScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteAdSwapScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateAdSwapActorUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/ad-swap/draft/stills/actor/regenerate`
}

/**
 * The actor's still drawn again, a paid picture. `TEMPLATE_DRAFT_LOCKED` (409) before
 * the cast or while anything works.
 * @summary Regenerate Ad Swap Actor
 */
export const regenerateAdSwapActor = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<AdSwapDraft> => {

  return apiRequest<AdSwapDraft>(getRegenerateAdSwapActorUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateAdSwapActorMutationKey = () => ['regenerateAdSwapActor'] as const;

export const getRegenerateAdSwapActorMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateAdSwapActor>>, TError,RegenerateAdSwapActorMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateAdSwapActor>>, TError,RegenerateAdSwapActorMutationVariables, TContext> => {

const mutationKey = getRegenerateAdSwapActorMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateAdSwapActor>>, RegenerateAdSwapActorMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  regenerateAdSwapActor(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateAdSwapActorMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateAdSwapActor>>>

    export type RegenerateAdSwapActorMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateAdSwapActorMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Regenerate Ad Swap Actor
 */
export const useRegenerateAdSwapActor = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateAdSwapActor>>, TError,RegenerateAdSwapActorMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateAdSwapActor>>,
        TError,
        RegenerateAdSwapActorMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateAdSwapActorMutationOptions(options), queryClient);
    }
    export const getResetBalloonAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/balloon-ad/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Balloon Ad Draft
 */
export const resetBalloonAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<BalloonAdDraft> => {

  return apiRequest<BalloonAdDraft>(getResetBalloonAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetBalloonAdDraftMutationKey = () => ['resetBalloonAdDraft'] as const;

export const getResetBalloonAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetBalloonAdDraft>>, TError,ResetBalloonAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetBalloonAdDraft>>, TError,ResetBalloonAdDraftMutationVariables, TContext> => {

const mutationKey = getResetBalloonAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetBalloonAdDraft>>, ResetBalloonAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetBalloonAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetBalloonAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetBalloonAdDraft>>>

    export type ResetBalloonAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetBalloonAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Balloon Ad Draft
 */
export const useResetBalloonAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetBalloonAdDraft>>, TError,ResetBalloonAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetBalloonAdDraft>>,
        TError,
        ResetBalloonAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetBalloonAdDraftMutationOptions(options), queryClient);
    }
    export const getGetBalloonAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/balloon-ad/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Balloon Ad Draft
 */
export const getBalloonAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<BalloonAdDraft> => {

  return apiRequest<BalloonAdDraft>(getGetBalloonAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetBalloonAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/balloon-ad/draft`
    ] as const;
    }


export const getGetBalloonAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getBalloonAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalloonAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBalloonAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBalloonAdDraft>>> = ({ signal }) => getBalloonAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBalloonAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBalloonAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getBalloonAdDraft>>>
export type GetBalloonAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetBalloonAdDraft<TData = Awaited<ReturnType<typeof getBalloonAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalloonAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalloonAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getBalloonAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBalloonAdDraft<TData = Awaited<ReturnType<typeof getBalloonAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalloonAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBalloonAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getBalloonAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBalloonAdDraft<TData = Awaited<ReturnType<typeof getBalloonAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalloonAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Balloon Ad Draft
 */

export function useGetBalloonAdDraft<TData = Awaited<ReturnType<typeof getBalloonAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBalloonAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBalloonAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteBalloonAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/balloon-ad/draft`
}

/**
 * The form as it stands and its script as edited, its words recounted.
 * `TEMPLATE_DRAFT_LOCKED` (409) while a step works or once the script is approved, as live
 * locks the form.
 * @summary Write Balloon Ad Draft
 */
export const writeBalloonAdDraft = async (teamId: string,
    brandId: string,
    balloonAdDraftWrite: BalloonAdDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<BalloonAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<BalloonAdDraft>(getWriteBalloonAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(balloonAdDraftWrite)
  }
);}





export const getWriteBalloonAdDraftMutationKey = () => ['writeBalloonAdDraft'] as const;

export const getWriteBalloonAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeBalloonAdDraft>>, TError,WriteBalloonAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeBalloonAdDraft>>, TError,WriteBalloonAdDraftMutationVariables, TContext> => {

const mutationKey = getWriteBalloonAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeBalloonAdDraft>>, WriteBalloonAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeBalloonAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteBalloonAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeBalloonAdDraft>>>
    export type WriteBalloonAdDraftMutationBody = BalloonAdDraftWrite
    export type WriteBalloonAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteBalloonAdDraftMutationVariables = {teamId: string;brandId: string;data: BalloonAdDraftWrite}

    /**
 * @summary Write Balloon Ad Draft
 */
export const useWriteBalloonAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeBalloonAdDraft>>, TError,WriteBalloonAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeBalloonAdDraft>>,
        TError,
        WriteBalloonAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteBalloonAdDraftMutationOptions(options), queryClient);
    }
    export const getApproveBalloonAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/balloon-ad/draft/approve`
}

/**
 * Live's Approve script: a narrator in voiceover mode (422 at `inputs.voice`), a script
 * that passes live's gate (422 at `script`), then the stage the storyboard's.
 * @summary Approve Balloon Ad Script
 */
export const approveBalloonAdScript = async (teamId: string,
    brandId: string,
    balloonAdScriptApproval: BalloonAdScriptApproval, options?: Parameters<typeof apiRequest>[1]): Promise<BalloonAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<BalloonAdDraft>(getApproveBalloonAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(balloonAdScriptApproval)
  }
);}





export const getApproveBalloonAdScriptMutationKey = () => ['approveBalloonAdScript'] as const;

export const getApproveBalloonAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveBalloonAdScript>>, TError,ApproveBalloonAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveBalloonAdScript>>, TError,ApproveBalloonAdScriptMutationVariables, TContext> => {

const mutationKey = getApproveBalloonAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveBalloonAdScript>>, ApproveBalloonAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveBalloonAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveBalloonAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveBalloonAdScript>>>
    export type ApproveBalloonAdScriptMutationBody = BalloonAdScriptApproval
    export type ApproveBalloonAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveBalloonAdScriptMutationVariables = {teamId: string;brandId: string;data: BalloonAdScriptApproval}

    /**
 * @summary Approve Balloon Ad Script
 */
export const useApproveBalloonAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveBalloonAdScript>>, TError,ApproveBalloonAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveBalloonAdScript>>,
        TError,
        ApproveBalloonAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveBalloonAdScriptMutationOptions(options), queryClient);
    }
    export const getWriteBalloonAdBlankUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/balloon-ad/draft/blank`
}

/**
 * Live's "Write it myself": eight empty sentences in their beats, three empty benefit
 * banners, the end card headed by the product's name; nothing generated.
 * `TEMPLATE_DRAFT_LOCKED` (409) as the write.
 * @summary Write Balloon Ad Blank
 */
export const writeBalloonAdBlank = async (teamId: string,
    brandId: string,
    balloonAdBlankScript: BalloonAdBlankScript, options?: Parameters<typeof apiRequest>[1]): Promise<BalloonAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<BalloonAdDraft>(getWriteBalloonAdBlankUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(balloonAdBlankScript)
  }
);}





export const getWriteBalloonAdBlankMutationKey = () => ['writeBalloonAdBlank'] as const;

export const getWriteBalloonAdBlankMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeBalloonAdBlank>>, TError,WriteBalloonAdBlankMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeBalloonAdBlank>>, TError,WriteBalloonAdBlankMutationVariables, TContext> => {

const mutationKey = getWriteBalloonAdBlankMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeBalloonAdBlank>>, WriteBalloonAdBlankMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeBalloonAdBlank(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteBalloonAdBlankMutationResult = NonNullable<Awaited<ReturnType<typeof writeBalloonAdBlank>>>
    export type WriteBalloonAdBlankMutationBody = BalloonAdBlankScript
    export type WriteBalloonAdBlankMutationError = ErrorType<ErrorEnvelope>
    export type WriteBalloonAdBlankMutationVariables = {teamId: string;brandId: string;data: BalloonAdBlankScript}

    /**
 * @summary Write Balloon Ad Blank
 */
export const useWriteBalloonAdBlank = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeBalloonAdBlank>>, TError,WriteBalloonAdBlankMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeBalloonAdBlank>>,
        TError,
        WriteBalloonAdBlankMutationVariables,
        TContext
      > => {
      return useMutation(getWriteBalloonAdBlankMutationOptions(options), queryClient);
    }
    export const getWriteBalloonAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/balloon-ad/draft/script`
}

/**
 * Live's wand: an uploaded packshot with no name or no text typed is read first
 * (`pack_director`; an unreadable one sets `pack_warning`), then the script director, up
 * to three tries each told the last answer's problems; the try with the fewest is kept,
 * with live's words on what the editor can still fix (`script_warning`).
 * @summary Write Balloon Ad Script
 */
export const writeBalloonAdScript = async (teamId: string,
    brandId: string,
    balloonAdScriptAsk: BalloonAdScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<BalloonAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<BalloonAdDraft>(getWriteBalloonAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(balloonAdScriptAsk)
  }
);}





export const getWriteBalloonAdScriptMutationKey = () => ['writeBalloonAdScript'] as const;

export const getWriteBalloonAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeBalloonAdScript>>, TError,WriteBalloonAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeBalloonAdScript>>, TError,WriteBalloonAdScriptMutationVariables, TContext> => {

const mutationKey = getWriteBalloonAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeBalloonAdScript>>, WriteBalloonAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeBalloonAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteBalloonAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeBalloonAdScript>>>
    export type WriteBalloonAdScriptMutationBody = BalloonAdScriptAsk
    export type WriteBalloonAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteBalloonAdScriptMutationVariables = {teamId: string;brandId: string;data: BalloonAdScriptAsk}

    /**
 * @summary Write Balloon Ad Script
 */
export const useWriteBalloonAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeBalloonAdScript>>, TError,WriteBalloonAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeBalloonAdScript>>,
        TError,
        WriteBalloonAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteBalloonAdScriptMutationOptions(options), queryClient);
    }
    export const getResetCartoonCharacterInTheRealWorldDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-character-in-the-real-world/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Cartoon Character In The Real World Draft
 */
export const resetCartoonCharacterInTheRealWorldDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonDraft> => {

  return apiRequest<CartoonDraft>(getResetCartoonCharacterInTheRealWorldDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetCartoonCharacterInTheRealWorldDraftMutationKey = () => ['resetCartoonCharacterInTheRealWorldDraft'] as const;

export const getResetCartoonCharacterInTheRealWorldDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetCartoonCharacterInTheRealWorldDraft>>, TError,ResetCartoonCharacterInTheRealWorldDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetCartoonCharacterInTheRealWorldDraft>>, TError,ResetCartoonCharacterInTheRealWorldDraftMutationVariables, TContext> => {

const mutationKey = getResetCartoonCharacterInTheRealWorldDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetCartoonCharacterInTheRealWorldDraft>>, ResetCartoonCharacterInTheRealWorldDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetCartoonCharacterInTheRealWorldDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetCartoonCharacterInTheRealWorldDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetCartoonCharacterInTheRealWorldDraft>>>

    export type ResetCartoonCharacterInTheRealWorldDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetCartoonCharacterInTheRealWorldDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Cartoon Character In The Real World Draft
 */
export const useResetCartoonCharacterInTheRealWorldDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetCartoonCharacterInTheRealWorldDraft>>, TError,ResetCartoonCharacterInTheRealWorldDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetCartoonCharacterInTheRealWorldDraft>>,
        TError,
        ResetCartoonCharacterInTheRealWorldDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetCartoonCharacterInTheRealWorldDraftMutationOptions(options), queryClient);
    }
    export const getGetCartoonCharacterInTheRealWorldDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-character-in-the-real-world/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Cartoon Character In The Real World Draft
 */
export const getCartoonCharacterInTheRealWorldDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonDraft> => {

  return apiRequest<CartoonDraft>(getGetCartoonCharacterInTheRealWorldDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCartoonCharacterInTheRealWorldDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-character-in-the-real-world/draft`
    ] as const;
    }


export const getGetCartoonCharacterInTheRealWorldDraftQueryOptions = <TData = Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCartoonCharacterInTheRealWorldDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>> = ({ signal }) => getCartoonCharacterInTheRealWorldDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCartoonCharacterInTheRealWorldDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>>
export type GetCartoonCharacterInTheRealWorldDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetCartoonCharacterInTheRealWorldDraft<TData = Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>,
          TError,
          Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCartoonCharacterInTheRealWorldDraft<TData = Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>,
          TError,
          Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCartoonCharacterInTheRealWorldDraft<TData = Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Cartoon Character In The Real World Draft
 */

export function useGetCartoonCharacterInTheRealWorldDraft<TData = Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonCharacterInTheRealWorldDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCartoonCharacterInTheRealWorldDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteCartoonCharacterInTheRealWorldDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-character-in-the-real-world/draft`
}

/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved.
 * @summary Write Cartoon Character In The Real World Draft
 */
export const writeCartoonCharacterInTheRealWorldDraft = async (teamId: string,
    brandId: string,
    cartoonDraftWrite: CartoonDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CartoonDraft>(getWriteCartoonCharacterInTheRealWorldDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartoonDraftWrite)
  }
);}





export const getWriteCartoonCharacterInTheRealWorldDraftMutationKey = () => ['writeCartoonCharacterInTheRealWorldDraft'] as const;

export const getWriteCartoonCharacterInTheRealWorldDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldDraft>>, TError,WriteCartoonCharacterInTheRealWorldDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldDraft>>, TError,WriteCartoonCharacterInTheRealWorldDraftMutationVariables, TContext> => {

const mutationKey = getWriteCartoonCharacterInTheRealWorldDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldDraft>>, WriteCartoonCharacterInTheRealWorldDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeCartoonCharacterInTheRealWorldDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteCartoonCharacterInTheRealWorldDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldDraft>>>
    export type WriteCartoonCharacterInTheRealWorldDraftMutationBody = CartoonDraftWrite
    export type WriteCartoonCharacterInTheRealWorldDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteCartoonCharacterInTheRealWorldDraftMutationVariables = {teamId: string;brandId: string;data: CartoonDraftWrite}

    /**
 * @summary Write Cartoon Character In The Real World Draft
 */
export const useWriteCartoonCharacterInTheRealWorldDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldDraft>>, TError,WriteCartoonCharacterInTheRealWorldDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldDraft>>,
        TError,
        WriteCartoonCharacterInTheRealWorldDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteCartoonCharacterInTheRealWorldDraftMutationOptions(options), queryClient);
    }
    export const getApproveCartoonCharacterInTheRealWorldScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-character-in-the-real-world/draft/approve`
}

/**
 * Approve script: eleven lines on the fixed speakers, the hero's super at most eight
 * words, 80 to 120 words, no on-screen line past 4.5 s, every lock filled with a hex color
 * in the creature's (422 at `script` in its words); then the stills with no source, the
 * sheets, the room master and the product sheet, each other still once those it is drawn
 * from are done.
 * @summary Approve Cartoon Character In The Real World Script
 */
export const approveCartoonCharacterInTheRealWorldScript = async (teamId: string,
    brandId: string,
    cartoonApproval: CartoonApproval, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CartoonDraft>(getApproveCartoonCharacterInTheRealWorldScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartoonApproval)
  }
);}





export const getApproveCartoonCharacterInTheRealWorldScriptMutationKey = () => ['approveCartoonCharacterInTheRealWorldScript'] as const;

export const getApproveCartoonCharacterInTheRealWorldScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCartoonCharacterInTheRealWorldScript>>, TError,ApproveCartoonCharacterInTheRealWorldScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveCartoonCharacterInTheRealWorldScript>>, TError,ApproveCartoonCharacterInTheRealWorldScriptMutationVariables, TContext> => {

const mutationKey = getApproveCartoonCharacterInTheRealWorldScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveCartoonCharacterInTheRealWorldScript>>, ApproveCartoonCharacterInTheRealWorldScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveCartoonCharacterInTheRealWorldScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveCartoonCharacterInTheRealWorldScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveCartoonCharacterInTheRealWorldScript>>>
    export type ApproveCartoonCharacterInTheRealWorldScriptMutationBody = CartoonApproval
    export type ApproveCartoonCharacterInTheRealWorldScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveCartoonCharacterInTheRealWorldScriptMutationVariables = {teamId: string;brandId: string;data: CartoonApproval}

    /**
 * @summary Approve Cartoon Character In The Real World Script
 */
export const useApproveCartoonCharacterInTheRealWorldScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCartoonCharacterInTheRealWorldScript>>, TError,ApproveCartoonCharacterInTheRealWorldScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveCartoonCharacterInTheRealWorldScript>>,
        TError,
        ApproveCartoonCharacterInTheRealWorldScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveCartoonCharacterInTheRealWorldScriptMutationOptions(options), queryClient);
    }
    export const getWriteCartoonCharacterInTheRealWorldScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-character-in-the-real-world/draft/script`
}

/**
 * Generate script: an uploaded packshot with no name or no text typed is read first
 * (`pack_director`; an unreadable one sets `pack_warning`), then the script director. A
 * script Approve would refuse is redone once, then kept with that problem
 * (`script_problems`).
 * @summary Write Cartoon Character In The Real World Script
 */
export const writeCartoonCharacterInTheRealWorldScript = async (teamId: string,
    brandId: string,
    cartoonScriptAsk: CartoonScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CartoonDraft>(getWriteCartoonCharacterInTheRealWorldScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartoonScriptAsk)
  }
);}





export const getWriteCartoonCharacterInTheRealWorldScriptMutationKey = () => ['writeCartoonCharacterInTheRealWorldScript'] as const;

export const getWriteCartoonCharacterInTheRealWorldScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldScript>>, TError,WriteCartoonCharacterInTheRealWorldScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldScript>>, TError,WriteCartoonCharacterInTheRealWorldScriptMutationVariables, TContext> => {

const mutationKey = getWriteCartoonCharacterInTheRealWorldScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldScript>>, WriteCartoonCharacterInTheRealWorldScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeCartoonCharacterInTheRealWorldScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteCartoonCharacterInTheRealWorldScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldScript>>>
    export type WriteCartoonCharacterInTheRealWorldScriptMutationBody = CartoonScriptAsk
    export type WriteCartoonCharacterInTheRealWorldScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteCartoonCharacterInTheRealWorldScriptMutationVariables = {teamId: string;brandId: string;data: CartoonScriptAsk}

    /**
 * @summary Write Cartoon Character In The Real World Script
 */
export const useWriteCartoonCharacterInTheRealWorldScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldScript>>, TError,WriteCartoonCharacterInTheRealWorldScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeCartoonCharacterInTheRealWorldScript>>,
        TError,
        WriteCartoonCharacterInTheRealWorldScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteCartoonCharacterInTheRealWorldScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateCartoonCharacterInTheRealWorldStillUrl = (teamId: string,
    brandId: string,
    name: 'creature_sheet' | 'scale_plate' | 'woman_sheet' | 'room_master' | 'product_sheet' | 's1' | 's2' | 's3' | 's4' | 's5' | 's6' | 's7' | 's8' | 's9' | 's10' | 's11',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-character-in-the-real-world/draft/stills/${name}/regenerate`
}

/**
 * Regenerate a still: it and every still drawn from it drawn again (a shot draws the
 * later shots again), each a paid image as the first was. `TEMPLATE_DRAFT_LOCKED` (409)
 * before the stills or while anything works.
 * @summary Regenerate Cartoon Character In The Real World Still
 */
export const regenerateCartoonCharacterInTheRealWorldStill = async (teamId: string,
    brandId: string,
    name: 'creature_sheet' | 'scale_plate' | 'woman_sheet' | 'room_master' | 'product_sheet' | 's1' | 's2' | 's3' | 's4' | 's5' | 's6' | 's7' | 's8' | 's9' | 's10' | 's11', options?: Parameters<typeof apiRequest>[1]): Promise<CartoonDraft> => {

  return apiRequest<CartoonDraft>(getRegenerateCartoonCharacterInTheRealWorldStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateCartoonCharacterInTheRealWorldStillMutationKey = () => ['regenerateCartoonCharacterInTheRealWorldStill'] as const;

export const getRegenerateCartoonCharacterInTheRealWorldStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateCartoonCharacterInTheRealWorldStill>>, TError,RegenerateCartoonCharacterInTheRealWorldStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateCartoonCharacterInTheRealWorldStill>>, TError,RegenerateCartoonCharacterInTheRealWorldStillMutationVariables, TContext> => {

const mutationKey = getRegenerateCartoonCharacterInTheRealWorldStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateCartoonCharacterInTheRealWorldStill>>, RegenerateCartoonCharacterInTheRealWorldStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateCartoonCharacterInTheRealWorldStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateCartoonCharacterInTheRealWorldStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateCartoonCharacterInTheRealWorldStill>>>

    export type RegenerateCartoonCharacterInTheRealWorldStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateCartoonCharacterInTheRealWorldStillMutationVariables = {teamId: string;brandId: string;name: 'creature_sheet' | 'scale_plate' | 'woman_sheet' | 'room_master' | 'product_sheet' | 's1' | 's2' | 's3' | 's4' | 's5' | 's6' | 's7' | 's8' | 's9' | 's10' | 's11'}

    /**
 * @summary Regenerate Cartoon Character In The Real World Still
 */
export const useRegenerateCartoonCharacterInTheRealWorldStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateCartoonCharacterInTheRealWorldStill>>, TError,RegenerateCartoonCharacterInTheRealWorldStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateCartoonCharacterInTheRealWorldStill>>,
        TError,
        RegenerateCartoonCharacterInTheRealWorldStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateCartoonCharacterInTheRealWorldStillMutationOptions(options), queryClient);
    }
    export const getResetCartoonCloneDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-clone/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Cartoon Clone Draft
 */
export const resetCartoonCloneDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonCloneDraft> => {

  return apiRequest<CartoonCloneDraft>(getResetCartoonCloneDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetCartoonCloneDraftMutationKey = () => ['resetCartoonCloneDraft'] as const;

export const getResetCartoonCloneDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetCartoonCloneDraft>>, TError,ResetCartoonCloneDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetCartoonCloneDraft>>, TError,ResetCartoonCloneDraftMutationVariables, TContext> => {

const mutationKey = getResetCartoonCloneDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetCartoonCloneDraft>>, ResetCartoonCloneDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetCartoonCloneDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetCartoonCloneDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetCartoonCloneDraft>>>

    export type ResetCartoonCloneDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetCartoonCloneDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Cartoon Clone Draft
 */
export const useResetCartoonCloneDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetCartoonCloneDraft>>, TError,ResetCartoonCloneDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetCartoonCloneDraft>>,
        TError,
        ResetCartoonCloneDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetCartoonCloneDraftMutationOptions(options), queryClient);
    }
    export const getGetCartoonCloneDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-clone/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Cartoon Clone Draft
 */
export const getCartoonCloneDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonCloneDraft> => {

  return apiRequest<CartoonCloneDraft>(getGetCartoonCloneDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCartoonCloneDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-clone/draft`
    ] as const;
    }


export const getGetCartoonCloneDraftQueryOptions = <TData = Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCartoonCloneDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCartoonCloneDraft>>> = ({ signal }) => getCartoonCloneDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCartoonCloneDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getCartoonCloneDraft>>>
export type GetCartoonCloneDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetCartoonCloneDraft<TData = Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCartoonCloneDraft>>,
          TError,
          Awaited<ReturnType<typeof getCartoonCloneDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCartoonCloneDraft<TData = Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCartoonCloneDraft>>,
          TError,
          Awaited<ReturnType<typeof getCartoonCloneDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCartoonCloneDraft<TData = Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Cartoon Clone Draft
 */

export function useGetCartoonCloneDraft<TData = Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonCloneDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCartoonCloneDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteCartoonCloneDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-clone/draft`
}

/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a step works or once the script is approved.
 * @summary Write Cartoon Clone Draft
 */
export const writeCartoonCloneDraft = async (teamId: string,
    brandId: string,
    cartoonCloneDraftWrite: CartoonCloneDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonCloneDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CartoonCloneDraft>(getWriteCartoonCloneDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartoonCloneDraftWrite)
  }
);}





export const getWriteCartoonCloneDraftMutationKey = () => ['writeCartoonCloneDraft'] as const;

export const getWriteCartoonCloneDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCloneDraft>>, TError,WriteCartoonCloneDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCloneDraft>>, TError,WriteCartoonCloneDraftMutationVariables, TContext> => {

const mutationKey = getWriteCartoonCloneDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeCartoonCloneDraft>>, WriteCartoonCloneDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeCartoonCloneDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteCartoonCloneDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeCartoonCloneDraft>>>
    export type WriteCartoonCloneDraftMutationBody = CartoonCloneDraftWrite
    export type WriteCartoonCloneDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteCartoonCloneDraftMutationVariables = {teamId: string;brandId: string;data: CartoonCloneDraftWrite}

    /**
 * @summary Write Cartoon Clone Draft
 */
export const useWriteCartoonCloneDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCloneDraft>>, TError,WriteCartoonCloneDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeCartoonCloneDraft>>,
        TError,
        WriteCartoonCloneDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteCartoonCloneDraftMutationOptions(options), queryClient);
    }
    export const getApproveCartoonCloneScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-clone/draft/approve`
}

/**
 * Approve script: the line, the locks, the pack, the set and the voice (422 at
 * `script`); then the cast, paid pictures, and the voice's design.
 * @summary Approve Cartoon Clone Script
 */
export const approveCartoonCloneScript = async (teamId: string,
    brandId: string,
    cartoonCloneApproval: CartoonCloneApproval, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonCloneDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CartoonCloneDraft>(getApproveCartoonCloneScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartoonCloneApproval)
  }
);}





export const getApproveCartoonCloneScriptMutationKey = () => ['approveCartoonCloneScript'] as const;

export const getApproveCartoonCloneScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCartoonCloneScript>>, TError,ApproveCartoonCloneScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveCartoonCloneScript>>, TError,ApproveCartoonCloneScriptMutationVariables, TContext> => {

const mutationKey = getApproveCartoonCloneScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveCartoonCloneScript>>, ApproveCartoonCloneScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveCartoonCloneScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveCartoonCloneScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveCartoonCloneScript>>>
    export type ApproveCartoonCloneScriptMutationBody = CartoonCloneApproval
    export type ApproveCartoonCloneScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveCartoonCloneScriptMutationVariables = {teamId: string;brandId: string;data: CartoonCloneApproval}

    /**
 * @summary Approve Cartoon Clone Script
 */
export const useApproveCartoonCloneScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCartoonCloneScript>>, TError,ApproveCartoonCloneScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveCartoonCloneScript>>,
        TError,
        ApproveCartoonCloneScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveCartoonCloneScriptMutationOptions(options), queryClient);
    }
    export const getWriteCartoonCloneScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-clone/draft/script`
}

/**
 * Generate Script: the product, the source ad and the rights checked (422 at each); an
 * uploaded packshot with no name or no text read first; the source ad read where the draft
 * has no reading of it (`reading_director`); then the clone director, its script off the
 * source or its page redone once, then kept with its problems (`script_problems`).
 * @summary Write Cartoon Clone Script
 */
export const writeCartoonCloneScript = async (teamId: string,
    brandId: string,
    cartoonCloneScriptAsk: CartoonCloneScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonCloneDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CartoonCloneDraft>(getWriteCartoonCloneScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartoonCloneScriptAsk)
  }
);}





export const getWriteCartoonCloneScriptMutationKey = () => ['writeCartoonCloneScript'] as const;

export const getWriteCartoonCloneScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCloneScript>>, TError,WriteCartoonCloneScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCloneScript>>, TError,WriteCartoonCloneScriptMutationVariables, TContext> => {

const mutationKey = getWriteCartoonCloneScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeCartoonCloneScript>>, WriteCartoonCloneScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeCartoonCloneScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteCartoonCloneScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeCartoonCloneScript>>>
    export type WriteCartoonCloneScriptMutationBody = CartoonCloneScriptAsk
    export type WriteCartoonCloneScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteCartoonCloneScriptMutationVariables = {teamId: string;brandId: string;data: CartoonCloneScriptAsk}

    /**
 * @summary Write Cartoon Clone Script
 */
export const useWriteCartoonCloneScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonCloneScript>>, TError,WriteCartoonCloneScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeCartoonCloneScript>>,
        TError,
        WriteCartoonCloneScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteCartoonCloneScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateCartoonCloneStillUrl = (teamId: string,
    brandId: string,
    name: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-clone/draft/stills/${name}/regenerate`
}

/**
 * A still of the cast drawn again with every still drawn from it, or `voice` designed
 * again. 404 for a name the cast lacks; `TEMPLATE_DRAFT_LOCKED` (409) before the cast or
 * while anything works.
 * @summary Regenerate Cartoon Clone Still
 */
export const regenerateCartoonCloneStill = async (teamId: string,
    brandId: string,
    name: string, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonCloneDraft> => {

  return apiRequest<CartoonCloneDraft>(getRegenerateCartoonCloneStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateCartoonCloneStillMutationKey = () => ['regenerateCartoonCloneStill'] as const;

export const getRegenerateCartoonCloneStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateCartoonCloneStill>>, TError,RegenerateCartoonCloneStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateCartoonCloneStill>>, TError,RegenerateCartoonCloneStillMutationVariables, TContext> => {

const mutationKey = getRegenerateCartoonCloneStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateCartoonCloneStill>>, RegenerateCartoonCloneStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateCartoonCloneStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateCartoonCloneStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateCartoonCloneStill>>>

    export type RegenerateCartoonCloneStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateCartoonCloneStillMutationVariables = {teamId: string;brandId: string;name: string}

    /**
 * @summary Regenerate Cartoon Clone Still
 */
export const useRegenerateCartoonCloneStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateCartoonCloneStill>>, TError,RegenerateCartoonCloneStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateCartoonCloneStill>>,
        TError,
        RegenerateCartoonCloneStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateCartoonCloneStillMutationOptions(options), queryClient);
    }
    export const getResetCartoonVillainAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-villain/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Cartoon Villain Ad Draft
 */
export const resetCartoonVillainAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonVillainDraft> => {

  return apiRequest<CartoonVillainDraft>(getResetCartoonVillainAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetCartoonVillainAdDraftMutationKey = () => ['resetCartoonVillainAdDraft'] as const;

export const getResetCartoonVillainAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetCartoonVillainAdDraft>>, TError,ResetCartoonVillainAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetCartoonVillainAdDraft>>, TError,ResetCartoonVillainAdDraftMutationVariables, TContext> => {

const mutationKey = getResetCartoonVillainAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetCartoonVillainAdDraft>>, ResetCartoonVillainAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetCartoonVillainAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetCartoonVillainAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetCartoonVillainAdDraft>>>

    export type ResetCartoonVillainAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetCartoonVillainAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Cartoon Villain Ad Draft
 */
export const useResetCartoonVillainAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetCartoonVillainAdDraft>>, TError,ResetCartoonVillainAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetCartoonVillainAdDraft>>,
        TError,
        ResetCartoonVillainAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetCartoonVillainAdDraftMutationOptions(options), queryClient);
    }
    export const getGetCartoonVillainAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-villain/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Cartoon Villain Ad Draft
 */
export const getCartoonVillainAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonVillainDraft> => {

  return apiRequest<CartoonVillainDraft>(getGetCartoonVillainAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCartoonVillainAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-villain/draft`
    ] as const;
    }


export const getGetCartoonVillainAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCartoonVillainAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCartoonVillainAdDraft>>> = ({ signal }) => getCartoonVillainAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCartoonVillainAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getCartoonVillainAdDraft>>>
export type GetCartoonVillainAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetCartoonVillainAdDraft<TData = Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCartoonVillainAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getCartoonVillainAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCartoonVillainAdDraft<TData = Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCartoonVillainAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getCartoonVillainAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCartoonVillainAdDraft<TData = Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Cartoon Villain Ad Draft
 */

export function useGetCartoonVillainAdDraft<TData = Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartoonVillainAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCartoonVillainAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteCartoonVillainAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-villain/draft`
}

/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved.
 * @summary Write Cartoon Villain Ad Draft
 */
export const writeCartoonVillainAdDraft = async (teamId: string,
    brandId: string,
    cartoonVillainDraftWrite: CartoonVillainDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonVillainDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CartoonVillainDraft>(getWriteCartoonVillainAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartoonVillainDraftWrite)
  }
);}





export const getWriteCartoonVillainAdDraftMutationKey = () => ['writeCartoonVillainAdDraft'] as const;

export const getWriteCartoonVillainAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonVillainAdDraft>>, TError,WriteCartoonVillainAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeCartoonVillainAdDraft>>, TError,WriteCartoonVillainAdDraftMutationVariables, TContext> => {

const mutationKey = getWriteCartoonVillainAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeCartoonVillainAdDraft>>, WriteCartoonVillainAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeCartoonVillainAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteCartoonVillainAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeCartoonVillainAdDraft>>>
    export type WriteCartoonVillainAdDraftMutationBody = CartoonVillainDraftWrite
    export type WriteCartoonVillainAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteCartoonVillainAdDraftMutationVariables = {teamId: string;brandId: string;data: CartoonVillainDraftWrite}

    /**
 * @summary Write Cartoon Villain Ad Draft
 */
export const useWriteCartoonVillainAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonVillainAdDraft>>, TError,WriteCartoonVillainAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeCartoonVillainAdDraft>>,
        TError,
        WriteCartoonVillainAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteCartoonVillainAdDraftMutationOptions(options), queryClient);
    }
    export const getApproveCartoonVillainAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-villain/draft/approve`
}

/**
 * Approve script: every value given, the brag 10 to 14 words and the colours hex (422
 * at `script` in our words); then the stills: the sheet, the home plate and the end card
 * at once, `s1` and `s2` as their pictures are done.
 * @summary Approve Cartoon Villain Ad Script
 */
export const approveCartoonVillainAdScript = async (teamId: string,
    brandId: string,
    cartoonVillainApproval: CartoonVillainApproval, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonVillainDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CartoonVillainDraft>(getApproveCartoonVillainAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartoonVillainApproval)
  }
);}





export const getApproveCartoonVillainAdScriptMutationKey = () => ['approveCartoonVillainAdScript'] as const;

export const getApproveCartoonVillainAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCartoonVillainAdScript>>, TError,ApproveCartoonVillainAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveCartoonVillainAdScript>>, TError,ApproveCartoonVillainAdScriptMutationVariables, TContext> => {

const mutationKey = getApproveCartoonVillainAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveCartoonVillainAdScript>>, ApproveCartoonVillainAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveCartoonVillainAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveCartoonVillainAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveCartoonVillainAdScript>>>
    export type ApproveCartoonVillainAdScriptMutationBody = CartoonVillainApproval
    export type ApproveCartoonVillainAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveCartoonVillainAdScriptMutationVariables = {teamId: string;brandId: string;data: CartoonVillainApproval}

    /**
 * @summary Approve Cartoon Villain Ad Script
 */
export const useApproveCartoonVillainAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCartoonVillainAdScript>>, TError,ApproveCartoonVillainAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveCartoonVillainAdScript>>,
        TError,
        ApproveCartoonVillainAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveCartoonVillainAdScriptMutationOptions(options), queryClient);
    }
    export const getWriteCartoonVillainAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-villain/draft/script`
}

/**
 * Generate script: an uploaded packshot with no name or no text typed is read first
 * (`pack_director`; an unreadable one sets `pack_warning`), then the script director,
 * shown the packshot, fills every value of the playbook's locks and lines.
 * @summary Write Cartoon Villain Ad Script
 */
export const writeCartoonVillainAdScript = async (teamId: string,
    brandId: string,
    cartoonVillainScriptAsk: CartoonVillainScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<CartoonVillainDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<CartoonVillainDraft>(getWriteCartoonVillainAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(cartoonVillainScriptAsk)
  }
);}





export const getWriteCartoonVillainAdScriptMutationKey = () => ['writeCartoonVillainAdScript'] as const;

export const getWriteCartoonVillainAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonVillainAdScript>>, TError,WriteCartoonVillainAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeCartoonVillainAdScript>>, TError,WriteCartoonVillainAdScriptMutationVariables, TContext> => {

const mutationKey = getWriteCartoonVillainAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeCartoonVillainAdScript>>, WriteCartoonVillainAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeCartoonVillainAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteCartoonVillainAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeCartoonVillainAdScript>>>
    export type WriteCartoonVillainAdScriptMutationBody = CartoonVillainScriptAsk
    export type WriteCartoonVillainAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteCartoonVillainAdScriptMutationVariables = {teamId: string;brandId: string;data: CartoonVillainScriptAsk}

    /**
 * @summary Write Cartoon Villain Ad Script
 */
export const useWriteCartoonVillainAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeCartoonVillainAdScript>>, TError,WriteCartoonVillainAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeCartoonVillainAdScript>>,
        TError,
        WriteCartoonVillainAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteCartoonVillainAdScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateCartoonVillainAdStillUrl = (teamId: string,
    brandId: string,
    name: 'sheet' | 'home' | 's1' | 's2' | 'end_card',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/cartoon-villain/draft/stills/${name}/regenerate`
}

/**
 * A still and every still drawn from it drawn again, each a paid image as the first
 * was. `TEMPLATE_DRAFT_LOCKED` (409) before the stills or while anything works.
 * @summary Regenerate Cartoon Villain Ad Still
 */
export const regenerateCartoonVillainAdStill = async (teamId: string,
    brandId: string,
    name: 'sheet' | 'home' | 's1' | 's2' | 'end_card', options?: Parameters<typeof apiRequest>[1]): Promise<CartoonVillainDraft> => {

  return apiRequest<CartoonVillainDraft>(getRegenerateCartoonVillainAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateCartoonVillainAdStillMutationKey = () => ['regenerateCartoonVillainAdStill'] as const;

export const getRegenerateCartoonVillainAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateCartoonVillainAdStill>>, TError,RegenerateCartoonVillainAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateCartoonVillainAdStill>>, TError,RegenerateCartoonVillainAdStillMutationVariables, TContext> => {

const mutationKey = getRegenerateCartoonVillainAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateCartoonVillainAdStill>>, RegenerateCartoonVillainAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateCartoonVillainAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateCartoonVillainAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateCartoonVillainAdStill>>>

    export type RegenerateCartoonVillainAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateCartoonVillainAdStillMutationVariables = {teamId: string;brandId: string;name: 'sheet' | 'home' | 's1' | 's2' | 'end_card'}

    /**
 * @summary Regenerate Cartoon Villain Ad Still
 */
export const useRegenerateCartoonVillainAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateCartoonVillainAdStill>>, TError,RegenerateCartoonVillainAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateCartoonVillainAdStill>>,
        TError,
        RegenerateCartoonVillainAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateCartoonVillainAdStillMutationOptions(options), queryClient);
    }
    export const getResetChalkExplainerAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/chalk-explainer-ad/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Chalk Explainer Ad Draft
 */
export const resetChalkExplainerAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<ChalkExplainerAdDraft> => {

  return apiRequest<ChalkExplainerAdDraft>(getResetChalkExplainerAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetChalkExplainerAdDraftMutationKey = () => ['resetChalkExplainerAdDraft'] as const;

export const getResetChalkExplainerAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetChalkExplainerAdDraft>>, TError,ResetChalkExplainerAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetChalkExplainerAdDraft>>, TError,ResetChalkExplainerAdDraftMutationVariables, TContext> => {

const mutationKey = getResetChalkExplainerAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetChalkExplainerAdDraft>>, ResetChalkExplainerAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetChalkExplainerAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetChalkExplainerAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetChalkExplainerAdDraft>>>

    export type ResetChalkExplainerAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetChalkExplainerAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Chalk Explainer Ad Draft
 */
export const useResetChalkExplainerAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetChalkExplainerAdDraft>>, TError,ResetChalkExplainerAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetChalkExplainerAdDraft>>,
        TError,
        ResetChalkExplainerAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetChalkExplainerAdDraftMutationOptions(options), queryClient);
    }
    export const getGetChalkExplainerAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/chalk-explainer-ad/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Chalk Explainer Ad Draft
 */
export const getChalkExplainerAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<ChalkExplainerAdDraft> => {

  return apiRequest<ChalkExplainerAdDraft>(getGetChalkExplainerAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetChalkExplainerAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/chalk-explainer-ad/draft`
    ] as const;
    }


export const getGetChalkExplainerAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetChalkExplainerAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getChalkExplainerAdDraft>>> = ({ signal }) => getChalkExplainerAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetChalkExplainerAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getChalkExplainerAdDraft>>>
export type GetChalkExplainerAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetChalkExplainerAdDraft<TData = Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChalkExplainerAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getChalkExplainerAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChalkExplainerAdDraft<TData = Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChalkExplainerAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getChalkExplainerAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetChalkExplainerAdDraft<TData = Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Chalk Explainer Ad Draft
 */

export function useGetChalkExplainerAdDraft<TData = Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getChalkExplainerAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetChalkExplainerAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteChalkExplainerAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/chalk-explainer-ad/draft`
}

/**
 * The form as it stands and its script as edited, the script's problems read again.
 * `TEMPLATE_DRAFT_LOCKED` (409) while a director works or once the script is approved.
 * @summary Write Chalk Explainer Ad Draft
 */
export const writeChalkExplainerAdDraft = async (teamId: string,
    brandId: string,
    chalkExplainerAdDraftWrite: ChalkExplainerAdDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<ChalkExplainerAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<ChalkExplainerAdDraft>(getWriteChalkExplainerAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(chalkExplainerAdDraftWrite)
  }
);}





export const getWriteChalkExplainerAdDraftMutationKey = () => ['writeChalkExplainerAdDraft'] as const;

export const getWriteChalkExplainerAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeChalkExplainerAdDraft>>, TError,WriteChalkExplainerAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeChalkExplainerAdDraft>>, TError,WriteChalkExplainerAdDraftMutationVariables, TContext> => {

const mutationKey = getWriteChalkExplainerAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeChalkExplainerAdDraft>>, WriteChalkExplainerAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeChalkExplainerAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteChalkExplainerAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeChalkExplainerAdDraft>>>
    export type WriteChalkExplainerAdDraftMutationBody = ChalkExplainerAdDraftWrite
    export type WriteChalkExplainerAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteChalkExplainerAdDraftMutationVariables = {teamId: string;brandId: string;data: ChalkExplainerAdDraftWrite}

    /**
 * @summary Write Chalk Explainer Ad Draft
 */
export const useWriteChalkExplainerAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeChalkExplainerAdDraft>>, TError,WriteChalkExplainerAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeChalkExplainerAdDraft>>,
        TError,
        WriteChalkExplainerAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteChalkExplainerAdDraftMutationOptions(options), queryClient);
    }
    export const getApproveChalkExplainerAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/chalk-explainer-ad/draft/approve`
}

/**
 * Live's Approve script: its ten lines, each written and said, a board part on every
 * line but the last, the end card's headline and button (422 at `script` with live's
 * words); then the blank board, the end card and the board director. A board off the
 * script is asked once more, then refused (`problem`), the draft back at its script. A kept
 * board starts the three boards, each as the one before is done.
 * @summary Approve Chalk Explainer Ad Script
 */
export const approveChalkExplainerAdScript = async (teamId: string,
    brandId: string,
    chalkExplainerAdApproval: ChalkExplainerAdApproval, options?: Parameters<typeof apiRequest>[1]): Promise<ChalkExplainerAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<ChalkExplainerAdDraft>(getApproveChalkExplainerAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(chalkExplainerAdApproval)
  }
);}





export const getApproveChalkExplainerAdScriptMutationKey = () => ['approveChalkExplainerAdScript'] as const;

export const getApproveChalkExplainerAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveChalkExplainerAdScript>>, TError,ApproveChalkExplainerAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveChalkExplainerAdScript>>, TError,ApproveChalkExplainerAdScriptMutationVariables, TContext> => {

const mutationKey = getApproveChalkExplainerAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveChalkExplainerAdScript>>, ApproveChalkExplainerAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveChalkExplainerAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveChalkExplainerAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveChalkExplainerAdScript>>>
    export type ApproveChalkExplainerAdScriptMutationBody = ChalkExplainerAdApproval
    export type ApproveChalkExplainerAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveChalkExplainerAdScriptMutationVariables = {teamId: string;brandId: string;data: ChalkExplainerAdApproval}

    /**
 * @summary Approve Chalk Explainer Ad Script
 */
export const useApproveChalkExplainerAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveChalkExplainerAdScript>>, TError,ApproveChalkExplainerAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveChalkExplainerAdScript>>,
        TError,
        ApproveChalkExplainerAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveChalkExplainerAdScriptMutationOptions(options), queryClient);
    }
    export const getBackToChalkExplainerAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/chalk-explainer-ad/draft/back-to-script`
}

/**
 * Live's "Back to script": the board and the stills forgotten. `TEMPLATE_DRAFT_LOCKED`
 * (409) before approval or while anything works.
 * @summary Back To Chalk Explainer Ad Script
 */
export const backToChalkExplainerAdScript = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<ChalkExplainerAdDraft> => {

  return apiRequest<ChalkExplainerAdDraft>(getBackToChalkExplainerAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBackToChalkExplainerAdScriptMutationKey = () => ['backToChalkExplainerAdScript'] as const;

export const getBackToChalkExplainerAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToChalkExplainerAdScript>>, TError,BackToChalkExplainerAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof backToChalkExplainerAdScript>>, TError,BackToChalkExplainerAdScriptMutationVariables, TContext> => {

const mutationKey = getBackToChalkExplainerAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof backToChalkExplainerAdScript>>, BackToChalkExplainerAdScriptMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  backToChalkExplainerAdScript(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BackToChalkExplainerAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof backToChalkExplainerAdScript>>>

    export type BackToChalkExplainerAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type BackToChalkExplainerAdScriptMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Back To Chalk Explainer Ad Script
 */
export const useBackToChalkExplainerAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToChalkExplainerAdScript>>, TError,BackToChalkExplainerAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof backToChalkExplainerAdScript>>,
        TError,
        BackToChalkExplainerAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getBackToChalkExplainerAdScriptMutationOptions(options), queryClient);
    }
    export const getWriteChalkExplainerAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/chalk-explainer-ad/draft/script`
}

/**
 * Live's Generate Script: an uploaded packshot with no name or no text typed is read
 * first, then the script director, up to three tries, each told what the last one failed;
 * the try with the fewest problems is kept with them (`script_warning`,
 * `script_problems`). An empty CTA chip takes the script's button.
 * @summary Write Chalk Explainer Ad Script
 */
export const writeChalkExplainerAdScript = async (teamId: string,
    brandId: string,
    chalkExplainerAdScriptAsk: ChalkExplainerAdScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<ChalkExplainerAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<ChalkExplainerAdDraft>(getWriteChalkExplainerAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(chalkExplainerAdScriptAsk)
  }
);}





export const getWriteChalkExplainerAdScriptMutationKey = () => ['writeChalkExplainerAdScript'] as const;

export const getWriteChalkExplainerAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeChalkExplainerAdScript>>, TError,WriteChalkExplainerAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeChalkExplainerAdScript>>, TError,WriteChalkExplainerAdScriptMutationVariables, TContext> => {

const mutationKey = getWriteChalkExplainerAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeChalkExplainerAdScript>>, WriteChalkExplainerAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeChalkExplainerAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteChalkExplainerAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeChalkExplainerAdScript>>>
    export type WriteChalkExplainerAdScriptMutationBody = ChalkExplainerAdScriptAsk
    export type WriteChalkExplainerAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteChalkExplainerAdScriptMutationVariables = {teamId: string;brandId: string;data: ChalkExplainerAdScriptAsk}

    /**
 * @summary Write Chalk Explainer Ad Script
 */
export const useWriteChalkExplainerAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeChalkExplainerAdScript>>, TError,WriteChalkExplainerAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeChalkExplainerAdScript>>,
        TError,
        WriteChalkExplainerAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteChalkExplainerAdScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateChalkExplainerAdStillUrl = (teamId: string,
    brandId: string,
    name: 'board0' | 'end_a' | 'end_b' | 'end_c' | 'end_card',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/chalk-explainer-ad/draft/stills/${name}/regenerate`
}

/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image
 * as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the still is asked, or while
 * anything works.
 * @summary Regenerate Chalk Explainer Ad Still
 */
export const regenerateChalkExplainerAdStill = async (teamId: string,
    brandId: string,
    name: 'board0' | 'end_a' | 'end_b' | 'end_c' | 'end_card', options?: Parameters<typeof apiRequest>[1]): Promise<ChalkExplainerAdDraft> => {

  return apiRequest<ChalkExplainerAdDraft>(getRegenerateChalkExplainerAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateChalkExplainerAdStillMutationKey = () => ['regenerateChalkExplainerAdStill'] as const;

export const getRegenerateChalkExplainerAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateChalkExplainerAdStill>>, TError,RegenerateChalkExplainerAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateChalkExplainerAdStill>>, TError,RegenerateChalkExplainerAdStillMutationVariables, TContext> => {

const mutationKey = getRegenerateChalkExplainerAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateChalkExplainerAdStill>>, RegenerateChalkExplainerAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateChalkExplainerAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateChalkExplainerAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateChalkExplainerAdStill>>>

    export type RegenerateChalkExplainerAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateChalkExplainerAdStillMutationVariables = {teamId: string;brandId: string;name: 'board0' | 'end_a' | 'end_b' | 'end_c' | 'end_card'}

    /**
 * @summary Regenerate Chalk Explainer Ad Still
 */
export const useRegenerateChalkExplainerAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateChalkExplainerAdStill>>, TError,RegenerateChalkExplainerAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateChalkExplainerAdStill>>,
        TError,
        RegenerateChalkExplainerAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateChalkExplainerAdStillMutationOptions(options), queryClient);
    }
    export const getResetClaymationAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Claymation Ad Draft
 */
export const resetClaymationAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<ClaymationAdDraft> => {

  return apiRequest<ClaymationAdDraft>(getResetClaymationAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetClaymationAdDraftMutationKey = () => ['resetClaymationAdDraft'] as const;

export const getResetClaymationAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetClaymationAdDraft>>, TError,ResetClaymationAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetClaymationAdDraft>>, TError,ResetClaymationAdDraftMutationVariables, TContext> => {

const mutationKey = getResetClaymationAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetClaymationAdDraft>>, ResetClaymationAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetClaymationAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetClaymationAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetClaymationAdDraft>>>

    export type ResetClaymationAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetClaymationAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Claymation Ad Draft
 */
export const useResetClaymationAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetClaymationAdDraft>>, TError,ResetClaymationAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetClaymationAdDraft>>,
        TError,
        ResetClaymationAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetClaymationAdDraftMutationOptions(options), queryClient);
    }
    export const getGetClaymationAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Claymation Ad Draft
 */
export const getClaymationAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<ClaymationAdDraft> => {

  return apiRequest<ClaymationAdDraft>(getGetClaymationAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClaymationAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft`
    ] as const;
    }


export const getGetClaymationAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getClaymationAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaymationAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClaymationAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClaymationAdDraft>>> = ({ signal }) => getClaymationAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClaymationAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClaymationAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getClaymationAdDraft>>>
export type GetClaymationAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetClaymationAdDraft<TData = Awaited<ReturnType<typeof getClaymationAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaymationAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClaymationAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getClaymationAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClaymationAdDraft<TData = Awaited<ReturnType<typeof getClaymationAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaymationAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClaymationAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getClaymationAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClaymationAdDraft<TData = Awaited<ReturnType<typeof getClaymationAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaymationAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Claymation Ad Draft
 */

export function useGetClaymationAdDraft<TData = Awaited<ReturnType<typeof getClaymationAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClaymationAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClaymationAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteClaymationAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft`
}

/**
 * The form as it stands and its script as edited, what is off in it checked again
 * (`script_problems`). `TEMPLATE_DRAFT_LOCKED` (409) while a step works or once the script
 * is approved, as live locks the form.
 * @summary Write Claymation Ad Draft
 */
export const writeClaymationAdDraft = async (teamId: string,
    brandId: string,
    claymationAdDraftWrite: ClaymationAdDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<ClaymationAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<ClaymationAdDraft>(getWriteClaymationAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(claymationAdDraftWrite)
  }
);}





export const getWriteClaymationAdDraftMutationKey = () => ['writeClaymationAdDraft'] as const;

export const getWriteClaymationAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeClaymationAdDraft>>, TError,WriteClaymationAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeClaymationAdDraft>>, TError,WriteClaymationAdDraftMutationVariables, TContext> => {

const mutationKey = getWriteClaymationAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeClaymationAdDraft>>, WriteClaymationAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeClaymationAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteClaymationAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeClaymationAdDraft>>>
    export type WriteClaymationAdDraftMutationBody = ClaymationAdDraftWrite
    export type WriteClaymationAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteClaymationAdDraftMutationVariables = {teamId: string;brandId: string;data: ClaymationAdDraftWrite}

    /**
 * @summary Write Claymation Ad Draft
 */
export const useWriteClaymationAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeClaymationAdDraft>>, TError,WriteClaymationAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeClaymationAdDraft>>,
        TError,
        WriteClaymationAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteClaymationAdDraftMutationOptions(options), queryClient);
    }
    export const getApproveClaymationAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft/approve`
}

/**
 * Live's Approve script: a narrator (422 at `inputs.narrator`) and live's gate on the
 * script (422 at `script` with live's words), then the script approved, the stage the
 * voice's, and three takes of the voiceover, each made, heard in English and checked.
 * @summary Approve Claymation Ad Script
 */
export const approveClaymationAdScript = async (teamId: string,
    brandId: string,
    claymationAdScriptApproval: ClaymationAdScriptApproval, options?: Parameters<typeof apiRequest>[1]): Promise<ClaymationAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<ClaymationAdDraft>(getApproveClaymationAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(claymationAdScriptApproval)
  }
);}





export const getApproveClaymationAdScriptMutationKey = () => ['approveClaymationAdScript'] as const;

export const getApproveClaymationAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveClaymationAdScript>>, TError,ApproveClaymationAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveClaymationAdScript>>, TError,ApproveClaymationAdScriptMutationVariables, TContext> => {

const mutationKey = getApproveClaymationAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveClaymationAdScript>>, ApproveClaymationAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveClaymationAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveClaymationAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveClaymationAdScript>>>
    export type ApproveClaymationAdScriptMutationBody = ClaymationAdScriptApproval
    export type ApproveClaymationAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveClaymationAdScriptMutationVariables = {teamId: string;brandId: string;data: ClaymationAdScriptApproval}

    /**
 * @summary Approve Claymation Ad Script
 */
export const useApproveClaymationAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveClaymationAdScript>>, TError,ApproveClaymationAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveClaymationAdScript>>,
        TError,
        ApproveClaymationAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveClaymationAdScriptMutationOptions(options), queryClient);
    }
    export const getApproveClaymationAdVoiceUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft/approve-voice`
}

/**
 * Live's Approve voice: the picked take's shot plan (422 at `take` with live's words for
 * a take not made or not checked, one with a line not heard, or one the shots do not fit),
 * the stage the storyboard's. `TEMPLATE_DRAFT_LOCKED` (409) outside the voice or while a
 * take works.
 * @summary Approve Claymation Ad Voice
 */
export const approveClaymationAdVoice = async (teamId: string,
    brandId: string,
    claymationAdVoiceApproval: ClaymationAdVoiceApproval, options?: Parameters<typeof apiRequest>[1]): Promise<ClaymationAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<ClaymationAdDraft>(getApproveClaymationAdVoiceUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(claymationAdVoiceApproval)
  }
);}





export const getApproveClaymationAdVoiceMutationKey = () => ['approveClaymationAdVoice'] as const;

export const getApproveClaymationAdVoiceMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveClaymationAdVoice>>, TError,ApproveClaymationAdVoiceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveClaymationAdVoice>>, TError,ApproveClaymationAdVoiceMutationVariables, TContext> => {

const mutationKey = getApproveClaymationAdVoiceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveClaymationAdVoice>>, ApproveClaymationAdVoiceMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveClaymationAdVoice(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveClaymationAdVoiceMutationResult = NonNullable<Awaited<ReturnType<typeof approveClaymationAdVoice>>>
    export type ApproveClaymationAdVoiceMutationBody = ClaymationAdVoiceApproval
    export type ApproveClaymationAdVoiceMutationError = ErrorType<ErrorEnvelope>
    export type ApproveClaymationAdVoiceMutationVariables = {teamId: string;brandId: string;data: ClaymationAdVoiceApproval}

    /**
 * @summary Approve Claymation Ad Voice
 */
export const useApproveClaymationAdVoice = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveClaymationAdVoice>>, TError,ApproveClaymationAdVoiceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveClaymationAdVoice>>,
        TError,
        ApproveClaymationAdVoiceMutationVariables,
        TContext
      > => {
      return useMutation(getApproveClaymationAdVoiceMutationOptions(options), queryClient);
    }
    export const getBackToClaymationAdVoiceUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft/back-to-voice`
}

/**
 * Live's Back to voice: the plan forgotten, the takes kept. `TEMPLATE_DRAFT_LOCKED`
 * (409) outside the storyboard.
 * @summary Back To Claymation Ad Voice
 */
export const backToClaymationAdVoice = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<ClaymationAdDraft> => {

  return apiRequest<ClaymationAdDraft>(getBackToClaymationAdVoiceUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBackToClaymationAdVoiceMutationKey = () => ['backToClaymationAdVoice'] as const;

export const getBackToClaymationAdVoiceMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToClaymationAdVoice>>, TError,BackToClaymationAdVoiceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof backToClaymationAdVoice>>, TError,BackToClaymationAdVoiceMutationVariables, TContext> => {

const mutationKey = getBackToClaymationAdVoiceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof backToClaymationAdVoice>>, BackToClaymationAdVoiceMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  backToClaymationAdVoice(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BackToClaymationAdVoiceMutationResult = NonNullable<Awaited<ReturnType<typeof backToClaymationAdVoice>>>

    export type BackToClaymationAdVoiceMutationError = ErrorType<ErrorEnvelope>
    export type BackToClaymationAdVoiceMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Back To Claymation Ad Voice
 */
export const useBackToClaymationAdVoice = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToClaymationAdVoice>>, TError,BackToClaymationAdVoiceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof backToClaymationAdVoice>>,
        TError,
        BackToClaymationAdVoiceMutationVariables,
        TContext
      > => {
      return useMutation(getBackToClaymationAdVoiceMutationOptions(options), queryClient);
    }
    export const getRetryClaymationAdShotDirectorUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft/retry-shot-director`
}

/**
 * Live's Retry the shot director, once it failed for good: a new ask of three tries,
 * then the stills its spec needs, drawn anew. `TEMPLATE_DRAFT_LOCKED` (409) before the
 * script is approved, unless the shot director failed, or while anything works.
 * @summary Retry Claymation Ad Shot Director
 */
export const retryClaymationAdShotDirector = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<ClaymationAdDraft> => {

  return apiRequest<ClaymationAdDraft>(getRetryClaymationAdShotDirectorUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryClaymationAdShotDirectorMutationKey = () => ['retryClaymationAdShotDirector'] as const;

export const getRetryClaymationAdShotDirectorMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryClaymationAdShotDirector>>, TError,RetryClaymationAdShotDirectorMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof retryClaymationAdShotDirector>>, TError,RetryClaymationAdShotDirectorMutationVariables, TContext> => {

const mutationKey = getRetryClaymationAdShotDirectorMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryClaymationAdShotDirector>>, RetryClaymationAdShotDirectorMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  retryClaymationAdShotDirector(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryClaymationAdShotDirectorMutationResult = NonNullable<Awaited<ReturnType<typeof retryClaymationAdShotDirector>>>

    export type RetryClaymationAdShotDirectorMutationError = ErrorType<ErrorEnvelope>
    export type RetryClaymationAdShotDirectorMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Retry Claymation Ad Shot Director
 */
export const useRetryClaymationAdShotDirector = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryClaymationAdShotDirector>>, TError,RetryClaymationAdShotDirectorMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryClaymationAdShotDirector>>,
        TError,
        RetryClaymationAdShotDirectorMutationVariables,
        TContext
      > => {
      return useMutation(getRetryClaymationAdShotDirectorMutationOptions(options), queryClient);
    }
    export const getWriteClaymationAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft/script`
}

/**
 * Live's wand: an uploaded packshot with no name or no text typed is read first
 * (`pack_director`; an unreadable one sets `pack_warning`), then the script director, up
 * to three tries each told the last one's problems; the try with the fewest is kept, with
 * live's words when it is still off (`script_warning`, `script_problems`).
 * @summary Write Claymation Ad Script
 */
export const writeClaymationAdScript = async (teamId: string,
    brandId: string,
    claymationAdScriptAsk: ClaymationAdScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<ClaymationAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<ClaymationAdDraft>(getWriteClaymationAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(claymationAdScriptAsk)
  }
);}





export const getWriteClaymationAdScriptMutationKey = () => ['writeClaymationAdScript'] as const;

export const getWriteClaymationAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeClaymationAdScript>>, TError,WriteClaymationAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeClaymationAdScript>>, TError,WriteClaymationAdScriptMutationVariables, TContext> => {

const mutationKey = getWriteClaymationAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeClaymationAdScript>>, WriteClaymationAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeClaymationAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteClaymationAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeClaymationAdScript>>>
    export type WriteClaymationAdScriptMutationBody = ClaymationAdScriptAsk
    export type WriteClaymationAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteClaymationAdScriptMutationVariables = {teamId: string;brandId: string;data: ClaymationAdScriptAsk}

    /**
 * @summary Write Claymation Ad Script
 */
export const useWriteClaymationAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeClaymationAdScript>>, TError,WriteClaymationAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeClaymationAdScript>>,
        TError,
        WriteClaymationAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteClaymationAdScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateClaymationAdStillUrl = (teamId: string,
    brandId: string,
    name: 'end_card' | 'sheet_character' | 'product_sheet' | 'plate_s1' | 'plate_s2' | 'plate_s3' | 'shot_1' | 'shot_2' | 'shot_3' | 'shot_4' | 'shot_5' | 'shot_6' | 'shot_7' | 'shot_8' | 'shot_1_turn' | 'shot_2_turn' | 'shot_3_turn' | 'shot_4_turn' | 'shot_5_turn' | 'shot_6_turn' | 'shot_7_turn' | 'shot_8_turn',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft/stills/${name}/regenerate`
}

/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image as
 * the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the script is approved, for a still
 * the storyboard lacks (any but the end card before the spec), or while anything works,
 * the takes included.
 * @summary Regenerate Claymation Ad Still
 */
export const regenerateClaymationAdStill = async (teamId: string,
    brandId: string,
    name: 'end_card' | 'sheet_character' | 'product_sheet' | 'plate_s1' | 'plate_s2' | 'plate_s3' | 'shot_1' | 'shot_2' | 'shot_3' | 'shot_4' | 'shot_5' | 'shot_6' | 'shot_7' | 'shot_8' | 'shot_1_turn' | 'shot_2_turn' | 'shot_3_turn' | 'shot_4_turn' | 'shot_5_turn' | 'shot_6_turn' | 'shot_7_turn' | 'shot_8_turn', options?: Parameters<typeof apiRequest>[1]): Promise<ClaymationAdDraft> => {

  return apiRequest<ClaymationAdDraft>(getRegenerateClaymationAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateClaymationAdStillMutationKey = () => ['regenerateClaymationAdStill'] as const;

export const getRegenerateClaymationAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateClaymationAdStill>>, TError,RegenerateClaymationAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateClaymationAdStill>>, TError,RegenerateClaymationAdStillMutationVariables, TContext> => {

const mutationKey = getRegenerateClaymationAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateClaymationAdStill>>, RegenerateClaymationAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateClaymationAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateClaymationAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateClaymationAdStill>>>

    export type RegenerateClaymationAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateClaymationAdStillMutationVariables = {teamId: string;brandId: string;name: 'end_card' | 'sheet_character' | 'product_sheet' | 'plate_s1' | 'plate_s2' | 'plate_s3' | 'shot_1' | 'shot_2' | 'shot_3' | 'shot_4' | 'shot_5' | 'shot_6' | 'shot_7' | 'shot_8' | 'shot_1_turn' | 'shot_2_turn' | 'shot_3_turn' | 'shot_4_turn' | 'shot_5_turn' | 'shot_6_turn' | 'shot_7_turn' | 'shot_8_turn'}

    /**
 * @summary Regenerate Claymation Ad Still
 */
export const useRegenerateClaymationAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateClaymationAdStill>>, TError,RegenerateClaymationAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateClaymationAdStill>>,
        TError,
        RegenerateClaymationAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateClaymationAdStillMutationOptions(options), queryClient);
    }
    export const getAddClaymationAdTakeUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/claymation-ad/draft/takes`
}

/**
 * Live's "Add a take": one more take of the same text; at six, live's note instead.
 * `TEMPLATE_DRAFT_LOCKED` (409) outside the voice or while a take works.
 * @summary Add Claymation Ad Take
 */
export const addClaymationAdTake = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<ClaymationAdDraft> => {

  return apiRequest<ClaymationAdDraft>(getAddClaymationAdTakeUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAddClaymationAdTakeMutationKey = () => ['addClaymationAdTake'] as const;

export const getAddClaymationAdTakeMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addClaymationAdTake>>, TError,AddClaymationAdTakeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof addClaymationAdTake>>, TError,AddClaymationAdTakeMutationVariables, TContext> => {

const mutationKey = getAddClaymationAdTakeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addClaymationAdTake>>, AddClaymationAdTakeMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  addClaymationAdTake(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddClaymationAdTakeMutationResult = NonNullable<Awaited<ReturnType<typeof addClaymationAdTake>>>

    export type AddClaymationAdTakeMutationError = ErrorType<ErrorEnvelope>
    export type AddClaymationAdTakeMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Add Claymation Ad Take
 */
export const useAddClaymationAdTake = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addClaymationAdTake>>, TError,AddClaymationAdTakeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addClaymationAdTake>>,
        TError,
        AddClaymationAdTakeMutationVariables,
        TContext
      > => {
      return useMutation(getAddClaymationAdTakeMutationOptions(options), queryClient);
    }
    export const getResetFlatCartoonDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/flat-cartoon/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Flat Cartoon Draft
 */
export const resetFlatCartoonDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<FlatCartoonDraft> => {

  return apiRequest<FlatCartoonDraft>(getResetFlatCartoonDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetFlatCartoonDraftMutationKey = () => ['resetFlatCartoonDraft'] as const;

export const getResetFlatCartoonDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetFlatCartoonDraft>>, TError,ResetFlatCartoonDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetFlatCartoonDraft>>, TError,ResetFlatCartoonDraftMutationVariables, TContext> => {

const mutationKey = getResetFlatCartoonDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetFlatCartoonDraft>>, ResetFlatCartoonDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetFlatCartoonDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetFlatCartoonDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetFlatCartoonDraft>>>

    export type ResetFlatCartoonDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetFlatCartoonDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Flat Cartoon Draft
 */
export const useResetFlatCartoonDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetFlatCartoonDraft>>, TError,ResetFlatCartoonDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetFlatCartoonDraft>>,
        TError,
        ResetFlatCartoonDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetFlatCartoonDraftMutationOptions(options), queryClient);
    }
    export const getGetFlatCartoonDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/flat-cartoon/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Flat Cartoon Draft
 */
export const getFlatCartoonDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<FlatCartoonDraft> => {

  return apiRequest<FlatCartoonDraft>(getGetFlatCartoonDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFlatCartoonDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/flat-cartoon/draft`
    ] as const;
    }


export const getGetFlatCartoonDraftQueryOptions = <TData = Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFlatCartoonDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFlatCartoonDraft>>> = ({ signal }) => getFlatCartoonDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFlatCartoonDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getFlatCartoonDraft>>>
export type GetFlatCartoonDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetFlatCartoonDraft<TData = Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFlatCartoonDraft>>,
          TError,
          Awaited<ReturnType<typeof getFlatCartoonDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFlatCartoonDraft<TData = Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFlatCartoonDraft>>,
          TError,
          Awaited<ReturnType<typeof getFlatCartoonDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFlatCartoonDraft<TData = Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Flat Cartoon Draft
 */

export function useGetFlatCartoonDraft<TData = Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFlatCartoonDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFlatCartoonDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteFlatCartoonDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/flat-cartoon/draft`
}

/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved.
 * @summary Write Flat Cartoon Draft
 */
export const writeFlatCartoonDraft = async (teamId: string,
    brandId: string,
    flatCartoonDraftWrite: FlatCartoonDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<FlatCartoonDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FlatCartoonDraft>(getWriteFlatCartoonDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(flatCartoonDraftWrite)
  }
);}





export const getWriteFlatCartoonDraftMutationKey = () => ['writeFlatCartoonDraft'] as const;

export const getWriteFlatCartoonDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeFlatCartoonDraft>>, TError,WriteFlatCartoonDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeFlatCartoonDraft>>, TError,WriteFlatCartoonDraftMutationVariables, TContext> => {

const mutationKey = getWriteFlatCartoonDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeFlatCartoonDraft>>, WriteFlatCartoonDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeFlatCartoonDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteFlatCartoonDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeFlatCartoonDraft>>>
    export type WriteFlatCartoonDraftMutationBody = FlatCartoonDraftWrite
    export type WriteFlatCartoonDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteFlatCartoonDraftMutationVariables = {teamId: string;brandId: string;data: FlatCartoonDraftWrite}

    /**
 * @summary Write Flat Cartoon Draft
 */
export const useWriteFlatCartoonDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeFlatCartoonDraft>>, TError,WriteFlatCartoonDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeFlatCartoonDraft>>,
        TError,
        WriteFlatCartoonDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteFlatCartoonDraftMutationOptions(options), queryClient);
    }
    export const getApproveFlatCartoonScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/flat-cartoon/draft/approve`
}

/**
 * Approve script: six lines in the beats' order, the prescription's opening, a hex color
 * in every lock, no line past 10 s and 45 to 80 words (422 at `script` in its words); then
 * the stills, the two character sheets first, each other still once those it is drawn
 * from are done.
 * @summary Approve Flat Cartoon Script
 */
export const approveFlatCartoonScript = async (teamId: string,
    brandId: string,
    flatCartoonApproval: FlatCartoonApproval, options?: Parameters<typeof apiRequest>[1]): Promise<FlatCartoonDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FlatCartoonDraft>(getApproveFlatCartoonScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(flatCartoonApproval)
  }
);}





export const getApproveFlatCartoonScriptMutationKey = () => ['approveFlatCartoonScript'] as const;

export const getApproveFlatCartoonScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveFlatCartoonScript>>, TError,ApproveFlatCartoonScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveFlatCartoonScript>>, TError,ApproveFlatCartoonScriptMutationVariables, TContext> => {

const mutationKey = getApproveFlatCartoonScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveFlatCartoonScript>>, ApproveFlatCartoonScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveFlatCartoonScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveFlatCartoonScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveFlatCartoonScript>>>
    export type ApproveFlatCartoonScriptMutationBody = FlatCartoonApproval
    export type ApproveFlatCartoonScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveFlatCartoonScriptMutationVariables = {teamId: string;brandId: string;data: FlatCartoonApproval}

    /**
 * @summary Approve Flat Cartoon Script
 */
export const useApproveFlatCartoonScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveFlatCartoonScript>>, TError,ApproveFlatCartoonScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveFlatCartoonScript>>,
        TError,
        ApproveFlatCartoonScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveFlatCartoonScriptMutationOptions(options), queryClient);
    }
    export const getWriteFlatCartoonScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/flat-cartoon/draft/script`
}

/**
 * Generate script: the brand as said is needed (422 at `inputs.brand`); an uploaded
 * packshot with no name or no text typed is read first (`pack_director`; an unreadable one
 * sets `pack_warning`), then the script director. A script Approve would refuse is redone
 * once, then kept with that problem (`script_problems`).
 * @summary Write Flat Cartoon Script
 */
export const writeFlatCartoonScript = async (teamId: string,
    brandId: string,
    flatCartoonScriptAsk: FlatCartoonScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<FlatCartoonDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FlatCartoonDraft>(getWriteFlatCartoonScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(flatCartoonScriptAsk)
  }
);}





export const getWriteFlatCartoonScriptMutationKey = () => ['writeFlatCartoonScript'] as const;

export const getWriteFlatCartoonScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeFlatCartoonScript>>, TError,WriteFlatCartoonScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeFlatCartoonScript>>, TError,WriteFlatCartoonScriptMutationVariables, TContext> => {

const mutationKey = getWriteFlatCartoonScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeFlatCartoonScript>>, WriteFlatCartoonScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeFlatCartoonScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteFlatCartoonScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeFlatCartoonScript>>>
    export type WriteFlatCartoonScriptMutationBody = FlatCartoonScriptAsk
    export type WriteFlatCartoonScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteFlatCartoonScriptMutationVariables = {teamId: string;brandId: string;data: FlatCartoonScriptAsk}

    /**
 * @summary Write Flat Cartoon Script
 */
export const useWriteFlatCartoonScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeFlatCartoonScript>>, TError,WriteFlatCartoonScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeFlatCartoonScript>>,
        TError,
        WriteFlatCartoonScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteFlatCartoonScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateFlatCartoonStillUrl = (teamId: string,
    brandId: string,
    name: 'host_sheet' | 'caller_sheet' | 'studio' | 'car' | 'metaphor' | 'prescribe' | 'closeup' | 'hero',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/flat-cartoon/draft/stills/${name}/regenerate`
}

/**
 * Regenerate a still: it and every still drawn from it drawn again, each a paid image
 * as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the stills or while anything
 * works.
 * @summary Regenerate Flat Cartoon Still
 */
export const regenerateFlatCartoonStill = async (teamId: string,
    brandId: string,
    name: 'host_sheet' | 'caller_sheet' | 'studio' | 'car' | 'metaphor' | 'prescribe' | 'closeup' | 'hero', options?: Parameters<typeof apiRequest>[1]): Promise<FlatCartoonDraft> => {

  return apiRequest<FlatCartoonDraft>(getRegenerateFlatCartoonStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateFlatCartoonStillMutationKey = () => ['regenerateFlatCartoonStill'] as const;

export const getRegenerateFlatCartoonStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateFlatCartoonStill>>, TError,RegenerateFlatCartoonStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateFlatCartoonStill>>, TError,RegenerateFlatCartoonStillMutationVariables, TContext> => {

const mutationKey = getRegenerateFlatCartoonStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateFlatCartoonStill>>, RegenerateFlatCartoonStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateFlatCartoonStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateFlatCartoonStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateFlatCartoonStill>>>

    export type RegenerateFlatCartoonStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateFlatCartoonStillMutationVariables = {teamId: string;brandId: string;name: 'host_sheet' | 'caller_sheet' | 'studio' | 'car' | 'metaphor' | 'prescribe' | 'closeup' | 'hero'}

    /**
 * @summary Regenerate Flat Cartoon Still
 */
export const useRegenerateFlatCartoonStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateFlatCartoonStill>>, TError,RegenerateFlatCartoonStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateFlatCartoonStill>>,
        TError,
        RegenerateFlatCartoonStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateFlatCartoonStillMutationOptions(options), queryClient);
    }
    export const getResetGreenScreenAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/green-screen-yapper-ad/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Green Screen Ad Draft
 */
export const resetGreenScreenAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<GreenScreenDraft> => {

  return apiRequest<GreenScreenDraft>(getResetGreenScreenAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetGreenScreenAdDraftMutationKey = () => ['resetGreenScreenAdDraft'] as const;

export const getResetGreenScreenAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetGreenScreenAdDraft>>, TError,ResetGreenScreenAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetGreenScreenAdDraft>>, TError,ResetGreenScreenAdDraftMutationVariables, TContext> => {

const mutationKey = getResetGreenScreenAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetGreenScreenAdDraft>>, ResetGreenScreenAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetGreenScreenAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetGreenScreenAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetGreenScreenAdDraft>>>

    export type ResetGreenScreenAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetGreenScreenAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Green Screen Ad Draft
 */
export const useResetGreenScreenAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetGreenScreenAdDraft>>, TError,ResetGreenScreenAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetGreenScreenAdDraft>>,
        TError,
        ResetGreenScreenAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetGreenScreenAdDraftMutationOptions(options), queryClient);
    }
    export const getGetGreenScreenAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/green-screen-yapper-ad/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Green Screen Ad Draft
 */
export const getGreenScreenAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<GreenScreenDraft> => {

  return apiRequest<GreenScreenDraft>(getGetGreenScreenAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGreenScreenAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/green-screen-yapper-ad/draft`
    ] as const;
    }


export const getGetGreenScreenAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGreenScreenAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGreenScreenAdDraft>>> = ({ signal }) => getGreenScreenAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGreenScreenAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getGreenScreenAdDraft>>>
export type GetGreenScreenAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetGreenScreenAdDraft<TData = Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGreenScreenAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getGreenScreenAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGreenScreenAdDraft<TData = Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGreenScreenAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getGreenScreenAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGreenScreenAdDraft<TData = Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Green Screen Ad Draft
 */

export function useGetGreenScreenAdDraft<TData = Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGreenScreenAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGreenScreenAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteGreenScreenAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/green-screen-yapper-ad/draft`
}

/**
 * The form as it stands and its script as edited, what is off in it checked again on
 * the picked clip model (`script_problems`). `TEMPLATE_DRAFT_LOCKED` (409) while the
 * director works, as live locks the form.
 * @summary Write Green Screen Ad Draft
 */
export const writeGreenScreenAdDraft = async (teamId: string,
    brandId: string,
    greenScreenDraftWrite: GreenScreenDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<GreenScreenDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<GreenScreenDraft>(getWriteGreenScreenAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(greenScreenDraftWrite)
  }
);}





export const getWriteGreenScreenAdDraftMutationKey = () => ['writeGreenScreenAdDraft'] as const;

export const getWriteGreenScreenAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeGreenScreenAdDraft>>, TError,WriteGreenScreenAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeGreenScreenAdDraft>>, TError,WriteGreenScreenAdDraftMutationVariables, TContext> => {

const mutationKey = getWriteGreenScreenAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeGreenScreenAdDraft>>, WriteGreenScreenAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeGreenScreenAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteGreenScreenAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeGreenScreenAdDraft>>>
    export type WriteGreenScreenAdDraftMutationBody = GreenScreenDraftWrite
    export type WriteGreenScreenAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteGreenScreenAdDraftMutationVariables = {teamId: string;brandId: string;data: GreenScreenDraftWrite}

    /**
 * @summary Write Green Screen Ad Draft
 */
export const useWriteGreenScreenAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeGreenScreenAdDraft>>, TError,WriteGreenScreenAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeGreenScreenAdDraft>>,
        TError,
        WriteGreenScreenAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteGreenScreenAdDraftMutationOptions(options), queryClient);
    }
    export const getApproveGreenScreenAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/green-screen-yapper-ad/draft/approve`
}

/**
 * Live's "Approve script": approval 1's issues refused at `script` in live's words (422);
 * then the images: the creator (from the look, or recreated from the picked person) and
 * the card at once, the three poses from the creator. Each card is read back against the
 * approved title and lines, up to three; the first that reads exactly is kept, else the
 * one with the fewest problems (`card_check`).
 * @summary Approve Green Screen Ad Script
 */
export const approveGreenScreenAdScript = async (teamId: string,
    brandId: string,
    greenScreenApproval: GreenScreenApproval, options?: Parameters<typeof apiRequest>[1]): Promise<GreenScreenDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<GreenScreenDraft>(getApproveGreenScreenAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(greenScreenApproval)
  }
);}





export const getApproveGreenScreenAdScriptMutationKey = () => ['approveGreenScreenAdScript'] as const;

export const getApproveGreenScreenAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveGreenScreenAdScript>>, TError,ApproveGreenScreenAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveGreenScreenAdScript>>, TError,ApproveGreenScreenAdScriptMutationVariables, TContext> => {

const mutationKey = getApproveGreenScreenAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveGreenScreenAdScript>>, ApproveGreenScreenAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveGreenScreenAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveGreenScreenAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveGreenScreenAdScript>>>
    export type ApproveGreenScreenAdScriptMutationBody = GreenScreenApproval
    export type ApproveGreenScreenAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveGreenScreenAdScriptMutationVariables = {teamId: string;brandId: string;data: GreenScreenApproval}

    /**
 * @summary Approve Green Screen Ad Script
 */
export const useApproveGreenScreenAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveGreenScreenAdScript>>, TError,ApproveGreenScreenAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveGreenScreenAdScript>>,
        TError,
        ApproveGreenScreenAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveGreenScreenAdScriptMutationOptions(options), queryClient);
    }
    export const getApproveGreenScreenAdRevisionUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/green-screen-yapper-ad/draft/approve-revision`
}

/**
 * Live's "Approve and generate final video" while revising: approval 1's issues, then a
 * change outside the refused clips' lines and beats, refused at `script` in live's words
 * (422); the images kept. The form then starts the run with the kept clips' `takes`.
 * `TEMPLATE_DRAFT_LOCKED` (409) unless revising, or while anything works.
 * @summary Approve Green Screen Ad Revision
 */
export const approveGreenScreenAdRevision = async (teamId: string,
    brandId: string,
    greenScreenApproval: GreenScreenApproval, options?: Parameters<typeof apiRequest>[1]): Promise<GreenScreenDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<GreenScreenDraft>(getApproveGreenScreenAdRevisionUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(greenScreenApproval)
  }
);}





export const getApproveGreenScreenAdRevisionMutationKey = () => ['approveGreenScreenAdRevision'] as const;

export const getApproveGreenScreenAdRevisionMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveGreenScreenAdRevision>>, TError,ApproveGreenScreenAdRevisionMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveGreenScreenAdRevision>>, TError,ApproveGreenScreenAdRevisionMutationVariables, TContext> => {

const mutationKey = getApproveGreenScreenAdRevisionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveGreenScreenAdRevision>>, ApproveGreenScreenAdRevisionMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveGreenScreenAdRevision(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveGreenScreenAdRevisionMutationResult = NonNullable<Awaited<ReturnType<typeof approveGreenScreenAdRevision>>>
    export type ApproveGreenScreenAdRevisionMutationBody = GreenScreenApproval
    export type ApproveGreenScreenAdRevisionMutationError = ErrorType<ErrorEnvelope>
    export type ApproveGreenScreenAdRevisionMutationVariables = {teamId: string;brandId: string;data: GreenScreenApproval}

    /**
 * @summary Approve Green Screen Ad Revision
 */
export const useApproveGreenScreenAdRevision = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveGreenScreenAdRevision>>, TError,ApproveGreenScreenAdRevisionMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveGreenScreenAdRevision>>,
        TError,
        ApproveGreenScreenAdRevisionMutationVariables,
        TContext
      > => {
      return useMutation(getApproveGreenScreenAdRevisionMutationOptions(options), queryClient);
    }
    export const getBackToGreenScreenAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/green-screen-yapper-ad/draft/back-to-script`
}

/**
 * Live's "Back to script": every image forgotten, the script open again.
 * `TEMPLATE_DRAFT_LOCKED` (409) before approval or while anything works.
 * @summary Back To Green Screen Ad Script
 */
export const backToGreenScreenAdScript = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<GreenScreenDraft> => {

  return apiRequest<GreenScreenDraft>(getBackToGreenScreenAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBackToGreenScreenAdScriptMutationKey = () => ['backToGreenScreenAdScript'] as const;

export const getBackToGreenScreenAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToGreenScreenAdScript>>, TError,BackToGreenScreenAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof backToGreenScreenAdScript>>, TError,BackToGreenScreenAdScriptMutationVariables, TContext> => {

const mutationKey = getBackToGreenScreenAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof backToGreenScreenAdScript>>, BackToGreenScreenAdScriptMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  backToGreenScreenAdScript(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BackToGreenScreenAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof backToGreenScreenAdScript>>>

    export type BackToGreenScreenAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type BackToGreenScreenAdScriptMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Back To Green Screen Ad Script
 */
export const useBackToGreenScreenAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToGreenScreenAdScript>>, TError,BackToGreenScreenAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof backToGreenScreenAdScript>>,
        TError,
        BackToGreenScreenAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getBackToGreenScreenAdScriptMutationOptions(options), queryClient);
    }
    export const getReviseGreenScreenAdClipsUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/green-screen-yapper-ad/draft/revise`
}

/**
 * Live's Revise, after a run whose video model refused a talking clip (the draft's
 * `run.refused`): the script open again with only those clips' lines and beats to change,
 * the images and the other clips kept. `TEMPLATE_DRAFT_LOCKED` (409) with no such run,
 * before approval or while anything works.
 * @summary Revise Green Screen Ad Clips
 */
export const reviseGreenScreenAdClips = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<GreenScreenDraft> => {

  return apiRequest<GreenScreenDraft>(getReviseGreenScreenAdClipsUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getReviseGreenScreenAdClipsMutationKey = () => ['reviseGreenScreenAdClips'] as const;

export const getReviseGreenScreenAdClipsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviseGreenScreenAdClips>>, TError,ReviseGreenScreenAdClipsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof reviseGreenScreenAdClips>>, TError,ReviseGreenScreenAdClipsMutationVariables, TContext> => {

const mutationKey = getReviseGreenScreenAdClipsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reviseGreenScreenAdClips>>, ReviseGreenScreenAdClipsMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  reviseGreenScreenAdClips(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReviseGreenScreenAdClipsMutationResult = NonNullable<Awaited<ReturnType<typeof reviseGreenScreenAdClips>>>

    export type ReviseGreenScreenAdClipsMutationError = ErrorType<ErrorEnvelope>
    export type ReviseGreenScreenAdClipsMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Revise Green Screen Ad Clips
 */
export const useReviseGreenScreenAdClips = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reviseGreenScreenAdClips>>, TError,ReviseGreenScreenAdClipsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof reviseGreenScreenAdClips>>,
        TError,
        ReviseGreenScreenAdClipsMutationVariables,
        TContext
      > => {
      return useMutation(getReviseGreenScreenAdClipsMutationOptions(options), queryClient);
    }
    export const getWriteGreenScreenAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/green-screen-yapper-ad/draft/script`
}

/**
 * Live's "Generate script": the script director, shown the packshot and the picked
 * person, up to three tries each told what the last one failed; the try with the fewest
 * problems is kept, with live's words when it is still off or its slogan was written from
 * the page (`script_warnings`, `script_problems`). A person not the team's ready picture,
 * or an actor that does not exist, is refused at `inputs.creator`.
 * @summary Write Green Screen Ad Script
 */
export const writeGreenScreenAdScript = async (teamId: string,
    brandId: string,
    greenScreenScriptAsk: GreenScreenScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<GreenScreenDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<GreenScreenDraft>(getWriteGreenScreenAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(greenScreenScriptAsk)
  }
);}





export const getWriteGreenScreenAdScriptMutationKey = () => ['writeGreenScreenAdScript'] as const;

export const getWriteGreenScreenAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeGreenScreenAdScript>>, TError,WriteGreenScreenAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeGreenScreenAdScript>>, TError,WriteGreenScreenAdScriptMutationVariables, TContext> => {

const mutationKey = getWriteGreenScreenAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeGreenScreenAdScript>>, WriteGreenScreenAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeGreenScreenAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteGreenScreenAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeGreenScreenAdScript>>>
    export type WriteGreenScreenAdScriptMutationBody = GreenScreenScriptAsk
    export type WriteGreenScreenAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteGreenScreenAdScriptMutationVariables = {teamId: string;brandId: string;data: GreenScreenScriptAsk}

    /**
 * @summary Write Green Screen Ad Script
 */
export const useWriteGreenScreenAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeGreenScreenAdScript>>, TError,WriteGreenScreenAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeGreenScreenAdScript>>,
        TError,
        WriteGreenScreenAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteGreenScreenAdScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateGreenScreenAdStillUrl = (teamId: string,
    brandId: string,
    name: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/green-screen-yapper-ad/draft/stills/${name}/regenerate`
}

/**
 * Live's ↻ on a still (`GreenScreenStillName`; any other name is not found): the
 * creator with the poses drawn from it, a pose alone, or the card's three tries again;
 * each a paid image as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before approval or
 * while anything works.
 * @summary Regenerate Green Screen Ad Still
 */
export const regenerateGreenScreenAdStill = async (teamId: string,
    brandId: string,
    name: string, options?: Parameters<typeof apiRequest>[1]): Promise<GreenScreenDraft> => {

  return apiRequest<GreenScreenDraft>(getRegenerateGreenScreenAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateGreenScreenAdStillMutationKey = () => ['regenerateGreenScreenAdStill'] as const;

export const getRegenerateGreenScreenAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateGreenScreenAdStill>>, TError,RegenerateGreenScreenAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateGreenScreenAdStill>>, TError,RegenerateGreenScreenAdStillMutationVariables, TContext> => {

const mutationKey = getRegenerateGreenScreenAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateGreenScreenAdStill>>, RegenerateGreenScreenAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateGreenScreenAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateGreenScreenAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateGreenScreenAdStill>>>

    export type RegenerateGreenScreenAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateGreenScreenAdStillMutationVariables = {teamId: string;brandId: string;name: string}

    /**
 * @summary Regenerate Green Screen Ad Still
 */
export const useRegenerateGreenScreenAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateGreenScreenAdStill>>, TError,RegenerateGreenScreenAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateGreenScreenAdStill>>,
        TError,
        RegenerateGreenScreenAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateGreenScreenAdStillMutationOptions(options), queryClient);
    }
    export const getResetGrwmDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/grwm/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Grwm Draft
 */
export const resetGrwmDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<GrwmDraft> => {

  return apiRequest<GrwmDraft>(getResetGrwmDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetGrwmDraftMutationKey = () => ['resetGrwmDraft'] as const;

export const getResetGrwmDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetGrwmDraft>>, TError,ResetGrwmDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetGrwmDraft>>, TError,ResetGrwmDraftMutationVariables, TContext> => {

const mutationKey = getResetGrwmDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetGrwmDraft>>, ResetGrwmDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetGrwmDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetGrwmDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetGrwmDraft>>>

    export type ResetGrwmDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetGrwmDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Grwm Draft
 */
export const useResetGrwmDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetGrwmDraft>>, TError,ResetGrwmDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetGrwmDraft>>,
        TError,
        ResetGrwmDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetGrwmDraftMutationOptions(options), queryClient);
    }
    export const getGetGrwmDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/grwm/draft`
}

/**
 * The member's draft, or an empty one with the playbook's approved locks written in:
 * what the form opens with.
 * @summary Get Grwm Draft
 */
export const getGrwmDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<GrwmDraft> => {

  return apiRequest<GrwmDraft>(getGetGrwmDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetGrwmDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/grwm/draft`
    ] as const;
    }


export const getGetGrwmDraftQueryOptions = <TData = Awaited<ReturnType<typeof getGrwmDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrwmDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetGrwmDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getGrwmDraft>>> = ({ signal }) => getGrwmDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getGrwmDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetGrwmDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getGrwmDraft>>>
export type GetGrwmDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetGrwmDraft<TData = Awaited<ReturnType<typeof getGrwmDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrwmDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGrwmDraft>>,
          TError,
          Awaited<ReturnType<typeof getGrwmDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGrwmDraft<TData = Awaited<ReturnType<typeof getGrwmDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrwmDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getGrwmDraft>>,
          TError,
          Awaited<ReturnType<typeof getGrwmDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetGrwmDraft<TData = Awaited<ReturnType<typeof getGrwmDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrwmDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Grwm Draft
 */

export function useGetGrwmDraft<TData = Awaited<ReturnType<typeof getGrwmDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getGrwmDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetGrwmDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteGrwmDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/grwm/draft`
}

/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * the director works or once the script is approved.
 * @summary Write Grwm Draft
 */
export const writeGrwmDraft = async (teamId: string,
    brandId: string,
    grwmDraftWrite: GrwmDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<GrwmDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<GrwmDraft>(getWriteGrwmDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grwmDraftWrite)
  }
);}





export const getWriteGrwmDraftMutationKey = () => ['writeGrwmDraft'] as const;

export const getWriteGrwmDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeGrwmDraft>>, TError,WriteGrwmDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeGrwmDraft>>, TError,WriteGrwmDraftMutationVariables, TContext> => {

const mutationKey = getWriteGrwmDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeGrwmDraft>>, WriteGrwmDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeGrwmDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteGrwmDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeGrwmDraft>>>
    export type WriteGrwmDraftMutationBody = GrwmDraftWrite
    export type WriteGrwmDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteGrwmDraftMutationVariables = {teamId: string;brandId: string;data: GrwmDraftWrite}

    /**
 * @summary Write Grwm Draft
 */
export const useWriteGrwmDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeGrwmDraft>>, TError,WriteGrwmDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeGrwmDraft>>,
        TError,
        WriteGrwmDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteGrwmDraftMutationOptions(options), queryClient);
    }
    export const getApproveGrwmScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/grwm/draft/approve`
}

/**
 * Approve script: its ten beats in order, each a line of at most 14 words, 50 to 95
 * words in all and an entryway action (422 at `script` with the reason); then the stills
 * from their roots, each as its sources are done.
 * @summary Approve Grwm Script
 */
export const approveGrwmScript = async (teamId: string,
    brandId: string,
    grwmApproval: GrwmApproval, options?: Parameters<typeof apiRequest>[1]): Promise<GrwmDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<GrwmDraft>(getApproveGrwmScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grwmApproval)
  }
);}





export const getApproveGrwmScriptMutationKey = () => ['approveGrwmScript'] as const;

export const getApproveGrwmScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveGrwmScript>>, TError,ApproveGrwmScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveGrwmScript>>, TError,ApproveGrwmScriptMutationVariables, TContext> => {

const mutationKey = getApproveGrwmScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveGrwmScript>>, ApproveGrwmScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveGrwmScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveGrwmScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveGrwmScript>>>
    export type ApproveGrwmScriptMutationBody = GrwmApproval
    export type ApproveGrwmScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveGrwmScriptMutationVariables = {teamId: string;brandId: string;data: GrwmApproval}

    /**
 * @summary Approve Grwm Script
 */
export const useApproveGrwmScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveGrwmScript>>, TError,ApproveGrwmScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveGrwmScript>>,
        TError,
        ApproveGrwmScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveGrwmScriptMutationOptions(options), queryClient);
    }
    export const getWriteGrwmScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/grwm/draft/script`
}

/**
 * Generate script: the director on the product, shown its picture. An answer missing a
 * beat is redone once, then fails (`problem`); a kept one carries what is still off
 * (`script_problems`).
 * @summary Write Grwm Script
 */
export const writeGrwmScript = async (teamId: string,
    brandId: string,
    grwmScriptAsk: GrwmScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<GrwmDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<GrwmDraft>(getWriteGrwmScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(grwmScriptAsk)
  }
);}





export const getWriteGrwmScriptMutationKey = () => ['writeGrwmScript'] as const;

export const getWriteGrwmScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeGrwmScript>>, TError,WriteGrwmScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeGrwmScript>>, TError,WriteGrwmScriptMutationVariables, TContext> => {

const mutationKey = getWriteGrwmScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeGrwmScript>>, WriteGrwmScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeGrwmScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteGrwmScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeGrwmScript>>>
    export type WriteGrwmScriptMutationBody = GrwmScriptAsk
    export type WriteGrwmScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteGrwmScriptMutationVariables = {teamId: string;brandId: string;data: GrwmScriptAsk}

    /**
 * @summary Write Grwm Script
 */
export const useWriteGrwmScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeGrwmScript>>, TError,WriteGrwmScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeGrwmScript>>,
        TError,
        WriteGrwmScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteGrwmScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateGrwmStillUrl = (teamId: string,
    brandId: string,
    name: 'img1' | 'img2c' | 'img3c' | 'img2' | 'img3' | 'dress' | 'body' | 'wear_front' | 'wear_side' | 'img4' | 'img5' | 'door' | 'img6s' | 'rest_plate' | 'img7r' | 'img8r',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/grwm/draft/stills/${name}/regenerate`
}

/**
 * ↻ on a still: it and every still drawn from it drawn again, each a paid image as the
 * first was. `TEMPLATE_DRAFT_LOCKED` (409) before the stills, or while anything works.
 * @summary Regenerate Grwm Still
 */
export const regenerateGrwmStill = async (teamId: string,
    brandId: string,
    name: 'img1' | 'img2c' | 'img3c' | 'img2' | 'img3' | 'dress' | 'body' | 'wear_front' | 'wear_side' | 'img4' | 'img5' | 'door' | 'img6s' | 'rest_plate' | 'img7r' | 'img8r', options?: Parameters<typeof apiRequest>[1]): Promise<GrwmDraft> => {

  return apiRequest<GrwmDraft>(getRegenerateGrwmStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateGrwmStillMutationKey = () => ['regenerateGrwmStill'] as const;

export const getRegenerateGrwmStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateGrwmStill>>, TError,RegenerateGrwmStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateGrwmStill>>, TError,RegenerateGrwmStillMutationVariables, TContext> => {

const mutationKey = getRegenerateGrwmStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateGrwmStill>>, RegenerateGrwmStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateGrwmStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateGrwmStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateGrwmStill>>>

    export type RegenerateGrwmStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateGrwmStillMutationVariables = {teamId: string;brandId: string;name: 'img1' | 'img2c' | 'img3c' | 'img2' | 'img3' | 'dress' | 'body' | 'wear_front' | 'wear_side' | 'img4' | 'img5' | 'door' | 'img6s' | 'rest_plate' | 'img7r' | 'img8r'}

    /**
 * @summary Regenerate Grwm Still
 */
export const useRegenerateGrwmStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateGrwmStill>>, TError,RegenerateGrwmStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateGrwmStill>>,
        TError,
        RegenerateGrwmStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateGrwmStillMutationOptions(options), queryClient);
    }
    export const getResetHotSeatAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/hot-seat/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Hot Seat Ad Draft
 */
export const resetHotSeatAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<TwoSpeakerDraft> => {

  return apiRequest<TwoSpeakerDraft>(getResetHotSeatAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetHotSeatAdDraftMutationKey = () => ['resetHotSeatAdDraft'] as const;

export const getResetHotSeatAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetHotSeatAdDraft>>, TError,ResetHotSeatAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetHotSeatAdDraft>>, TError,ResetHotSeatAdDraftMutationVariables, TContext> => {

const mutationKey = getResetHotSeatAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetHotSeatAdDraft>>, ResetHotSeatAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetHotSeatAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetHotSeatAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetHotSeatAdDraft>>>

    export type ResetHotSeatAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetHotSeatAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Hot Seat Ad Draft
 */
export const useResetHotSeatAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetHotSeatAdDraft>>, TError,ResetHotSeatAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetHotSeatAdDraft>>,
        TError,
        ResetHotSeatAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetHotSeatAdDraftMutationOptions(options), queryClient);
    }
    export const getGetHotSeatAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/hot-seat/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Hot Seat Ad Draft
 */
export const getHotSeatAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<TwoSpeakerDraft> => {

  return apiRequest<TwoSpeakerDraft>(getGetHotSeatAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetHotSeatAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/hot-seat/draft`
    ] as const;
    }


export const getGetHotSeatAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHotSeatAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHotSeatAdDraft>>> = ({ signal }) => getHotSeatAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHotSeatAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getHotSeatAdDraft>>>
export type GetHotSeatAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetHotSeatAdDraft<TData = Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHotSeatAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getHotSeatAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHotSeatAdDraft<TData = Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHotSeatAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getHotSeatAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHotSeatAdDraft<TData = Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Hot Seat Ad Draft
 */

export function useGetHotSeatAdDraft<TData = Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHotSeatAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHotSeatAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteHotSeatAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/hot-seat/draft`
}

/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * the director works or once the script is approved.
 * @summary Write Hot Seat Ad Draft
 */
export const writeHotSeatAdDraft = async (teamId: string,
    brandId: string,
    twoSpeakerDraftWrite: TwoSpeakerDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<TwoSpeakerDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<TwoSpeakerDraft>(getWriteHotSeatAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(twoSpeakerDraftWrite)
  }
);}





export const getWriteHotSeatAdDraftMutationKey = () => ['writeHotSeatAdDraft'] as const;

export const getWriteHotSeatAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeHotSeatAdDraft>>, TError,WriteHotSeatAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeHotSeatAdDraft>>, TError,WriteHotSeatAdDraftMutationVariables, TContext> => {

const mutationKey = getWriteHotSeatAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeHotSeatAdDraft>>, WriteHotSeatAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeHotSeatAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteHotSeatAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeHotSeatAdDraft>>>
    export type WriteHotSeatAdDraftMutationBody = TwoSpeakerDraftWrite
    export type WriteHotSeatAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteHotSeatAdDraftMutationVariables = {teamId: string;brandId: string;data: TwoSpeakerDraftWrite}

    /**
 * @summary Write Hot Seat Ad Draft
 */
export const useWriteHotSeatAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeHotSeatAdDraft>>, TError,WriteHotSeatAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeHotSeatAdDraft>>,
        TError,
        WriteHotSeatAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteHotSeatAdDraftMutationOptions(options), queryClient);
    }
    export const getApproveHotSeatAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/hot-seat/draft/approve`
}

/**
 * Approve script: the script checked (422 at `script` with the check's words, at
 * `inputs.wordmark` without one), approved, and the three stills started, each a paid
 * image: each speaker's picture and the end card's.
 * @summary Approve Hot Seat Ad Script
 */
export const approveHotSeatAdScript = async (teamId: string,
    brandId: string,
    twoSpeakerApproval: TwoSpeakerApproval, options?: Parameters<typeof apiRequest>[1]): Promise<TwoSpeakerDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<TwoSpeakerDraft>(getApproveHotSeatAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(twoSpeakerApproval)
  }
);}





export const getApproveHotSeatAdScriptMutationKey = () => ['approveHotSeatAdScript'] as const;

export const getApproveHotSeatAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveHotSeatAdScript>>, TError,ApproveHotSeatAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveHotSeatAdScript>>, TError,ApproveHotSeatAdScriptMutationVariables, TContext> => {

const mutationKey = getApproveHotSeatAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveHotSeatAdScript>>, ApproveHotSeatAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveHotSeatAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveHotSeatAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveHotSeatAdScript>>>
    export type ApproveHotSeatAdScriptMutationBody = TwoSpeakerApproval
    export type ApproveHotSeatAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveHotSeatAdScriptMutationVariables = {teamId: string;brandId: string;data: TwoSpeakerApproval}

    /**
 * @summary Approve Hot Seat Ad Script
 */
export const useApproveHotSeatAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveHotSeatAdScript>>, TError,ApproveHotSeatAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveHotSeatAdScript>>,
        TError,
        ApproveHotSeatAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveHotSeatAdScriptMutationOptions(options), queryClient);
    }
    export const getWriteHotSeatAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/hot-seat/draft/script`
}

/**
 * Generate script: the script director on the product's texts (a product and its
 * packshot first, and the brand's name, 422). An answer the check refuses is redone once,
 * then kept with the check's words in `script_problems`.
 * @summary Write Hot Seat Ad Script
 */
export const writeHotSeatAdScript = async (teamId: string,
    brandId: string,
    twoSpeakerScriptAsk: TwoSpeakerScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<TwoSpeakerDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<TwoSpeakerDraft>(getWriteHotSeatAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(twoSpeakerScriptAsk)
  }
);}





export const getWriteHotSeatAdScriptMutationKey = () => ['writeHotSeatAdScript'] as const;

export const getWriteHotSeatAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeHotSeatAdScript>>, TError,WriteHotSeatAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeHotSeatAdScript>>, TError,WriteHotSeatAdScriptMutationVariables, TContext> => {

const mutationKey = getWriteHotSeatAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeHotSeatAdScript>>, WriteHotSeatAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeHotSeatAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteHotSeatAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeHotSeatAdScript>>>
    export type WriteHotSeatAdScriptMutationBody = TwoSpeakerScriptAsk
    export type WriteHotSeatAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteHotSeatAdScriptMutationVariables = {teamId: string;brandId: string;data: TwoSpeakerScriptAsk}

    /**
 * @summary Write Hot Seat Ad Script
 */
export const useWriteHotSeatAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeHotSeatAdScript>>, TError,WriteHotSeatAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeHotSeatAdScript>>,
        TError,
        WriteHotSeatAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteHotSeatAdScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateHotSeatAdStillUrl = (teamId: string,
    brandId: string,
    name: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/hot-seat/draft/stills/${name}/regenerate`
}

/**
 * ↻ on a still (a speaker's id, or `end_card`): it drawn again, a paid image as the
 * first was. 404 for a still the card has none of; `TEMPLATE_DRAFT_LOCKED` (409) before
 * the stills or while anything works.
 * @summary Regenerate Hot Seat Ad Still
 */
export const regenerateHotSeatAdStill = async (teamId: string,
    brandId: string,
    name: string, options?: Parameters<typeof apiRequest>[1]): Promise<TwoSpeakerDraft> => {

  return apiRequest<TwoSpeakerDraft>(getRegenerateHotSeatAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateHotSeatAdStillMutationKey = () => ['regenerateHotSeatAdStill'] as const;

export const getRegenerateHotSeatAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateHotSeatAdStill>>, TError,RegenerateHotSeatAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateHotSeatAdStill>>, TError,RegenerateHotSeatAdStillMutationVariables, TContext> => {

const mutationKey = getRegenerateHotSeatAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateHotSeatAdStill>>, RegenerateHotSeatAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateHotSeatAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateHotSeatAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateHotSeatAdStill>>>

    export type RegenerateHotSeatAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateHotSeatAdStillMutationVariables = {teamId: string;brandId: string;name: string}

    /**
 * @summary Regenerate Hot Seat Ad Still
 */
export const useRegenerateHotSeatAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateHotSeatAdStill>>, TError,RegenerateHotSeatAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateHotSeatAdStill>>,
        TError,
        RegenerateHotSeatAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateHotSeatAdStillMutationOptions(options), queryClient);
    }
    export const getResetPixarSingingAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Pixar Singing Ad Draft
 */
export const resetPixarSingingAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PixarSingingAdDraft> => {

  return apiRequest<PixarSingingAdDraft>(getResetPixarSingingAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetPixarSingingAdDraftMutationKey = () => ['resetPixarSingingAdDraft'] as const;

export const getResetPixarSingingAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPixarSingingAdDraft>>, TError,ResetPixarSingingAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPixarSingingAdDraft>>, TError,ResetPixarSingingAdDraftMutationVariables, TContext> => {

const mutationKey = getResetPixarSingingAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPixarSingingAdDraft>>, ResetPixarSingingAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetPixarSingingAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPixarSingingAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetPixarSingingAdDraft>>>

    export type ResetPixarSingingAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetPixarSingingAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Pixar Singing Ad Draft
 */
export const useResetPixarSingingAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPixarSingingAdDraft>>, TError,ResetPixarSingingAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPixarSingingAdDraft>>,
        TError,
        ResetPixarSingingAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetPixarSingingAdDraftMutationOptions(options), queryClient);
    }
    export const getGetPixarSingingAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Pixar Singing Ad Draft
 */
export const getPixarSingingAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PixarSingingAdDraft> => {

  return apiRequest<PixarSingingAdDraft>(getGetPixarSingingAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPixarSingingAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft`
    ] as const;
    }


export const getGetPixarSingingAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPixarSingingAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPixarSingingAdDraft>>> = ({ signal }) => getPixarSingingAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPixarSingingAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getPixarSingingAdDraft>>>
export type GetPixarSingingAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetPixarSingingAdDraft<TData = Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPixarSingingAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getPixarSingingAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPixarSingingAdDraft<TData = Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPixarSingingAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getPixarSingingAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPixarSingingAdDraft<TData = Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Pixar Singing Ad Draft
 */

export function useGetPixarSingingAdDraft<TData = Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarSingingAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPixarSingingAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWritePixarSingingAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft`
}

/**
 * The form as it stands and its lyrics as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a step works or once the lyrics are approved, as live locks the form.
 * @summary Write Pixar Singing Ad Draft
 */
export const writePixarSingingAdDraft = async (teamId: string,
    brandId: string,
    pixarSingingAdDraftWrite: PixarSingingAdDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<PixarSingingAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarSingingAdDraft>(getWritePixarSingingAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarSingingAdDraftWrite)
  }
);}





export const getWritePixarSingingAdDraftMutationKey = () => ['writePixarSingingAdDraft'] as const;

export const getWritePixarSingingAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarSingingAdDraft>>, TError,WritePixarSingingAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writePixarSingingAdDraft>>, TError,WritePixarSingingAdDraftMutationVariables, TContext> => {

const mutationKey = getWritePixarSingingAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writePixarSingingAdDraft>>, WritePixarSingingAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writePixarSingingAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WritePixarSingingAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writePixarSingingAdDraft>>>
    export type WritePixarSingingAdDraftMutationBody = PixarSingingAdDraftWrite
    export type WritePixarSingingAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WritePixarSingingAdDraftMutationVariables = {teamId: string;brandId: string;data: PixarSingingAdDraftWrite}

    /**
 * @summary Write Pixar Singing Ad Draft
 */
export const useWritePixarSingingAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarSingingAdDraft>>, TError,WritePixarSingingAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writePixarSingingAdDraft>>,
        TError,
        WritePixarSingingAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWritePixarSingingAdDraftMutationOptions(options), queryClient);
    }
    export const getApprovePixarSingingAdLyricsUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft/approve-lyrics`
}

/**
 * Live's Approve lyrics: six lines, each with its text, a punch line and a button
 * (422 at `lyrics` with live's words), approved; then three takes of the song, each made,
 * heard in English and checked; three more when fewer than two pass.
 * @summary Approve Pixar Singing Ad Lyrics
 */
export const approvePixarSingingAdLyrics = async (teamId: string,
    brandId: string,
    pixarSingingAdLyricsApproval: PixarSingingAdLyricsApproval, options?: Parameters<typeof apiRequest>[1]): Promise<PixarSingingAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarSingingAdDraft>(getApprovePixarSingingAdLyricsUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarSingingAdLyricsApproval)
  }
);}





export const getApprovePixarSingingAdLyricsMutationKey = () => ['approvePixarSingingAdLyrics'] as const;

export const getApprovePixarSingingAdLyricsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePixarSingingAdLyrics>>, TError,ApprovePixarSingingAdLyricsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePixarSingingAdLyrics>>, TError,ApprovePixarSingingAdLyricsMutationVariables, TContext> => {

const mutationKey = getApprovePixarSingingAdLyricsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePixarSingingAdLyrics>>, ApprovePixarSingingAdLyricsMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approvePixarSingingAdLyrics(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePixarSingingAdLyricsMutationResult = NonNullable<Awaited<ReturnType<typeof approvePixarSingingAdLyrics>>>
    export type ApprovePixarSingingAdLyricsMutationBody = PixarSingingAdLyricsApproval
    export type ApprovePixarSingingAdLyricsMutationError = ErrorType<ErrorEnvelope>
    export type ApprovePixarSingingAdLyricsMutationVariables = {teamId: string;brandId: string;data: PixarSingingAdLyricsApproval}

    /**
 * @summary Approve Pixar Singing Ad Lyrics
 */
export const useApprovePixarSingingAdLyrics = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePixarSingingAdLyrics>>, TError,ApprovePixarSingingAdLyricsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approvePixarSingingAdLyrics>>,
        TError,
        ApprovePixarSingingAdLyricsMutationVariables,
        TContext
      > => {
      return useMutation(getApprovePixarSingingAdLyricsMutationOptions(options), queryClient);
    }
    export const getApprovePixarSingingAdSongUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft/approve-song`
}

/**
 * Live's Approve song: the picked take's shot plan (422 at `take` with live's words for
 * a take not made, not checked, or with a sung line not heard), then the shot director and
 * the end card; once the spec keeps to the plan, the character sheet and each shot. A spec
 * that breaks the plan is redone once, then refused (`problem`) and the draft goes back to
 * the song.
 * @summary Approve Pixar Singing Ad Song
 */
export const approvePixarSingingAdSong = async (teamId: string,
    brandId: string,
    pixarSingingAdSongApproval: PixarSingingAdSongApproval, options?: Parameters<typeof apiRequest>[1]): Promise<PixarSingingAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarSingingAdDraft>(getApprovePixarSingingAdSongUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarSingingAdSongApproval)
  }
);}





export const getApprovePixarSingingAdSongMutationKey = () => ['approvePixarSingingAdSong'] as const;

export const getApprovePixarSingingAdSongMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePixarSingingAdSong>>, TError,ApprovePixarSingingAdSongMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePixarSingingAdSong>>, TError,ApprovePixarSingingAdSongMutationVariables, TContext> => {

const mutationKey = getApprovePixarSingingAdSongMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePixarSingingAdSong>>, ApprovePixarSingingAdSongMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approvePixarSingingAdSong(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePixarSingingAdSongMutationResult = NonNullable<Awaited<ReturnType<typeof approvePixarSingingAdSong>>>
    export type ApprovePixarSingingAdSongMutationBody = PixarSingingAdSongApproval
    export type ApprovePixarSingingAdSongMutationError = ErrorType<ErrorEnvelope>
    export type ApprovePixarSingingAdSongMutationVariables = {teamId: string;brandId: string;data: PixarSingingAdSongApproval}

    /**
 * @summary Approve Pixar Singing Ad Song
 */
export const useApprovePixarSingingAdSong = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePixarSingingAdSong>>, TError,ApprovePixarSingingAdSongMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approvePixarSingingAdSong>>,
        TError,
        ApprovePixarSingingAdSongMutationVariables,
        TContext
      > => {
      return useMutation(getApprovePixarSingingAdSongMutationOptions(options), queryClient);
    }
    export const getBackToPixarSingingAdLyricsUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft/back-to-lyrics`
}

/**
 * Back to the lyrics, the takes forgotten (ours: live's notes ask for it).
 * `TEMPLATE_DRAFT_LOCKED` (409) before the song or while anything works.
 * @summary Back To Pixar Singing Ad Lyrics
 */
export const backToPixarSingingAdLyrics = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PixarSingingAdDraft> => {

  return apiRequest<PixarSingingAdDraft>(getBackToPixarSingingAdLyricsUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBackToPixarSingingAdLyricsMutationKey = () => ['backToPixarSingingAdLyrics'] as const;

export const getBackToPixarSingingAdLyricsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToPixarSingingAdLyrics>>, TError,BackToPixarSingingAdLyricsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof backToPixarSingingAdLyrics>>, TError,BackToPixarSingingAdLyricsMutationVariables, TContext> => {

const mutationKey = getBackToPixarSingingAdLyricsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof backToPixarSingingAdLyrics>>, BackToPixarSingingAdLyricsMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  backToPixarSingingAdLyrics(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BackToPixarSingingAdLyricsMutationResult = NonNullable<Awaited<ReturnType<typeof backToPixarSingingAdLyrics>>>

    export type BackToPixarSingingAdLyricsMutationError = ErrorType<ErrorEnvelope>
    export type BackToPixarSingingAdLyricsMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Back To Pixar Singing Ad Lyrics
 */
export const useBackToPixarSingingAdLyrics = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToPixarSingingAdLyrics>>, TError,BackToPixarSingingAdLyricsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof backToPixarSingingAdLyrics>>,
        TError,
        BackToPixarSingingAdLyricsMutationVariables,
        TContext
      > => {
      return useMutation(getBackToPixarSingingAdLyricsMutationOptions(options), queryClient);
    }
    export const getBackToPixarSingingAdTakesUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft/back-to-takes`
}

/**
 * Live's Back to takes: the plan and the stills forgotten, the takes kept.
 * `TEMPLATE_DRAFT_LOCKED` (409) outside the cast or while anything works.
 * @summary Back To Pixar Singing Ad Takes
 */
export const backToPixarSingingAdTakes = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PixarSingingAdDraft> => {

  return apiRequest<PixarSingingAdDraft>(getBackToPixarSingingAdTakesUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBackToPixarSingingAdTakesMutationKey = () => ['backToPixarSingingAdTakes'] as const;

export const getBackToPixarSingingAdTakesMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToPixarSingingAdTakes>>, TError,BackToPixarSingingAdTakesMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof backToPixarSingingAdTakes>>, TError,BackToPixarSingingAdTakesMutationVariables, TContext> => {

const mutationKey = getBackToPixarSingingAdTakesMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof backToPixarSingingAdTakes>>, BackToPixarSingingAdTakesMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  backToPixarSingingAdTakes(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BackToPixarSingingAdTakesMutationResult = NonNullable<Awaited<ReturnType<typeof backToPixarSingingAdTakes>>>

    export type BackToPixarSingingAdTakesMutationError = ErrorType<ErrorEnvelope>
    export type BackToPixarSingingAdTakesMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Back To Pixar Singing Ad Takes
 */
export const useBackToPixarSingingAdTakes = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToPixarSingingAdTakes>>, TError,BackToPixarSingingAdTakesMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof backToPixarSingingAdTakes>>,
        TError,
        BackToPixarSingingAdTakesMutationVariables,
        TContext
      > => {
      return useMutation(getBackToPixarSingingAdTakesMutationOptions(options), queryClient);
    }
    export const getWritePixarSingingAdLyricsUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft/lyrics`
}

/**
 * Live's wand: an uploaded packshot with no name or no text typed is read first
 * (`pack_director`; an unreadable one sets `pack_warning`), then the lyrics director;
 * lyrics off live's rules are redone once, then kept with live's words
 * (`lyrics_warning`).
 * @summary Write Pixar Singing Ad Lyrics
 */
export const writePixarSingingAdLyrics = async (teamId: string,
    brandId: string,
    pixarSingingAdLyricsAsk: PixarSingingAdLyricsAsk, options?: Parameters<typeof apiRequest>[1]): Promise<PixarSingingAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarSingingAdDraft>(getWritePixarSingingAdLyricsUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarSingingAdLyricsAsk)
  }
);}





export const getWritePixarSingingAdLyricsMutationKey = () => ['writePixarSingingAdLyrics'] as const;

export const getWritePixarSingingAdLyricsMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarSingingAdLyrics>>, TError,WritePixarSingingAdLyricsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writePixarSingingAdLyrics>>, TError,WritePixarSingingAdLyricsMutationVariables, TContext> => {

const mutationKey = getWritePixarSingingAdLyricsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writePixarSingingAdLyrics>>, WritePixarSingingAdLyricsMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writePixarSingingAdLyrics(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WritePixarSingingAdLyricsMutationResult = NonNullable<Awaited<ReturnType<typeof writePixarSingingAdLyrics>>>
    export type WritePixarSingingAdLyricsMutationBody = PixarSingingAdLyricsAsk
    export type WritePixarSingingAdLyricsMutationError = ErrorType<ErrorEnvelope>
    export type WritePixarSingingAdLyricsMutationVariables = {teamId: string;brandId: string;data: PixarSingingAdLyricsAsk}

    /**
 * @summary Write Pixar Singing Ad Lyrics
 */
export const useWritePixarSingingAdLyrics = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarSingingAdLyrics>>, TError,WritePixarSingingAdLyricsMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writePixarSingingAdLyrics>>,
        TError,
        WritePixarSingingAdLyricsMutationVariables,
        TContext
      > => {
      return useMutation(getWritePixarSingingAdLyricsMutationOptions(options), queryClient);
    }
    export const getRegeneratePixarSingingAdStillUrl = (teamId: string,
    brandId: string,
    name: 'char_sheet' | 'shot_1' | 'shot_2' | 'shot_3' | 'end_card',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft/stills/${name}/regenerate`
}

/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image as
 * the first was. `TEMPLATE_DRAFT_LOCKED` (409) outside the cast, for a still the plan
 * lacks, before the spec for a still that needs it, or while anything works.
 * @summary Regenerate Pixar Singing Ad Still
 */
export const regeneratePixarSingingAdStill = async (teamId: string,
    brandId: string,
    name: 'char_sheet' | 'shot_1' | 'shot_2' | 'shot_3' | 'end_card', options?: Parameters<typeof apiRequest>[1]): Promise<PixarSingingAdDraft> => {

  return apiRequest<PixarSingingAdDraft>(getRegeneratePixarSingingAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegeneratePixarSingingAdStillMutationKey = () => ['regeneratePixarSingingAdStill'] as const;

export const getRegeneratePixarSingingAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePixarSingingAdStill>>, TError,RegeneratePixarSingingAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regeneratePixarSingingAdStill>>, TError,RegeneratePixarSingingAdStillMutationVariables, TContext> => {

const mutationKey = getRegeneratePixarSingingAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regeneratePixarSingingAdStill>>, RegeneratePixarSingingAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regeneratePixarSingingAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegeneratePixarSingingAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regeneratePixarSingingAdStill>>>

    export type RegeneratePixarSingingAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegeneratePixarSingingAdStillMutationVariables = {teamId: string;brandId: string;name: 'char_sheet' | 'shot_1' | 'shot_2' | 'shot_3' | 'end_card'}

    /**
 * @summary Regenerate Pixar Singing Ad Still
 */
export const useRegeneratePixarSingingAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePixarSingingAdStill>>, TError,RegeneratePixarSingingAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regeneratePixarSingingAdStill>>,
        TError,
        RegeneratePixarSingingAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegeneratePixarSingingAdStillMutationOptions(options), queryClient);
    }
    export const getAddPixarSingingAdTakeUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-singing-ad/draft/takes`
}

/**
 * Live's "+": one more take with the same prompt; at six, live's note instead.
 * `TEMPLATE_DRAFT_LOCKED` (409) before the song or while anything works.
 * @summary Add Pixar Singing Ad Take
 */
export const addPixarSingingAdTake = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PixarSingingAdDraft> => {

  return apiRequest<PixarSingingAdDraft>(getAddPixarSingingAdTakeUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getAddPixarSingingAdTakeMutationKey = () => ['addPixarSingingAdTake'] as const;

export const getAddPixarSingingAdTakeMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPixarSingingAdTake>>, TError,AddPixarSingingAdTakeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof addPixarSingingAdTake>>, TError,AddPixarSingingAdTakeMutationVariables, TContext> => {

const mutationKey = getAddPixarSingingAdTakeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addPixarSingingAdTake>>, AddPixarSingingAdTakeMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  addPixarSingingAdTake(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddPixarSingingAdTakeMutationResult = NonNullable<Awaited<ReturnType<typeof addPixarSingingAdTake>>>

    export type AddPixarSingingAdTakeMutationError = ErrorType<ErrorEnvelope>
    export type AddPixarSingingAdTakeMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Add Pixar Singing Ad Take
 */
export const useAddPixarSingingAdTake = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addPixarSingingAdTake>>, TError,AddPixarSingingAdTakeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addPixarSingingAdTake>>,
        TError,
        AddPixarSingingAdTakeMutationVariables,
        TContext
      > => {
      return useMutation(getAddPixarSingingAdTakeMutationOptions(options), queryClient);
    }
    export const getResetPixarTalkingAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-talking-ad/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Pixar Talking Ad Draft
 */
export const resetPixarTalkingAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PixarTalkingAdDraft> => {

  return apiRequest<PixarTalkingAdDraft>(getResetPixarTalkingAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetPixarTalkingAdDraftMutationKey = () => ['resetPixarTalkingAdDraft'] as const;

export const getResetPixarTalkingAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPixarTalkingAdDraft>>, TError,ResetPixarTalkingAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPixarTalkingAdDraft>>, TError,ResetPixarTalkingAdDraftMutationVariables, TContext> => {

const mutationKey = getResetPixarTalkingAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPixarTalkingAdDraft>>, ResetPixarTalkingAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetPixarTalkingAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPixarTalkingAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetPixarTalkingAdDraft>>>

    export type ResetPixarTalkingAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetPixarTalkingAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Pixar Talking Ad Draft
 */
export const useResetPixarTalkingAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPixarTalkingAdDraft>>, TError,ResetPixarTalkingAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPixarTalkingAdDraft>>,
        TError,
        ResetPixarTalkingAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetPixarTalkingAdDraftMutationOptions(options), queryClient);
    }
    export const getGetPixarTalkingAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-talking-ad/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Pixar Talking Ad Draft
 */
export const getPixarTalkingAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PixarTalkingAdDraft> => {

  return apiRequest<PixarTalkingAdDraft>(getGetPixarTalkingAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPixarTalkingAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-talking-ad/draft`
    ] as const;
    }


export const getGetPixarTalkingAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPixarTalkingAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPixarTalkingAdDraft>>> = ({ signal }) => getPixarTalkingAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPixarTalkingAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getPixarTalkingAdDraft>>>
export type GetPixarTalkingAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetPixarTalkingAdDraft<TData = Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPixarTalkingAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getPixarTalkingAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPixarTalkingAdDraft<TData = Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPixarTalkingAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getPixarTalkingAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPixarTalkingAdDraft<TData = Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Pixar Talking Ad Draft
 */

export function useGetPixarTalkingAdDraft<TData = Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarTalkingAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPixarTalkingAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWritePixarTalkingAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-talking-ad/draft`
}

/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved, as live locks the form.
 * @summary Write Pixar Talking Ad Draft
 */
export const writePixarTalkingAdDraft = async (teamId: string,
    brandId: string,
    pixarTalkingAdDraftWrite: PixarTalkingAdDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<PixarTalkingAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarTalkingAdDraft>(getWritePixarTalkingAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarTalkingAdDraftWrite)
  }
);}





export const getWritePixarTalkingAdDraftMutationKey = () => ['writePixarTalkingAdDraft'] as const;

export const getWritePixarTalkingAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarTalkingAdDraft>>, TError,WritePixarTalkingAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writePixarTalkingAdDraft>>, TError,WritePixarTalkingAdDraftMutationVariables, TContext> => {

const mutationKey = getWritePixarTalkingAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writePixarTalkingAdDraft>>, WritePixarTalkingAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writePixarTalkingAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WritePixarTalkingAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writePixarTalkingAdDraft>>>
    export type WritePixarTalkingAdDraftMutationBody = PixarTalkingAdDraftWrite
    export type WritePixarTalkingAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WritePixarTalkingAdDraftMutationVariables = {teamId: string;brandId: string;data: PixarTalkingAdDraftWrite}

    /**
 * @summary Write Pixar Talking Ad Draft
 */
export const useWritePixarTalkingAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarTalkingAdDraft>>, TError,WritePixarTalkingAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writePixarTalkingAdDraft>>,
        TError,
        WritePixarTalkingAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWritePixarTalkingAdDraftMutationOptions(options), queryClient);
    }
    export const getApprovePixarTalkingAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-talking-ad/draft/approve`
}

/**
 * Live's Approve script: its 8 lines in their beats, each with its text (422 at
 * `script` with live's words), approved; then the shot director. A spec that breaks the
 * script or its schema is redone once, then refused (`problem`), the draft back at its
 * script. A kept spec starts the stills: the character chain, each as the one before is
 * done, and with the end card on, the end card beside the sheet.
 * @summary Approve Pixar Talking Ad Script
 */
export const approvePixarTalkingAdScript = async (teamId: string,
    brandId: string,
    pixarTalkingAdApproval: PixarTalkingAdApproval, options?: Parameters<typeof apiRequest>[1]): Promise<PixarTalkingAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarTalkingAdDraft>(getApprovePixarTalkingAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarTalkingAdApproval)
  }
);}





export const getApprovePixarTalkingAdScriptMutationKey = () => ['approvePixarTalkingAdScript'] as const;

export const getApprovePixarTalkingAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePixarTalkingAdScript>>, TError,ApprovePixarTalkingAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePixarTalkingAdScript>>, TError,ApprovePixarTalkingAdScriptMutationVariables, TContext> => {

const mutationKey = getApprovePixarTalkingAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePixarTalkingAdScript>>, ApprovePixarTalkingAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approvePixarTalkingAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePixarTalkingAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approvePixarTalkingAdScript>>>
    export type ApprovePixarTalkingAdScriptMutationBody = PixarTalkingAdApproval
    export type ApprovePixarTalkingAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApprovePixarTalkingAdScriptMutationVariables = {teamId: string;brandId: string;data: PixarTalkingAdApproval}

    /**
 * @summary Approve Pixar Talking Ad Script
 */
export const useApprovePixarTalkingAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePixarTalkingAdScript>>, TError,ApprovePixarTalkingAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approvePixarTalkingAdScript>>,
        TError,
        ApprovePixarTalkingAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApprovePixarTalkingAdScriptMutationOptions(options), queryClient);
    }
    export const getWritePixarTalkingAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-talking-ad/draft/script`
}

/**
 * Live's Generate Script: an uploaded packshot with no name or no text typed is read
 * first (`pack_director`; an unreadable one sets `pack_warning`), then the script
 * director; a script off its beats or quoting off the product text is redone once, then
 * kept with what is still off (`script_problems`). An empty Problem chip takes the
 * script's problem.
 * @summary Write Pixar Talking Ad Script
 */
export const writePixarTalkingAdScript = async (teamId: string,
    brandId: string,
    pixarTalkingAdScriptAsk: PixarTalkingAdScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<PixarTalkingAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarTalkingAdDraft>(getWritePixarTalkingAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarTalkingAdScriptAsk)
  }
);}





export const getWritePixarTalkingAdScriptMutationKey = () => ['writePixarTalkingAdScript'] as const;

export const getWritePixarTalkingAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarTalkingAdScript>>, TError,WritePixarTalkingAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writePixarTalkingAdScript>>, TError,WritePixarTalkingAdScriptMutationVariables, TContext> => {

const mutationKey = getWritePixarTalkingAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writePixarTalkingAdScript>>, WritePixarTalkingAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writePixarTalkingAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WritePixarTalkingAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writePixarTalkingAdScript>>>
    export type WritePixarTalkingAdScriptMutationBody = PixarTalkingAdScriptAsk
    export type WritePixarTalkingAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WritePixarTalkingAdScriptMutationVariables = {teamId: string;brandId: string;data: PixarTalkingAdScriptAsk}

    /**
 * @summary Write Pixar Talking Ad Script
 */
export const useWritePixarTalkingAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarTalkingAdScript>>, TError,WritePixarTalkingAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writePixarTalkingAdScript>>,
        TError,
        WritePixarTalkingAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWritePixarTalkingAdScriptMutationOptions(options), queryClient);
    }
    export const getRegeneratePixarTalkingAdStillUrl = (teamId: string,
    brandId: string,
    name: 'char_sheet' | 'opening' | 'hold' | 'closing' | 'end_card',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-talking-ad/draft/stills/${name}/regenerate`
}

/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image
 * as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the stills, for the end card with
 * the end card off, or while anything works.
 * @summary Regenerate Pixar Talking Ad Still
 */
export const regeneratePixarTalkingAdStill = async (teamId: string,
    brandId: string,
    name: 'char_sheet' | 'opening' | 'hold' | 'closing' | 'end_card', options?: Parameters<typeof apiRequest>[1]): Promise<PixarTalkingAdDraft> => {

  return apiRequest<PixarTalkingAdDraft>(getRegeneratePixarTalkingAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegeneratePixarTalkingAdStillMutationKey = () => ['regeneratePixarTalkingAdStill'] as const;

export const getRegeneratePixarTalkingAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePixarTalkingAdStill>>, TError,RegeneratePixarTalkingAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regeneratePixarTalkingAdStill>>, TError,RegeneratePixarTalkingAdStillMutationVariables, TContext> => {

const mutationKey = getRegeneratePixarTalkingAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regeneratePixarTalkingAdStill>>, RegeneratePixarTalkingAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regeneratePixarTalkingAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegeneratePixarTalkingAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regeneratePixarTalkingAdStill>>>

    export type RegeneratePixarTalkingAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegeneratePixarTalkingAdStillMutationVariables = {teamId: string;brandId: string;name: 'char_sheet' | 'opening' | 'hold' | 'closing' | 'end_card'}

    /**
 * @summary Regenerate Pixar Talking Ad Still
 */
export const useRegeneratePixarTalkingAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePixarTalkingAdStill>>, TError,RegeneratePixarTalkingAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regeneratePixarTalkingAdStill>>,
        TError,
        RegeneratePixarTalkingAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegeneratePixarTalkingAdStillMutationOptions(options), queryClient);
    }
    export const getResetPixarWhiteboardAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-whiteboard-ad/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Pixar Whiteboard Ad Draft
 */
export const resetPixarWhiteboardAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PixarWhiteboardAdDraft> => {

  return apiRequest<PixarWhiteboardAdDraft>(getResetPixarWhiteboardAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetPixarWhiteboardAdDraftMutationKey = () => ['resetPixarWhiteboardAdDraft'] as const;

export const getResetPixarWhiteboardAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPixarWhiteboardAdDraft>>, TError,ResetPixarWhiteboardAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPixarWhiteboardAdDraft>>, TError,ResetPixarWhiteboardAdDraftMutationVariables, TContext> => {

const mutationKey = getResetPixarWhiteboardAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPixarWhiteboardAdDraft>>, ResetPixarWhiteboardAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetPixarWhiteboardAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPixarWhiteboardAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetPixarWhiteboardAdDraft>>>

    export type ResetPixarWhiteboardAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetPixarWhiteboardAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Pixar Whiteboard Ad Draft
 */
export const useResetPixarWhiteboardAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPixarWhiteboardAdDraft>>, TError,ResetPixarWhiteboardAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPixarWhiteboardAdDraft>>,
        TError,
        ResetPixarWhiteboardAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetPixarWhiteboardAdDraftMutationOptions(options), queryClient);
    }
    export const getGetPixarWhiteboardAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-whiteboard-ad/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Pixar Whiteboard Ad Draft
 */
export const getPixarWhiteboardAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PixarWhiteboardAdDraft> => {

  return apiRequest<PixarWhiteboardAdDraft>(getGetPixarWhiteboardAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPixarWhiteboardAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-whiteboard-ad/draft`
    ] as const;
    }


export const getGetPixarWhiteboardAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPixarWhiteboardAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>> = ({ signal }) => getPixarWhiteboardAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPixarWhiteboardAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>>
export type GetPixarWhiteboardAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetPixarWhiteboardAdDraft<TData = Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPixarWhiteboardAdDraft<TData = Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPixarWhiteboardAdDraft<TData = Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Pixar Whiteboard Ad Draft
 */

export function useGetPixarWhiteboardAdDraft<TData = Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPixarWhiteboardAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPixarWhiteboardAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWritePixarWhiteboardAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-whiteboard-ad/draft`
}

/**
 * The form as it stands and its script as edited ("Write the 10 lines yourself" sends
 * the blank one). `TEMPLATE_DRAFT_LOCKED` (409) while a director works or once the script
 * is approved, as live locks the form.
 * @summary Write Pixar Whiteboard Ad Draft
 */
export const writePixarWhiteboardAdDraft = async (teamId: string,
    brandId: string,
    pixarWhiteboardAdDraftWrite: PixarWhiteboardAdDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<PixarWhiteboardAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarWhiteboardAdDraft>(getWritePixarWhiteboardAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarWhiteboardAdDraftWrite)
  }
);}





export const getWritePixarWhiteboardAdDraftMutationKey = () => ['writePixarWhiteboardAdDraft'] as const;

export const getWritePixarWhiteboardAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdDraft>>, TError,WritePixarWhiteboardAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdDraft>>, TError,WritePixarWhiteboardAdDraftMutationVariables, TContext> => {

const mutationKey = getWritePixarWhiteboardAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writePixarWhiteboardAdDraft>>, WritePixarWhiteboardAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writePixarWhiteboardAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WritePixarWhiteboardAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writePixarWhiteboardAdDraft>>>
    export type WritePixarWhiteboardAdDraftMutationBody = PixarWhiteboardAdDraftWrite
    export type WritePixarWhiteboardAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WritePixarWhiteboardAdDraftMutationVariables = {teamId: string;brandId: string;data: PixarWhiteboardAdDraftWrite}

    /**
 * @summary Write Pixar Whiteboard Ad Draft
 */
export const useWritePixarWhiteboardAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdDraft>>, TError,WritePixarWhiteboardAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writePixarWhiteboardAdDraft>>,
        TError,
        WritePixarWhiteboardAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWritePixarWhiteboardAdDraftMutationOptions(options), queryClient);
    }
    export const getApprovePixarWhiteboardAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-whiteboard-ad/draft/approve`
}

/**
 * Live's Approve script: its gate (422 at `script` in live's words), then the character
 * sheet and the end card at once and the board director. A spec off its schema or check
 * is asked once more, then refused (`problem`), the draft back at its script. A kept spec
 * starts the board stills, each when its sources are done.
 * @summary Approve Pixar Whiteboard Ad Script
 */
export const approvePixarWhiteboardAdScript = async (teamId: string,
    brandId: string,
    pixarWhiteboardAdApproval: PixarWhiteboardAdApproval, options?: Parameters<typeof apiRequest>[1]): Promise<PixarWhiteboardAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarWhiteboardAdDraft>(getApprovePixarWhiteboardAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarWhiteboardAdApproval)
  }
);}





export const getApprovePixarWhiteboardAdScriptMutationKey = () => ['approvePixarWhiteboardAdScript'] as const;

export const getApprovePixarWhiteboardAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePixarWhiteboardAdScript>>, TError,ApprovePixarWhiteboardAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePixarWhiteboardAdScript>>, TError,ApprovePixarWhiteboardAdScriptMutationVariables, TContext> => {

const mutationKey = getApprovePixarWhiteboardAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePixarWhiteboardAdScript>>, ApprovePixarWhiteboardAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approvePixarWhiteboardAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePixarWhiteboardAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approvePixarWhiteboardAdScript>>>
    export type ApprovePixarWhiteboardAdScriptMutationBody = PixarWhiteboardAdApproval
    export type ApprovePixarWhiteboardAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApprovePixarWhiteboardAdScriptMutationVariables = {teamId: string;brandId: string;data: PixarWhiteboardAdApproval}

    /**
 * @summary Approve Pixar Whiteboard Ad Script
 */
export const useApprovePixarWhiteboardAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePixarWhiteboardAdScript>>, TError,ApprovePixarWhiteboardAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approvePixarWhiteboardAdScript>>,
        TError,
        ApprovePixarWhiteboardAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApprovePixarWhiteboardAdScriptMutationOptions(options), queryClient);
    }
    export const getWritePixarWhiteboardAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-whiteboard-ad/draft/script`
}

/**
 * Live's Generate Script: an uploaded packshot with no name or no text typed is read
 * first, then the script director; a script with problems is asked once more, then kept
 * with live's warning (`script_warning`). Empty Problem and CTA chips take the
 * director's.
 * @summary Write Pixar Whiteboard Ad Script
 */
export const writePixarWhiteboardAdScript = async (teamId: string,
    brandId: string,
    pixarWhiteboardAdScriptAsk: PixarWhiteboardAdScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<PixarWhiteboardAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarWhiteboardAdDraft>(getWritePixarWhiteboardAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarWhiteboardAdScriptAsk)
  }
);}





export const getWritePixarWhiteboardAdScriptMutationKey = () => ['writePixarWhiteboardAdScript'] as const;

export const getWritePixarWhiteboardAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdScript>>, TError,WritePixarWhiteboardAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdScript>>, TError,WritePixarWhiteboardAdScriptMutationVariables, TContext> => {

const mutationKey = getWritePixarWhiteboardAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writePixarWhiteboardAdScript>>, WritePixarWhiteboardAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writePixarWhiteboardAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WritePixarWhiteboardAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writePixarWhiteboardAdScript>>>
    export type WritePixarWhiteboardAdScriptMutationBody = PixarWhiteboardAdScriptAsk
    export type WritePixarWhiteboardAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WritePixarWhiteboardAdScriptMutationVariables = {teamId: string;brandId: string;data: PixarWhiteboardAdScriptAsk}

    /**
 * @summary Write Pixar Whiteboard Ad Script
 */
export const useWritePixarWhiteboardAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdScript>>, TError,WritePixarWhiteboardAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writePixarWhiteboardAdScript>>,
        TError,
        WritePixarWhiteboardAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWritePixarWhiteboardAdScriptMutationOptions(options), queryClient);
    }
    export const getApprovePixarWhiteboardAdStoryboardUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-whiteboard-ad/draft/shoot`
}

/**
 * Live's "Shoot the clips": with every still done (else 422 in live's words), each
 * talking clip's takes and the end card's at once, each a paid clip; each delivered
 * talking take is heard and checked, and once none works each clip's best take is picked.
 * `TEMPLATE_DRAFT_LOCKED` (409) before the board spec, once shot, or while anything
 * works.
 * @summary Approve Pixar Whiteboard Ad Storyboard
 */
export const approvePixarWhiteboardAdStoryboard = async (teamId: string,
    brandId: string,
    pixarWhiteboardAdShoot: PixarWhiteboardAdShoot, options?: Parameters<typeof apiRequest>[1]): Promise<PixarWhiteboardAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarWhiteboardAdDraft>(getApprovePixarWhiteboardAdStoryboardUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarWhiteboardAdShoot)
  }
);}





export const getApprovePixarWhiteboardAdStoryboardMutationKey = () => ['approvePixarWhiteboardAdStoryboard'] as const;

export const getApprovePixarWhiteboardAdStoryboardMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePixarWhiteboardAdStoryboard>>, TError,ApprovePixarWhiteboardAdStoryboardMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePixarWhiteboardAdStoryboard>>, TError,ApprovePixarWhiteboardAdStoryboardMutationVariables, TContext> => {

const mutationKey = getApprovePixarWhiteboardAdStoryboardMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePixarWhiteboardAdStoryboard>>, ApprovePixarWhiteboardAdStoryboardMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approvePixarWhiteboardAdStoryboard(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePixarWhiteboardAdStoryboardMutationResult = NonNullable<Awaited<ReturnType<typeof approvePixarWhiteboardAdStoryboard>>>
    export type ApprovePixarWhiteboardAdStoryboardMutationBody = PixarWhiteboardAdShoot
    export type ApprovePixarWhiteboardAdStoryboardMutationError = ErrorType<ErrorEnvelope>
    export type ApprovePixarWhiteboardAdStoryboardMutationVariables = {teamId: string;brandId: string;data: PixarWhiteboardAdShoot}

    /**
 * @summary Approve Pixar Whiteboard Ad Storyboard
 */
export const useApprovePixarWhiteboardAdStoryboard = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePixarWhiteboardAdStoryboard>>, TError,ApprovePixarWhiteboardAdStoryboardMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approvePixarWhiteboardAdStoryboard>>,
        TError,
        ApprovePixarWhiteboardAdStoryboardMutationVariables,
        TContext
      > => {
      return useMutation(getApprovePixarWhiteboardAdStoryboardMutationOptions(options), queryClient);
    }
    export const getRegeneratePixarWhiteboardAdStillUrl = (teamId: string,
    brandId: string,
    name: 'sheet' | 'master_board' | 'char_ref' | 'opening' | 'anchor_a' | 'anchor_b' | 'anchor_c' | 'end_card',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-whiteboard-ad/draft/stills/${name}/regenerate`
}

/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image
 * as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the board spec, or while anything
 * works.
 * @summary Regenerate Pixar Whiteboard Ad Still
 */
export const regeneratePixarWhiteboardAdStill = async (teamId: string,
    brandId: string,
    name: 'sheet' | 'master_board' | 'char_ref' | 'opening' | 'anchor_a' | 'anchor_b' | 'anchor_c' | 'end_card', options?: Parameters<typeof apiRequest>[1]): Promise<PixarWhiteboardAdDraft> => {

  return apiRequest<PixarWhiteboardAdDraft>(getRegeneratePixarWhiteboardAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegeneratePixarWhiteboardAdStillMutationKey = () => ['regeneratePixarWhiteboardAdStill'] as const;

export const getRegeneratePixarWhiteboardAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePixarWhiteboardAdStill>>, TError,RegeneratePixarWhiteboardAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regeneratePixarWhiteboardAdStill>>, TError,RegeneratePixarWhiteboardAdStillMutationVariables, TContext> => {

const mutationKey = getRegeneratePixarWhiteboardAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regeneratePixarWhiteboardAdStill>>, RegeneratePixarWhiteboardAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regeneratePixarWhiteboardAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegeneratePixarWhiteboardAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regeneratePixarWhiteboardAdStill>>>

    export type RegeneratePixarWhiteboardAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegeneratePixarWhiteboardAdStillMutationVariables = {teamId: string;brandId: string;name: 'sheet' | 'master_board' | 'char_ref' | 'opening' | 'anchor_a' | 'anchor_b' | 'anchor_c' | 'end_card'}

    /**
 * @summary Regenerate Pixar Whiteboard Ad Still
 */
export const useRegeneratePixarWhiteboardAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePixarWhiteboardAdStill>>, TError,RegeneratePixarWhiteboardAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regeneratePixarWhiteboardAdStill>>,
        TError,
        RegeneratePixarWhiteboardAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegeneratePixarWhiteboardAdStillMutationOptions(options), queryClient);
    }
    export const getWritePixarWhiteboardAdTakeUrl = (teamId: string,
    brandId: string,
    clip: 'A' | 'B' | 'C' | 'end_card',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-whiteboard-ad/draft/takes/${clip}/new`
}

/**
 * Live's New take: one more paid take of the clip, picked only where the clip had no
 * finished take. `TEMPLATE_DRAFT_LOCKED` (409) before the shoot or while a take works.
 * @summary Write Pixar Whiteboard Ad Take
 */
export const writePixarWhiteboardAdTake = async (teamId: string,
    brandId: string,
    clip: 'A' | 'B' | 'C' | 'end_card', options?: Parameters<typeof apiRequest>[1]): Promise<PixarWhiteboardAdDraft> => {

  return apiRequest<PixarWhiteboardAdDraft>(getWritePixarWhiteboardAdTakeUrl(teamId,brandId,clip),
  {
    ...options,
    method: 'POST'


  }
);}





export const getWritePixarWhiteboardAdTakeMutationKey = () => ['writePixarWhiteboardAdTake'] as const;

export const getWritePixarWhiteboardAdTakeMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdTake>>, TError,WritePixarWhiteboardAdTakeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdTake>>, TError,WritePixarWhiteboardAdTakeMutationVariables, TContext> => {

const mutationKey = getWritePixarWhiteboardAdTakeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writePixarWhiteboardAdTake>>, WritePixarWhiteboardAdTakeMutationVariables> = (props) => {
          const {teamId,brandId,clip} = props ?? {};

          return  writePixarWhiteboardAdTake(teamId,brandId,clip,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WritePixarWhiteboardAdTakeMutationResult = NonNullable<Awaited<ReturnType<typeof writePixarWhiteboardAdTake>>>

    export type WritePixarWhiteboardAdTakeMutationError = ErrorType<ErrorEnvelope>
    export type WritePixarWhiteboardAdTakeMutationVariables = {teamId: string;brandId: string;clip: 'A' | 'B' | 'C' | 'end_card'}

    /**
 * @summary Write Pixar Whiteboard Ad Take
 */
export const useWritePixarWhiteboardAdTake = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdTake>>, TError,WritePixarWhiteboardAdTakeMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writePixarWhiteboardAdTake>>,
        TError,
        WritePixarWhiteboardAdTakeMutationVariables,
        TContext
      > => {
      return useMutation(getWritePixarWhiteboardAdTakeMutationOptions(options), queryClient);
    }
    export const getWritePixarWhiteboardAdPickUrl = (teamId: string,
    brandId: string,
    clip: 'A' | 'B' | 'C' | 'end_card',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/pixar-whiteboard-ad/draft/takes/${clip}/pick`
}

/**
 * Live's radio: a finished take of the clip picked (422 at `take` for any other).
 * `TEMPLATE_DRAFT_LOCKED` (409) before the shoot or while a take works.
 * @summary Write Pixar Whiteboard Ad Pick
 */
export const writePixarWhiteboardAdPick = async (teamId: string,
    brandId: string,
    clip: 'A' | 'B' | 'C' | 'end_card',
    pixarWhiteboardAdPick: PixarWhiteboardAdPick, options?: Parameters<typeof apiRequest>[1]): Promise<PixarWhiteboardAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PixarWhiteboardAdDraft>(getWritePixarWhiteboardAdPickUrl(teamId,brandId,clip),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(pixarWhiteboardAdPick)
  }
);}





export const getWritePixarWhiteboardAdPickMutationKey = () => ['writePixarWhiteboardAdPick'] as const;

export const getWritePixarWhiteboardAdPickMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdPick>>, TError,WritePixarWhiteboardAdPickMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdPick>>, TError,WritePixarWhiteboardAdPickMutationVariables, TContext> => {

const mutationKey = getWritePixarWhiteboardAdPickMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writePixarWhiteboardAdPick>>, WritePixarWhiteboardAdPickMutationVariables> = (props) => {
          const {teamId,brandId,clip,data} = props ?? {};

          return  writePixarWhiteboardAdPick(teamId,brandId,clip,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WritePixarWhiteboardAdPickMutationResult = NonNullable<Awaited<ReturnType<typeof writePixarWhiteboardAdPick>>>
    export type WritePixarWhiteboardAdPickMutationBody = PixarWhiteboardAdPick
    export type WritePixarWhiteboardAdPickMutationError = ErrorType<ErrorEnvelope>
    export type WritePixarWhiteboardAdPickMutationVariables = {teamId: string;brandId: string;clip: 'A' | 'B' | 'C' | 'end_card';data: PixarWhiteboardAdPick}

    /**
 * @summary Write Pixar Whiteboard Ad Pick
 */
export const useWritePixarWhiteboardAdPick = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePixarWhiteboardAdPick>>, TError,WritePixarWhiteboardAdPickMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writePixarWhiteboardAdPick>>,
        TError,
        WritePixarWhiteboardAdPickMutationVariables,
        TContext
      > => {
      return useMutation(getWritePixarWhiteboardAdPickMutationOptions(options), queryClient);
    }
    export const getResetPodcastAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/podcast-ad/draft`
}

/**
 * Start over: an empty draft. A director still running changes nothing once it ends.
 * @summary Reset Podcast Ad Draft
 */
export const resetPodcastAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PodcastAdDraft> => {

  return apiRequest<PodcastAdDraft>(getResetPodcastAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetPodcastAdDraftMutationKey = () => ['resetPodcastAdDraft'] as const;

export const getResetPodcastAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPodcastAdDraft>>, TError,ResetPodcastAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPodcastAdDraft>>, TError,ResetPodcastAdDraftMutationVariables, TContext> => {

const mutationKey = getResetPodcastAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPodcastAdDraft>>, ResetPodcastAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetPodcastAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetPodcastAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetPodcastAdDraft>>>

    export type ResetPodcastAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetPodcastAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Podcast Ad Draft
 */
export const useResetPodcastAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPodcastAdDraft>>, TError,ResetPodcastAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPodcastAdDraft>>,
        TError,
        ResetPodcastAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetPodcastAdDraftMutationOptions(options), queryClient);
    }
    export const getGetPodcastAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/podcast-ad/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Podcast Ad Draft
 */
export const getPodcastAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PodcastAdDraft> => {

  return apiRequest<PodcastAdDraft>(getGetPodcastAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPodcastAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/podcast-ad/draft`
    ] as const;
    }


export const getGetPodcastAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getPodcastAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPodcastAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPodcastAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPodcastAdDraft>>> = ({ signal }) => getPodcastAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPodcastAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPodcastAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getPodcastAdDraft>>>
export type GetPodcastAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetPodcastAdDraft<TData = Awaited<ReturnType<typeof getPodcastAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPodcastAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPodcastAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getPodcastAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPodcastAdDraft<TData = Awaited<ReturnType<typeof getPodcastAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPodcastAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPodcastAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getPodcastAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPodcastAdDraft<TData = Awaited<ReturnType<typeof getPodcastAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPodcastAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Podcast Ad Draft
 */

export function useGetPodcastAdDraft<TData = Awaited<ReturnType<typeof getPodcastAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPodcastAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPodcastAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWritePodcastAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/podcast-ad/draft`
}

/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved, as live locks the form.
 * @summary Write Podcast Ad Draft
 */
export const writePodcastAdDraft = async (teamId: string,
    brandId: string,
    podcastAdDraftWrite: PodcastAdDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<PodcastAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PodcastAdDraft>(getWritePodcastAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(podcastAdDraftWrite)
  }
);}





export const getWritePodcastAdDraftMutationKey = () => ['writePodcastAdDraft'] as const;

export const getWritePodcastAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePodcastAdDraft>>, TError,WritePodcastAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writePodcastAdDraft>>, TError,WritePodcastAdDraftMutationVariables, TContext> => {

const mutationKey = getWritePodcastAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writePodcastAdDraft>>, WritePodcastAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writePodcastAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WritePodcastAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writePodcastAdDraft>>>
    export type WritePodcastAdDraftMutationBody = PodcastAdDraftWrite
    export type WritePodcastAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WritePodcastAdDraftMutationVariables = {teamId: string;brandId: string;data: PodcastAdDraftWrite}

    /**
 * @summary Write Podcast Ad Draft
 */
export const useWritePodcastAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePodcastAdDraft>>, TError,WritePodcastAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writePodcastAdDraft>>,
        TError,
        WritePodcastAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWritePodcastAdDraftMutationOptions(options), queryClient);
    }
    export const getApprovePodcastAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/podcast-ad/draft/approve`
}

/**
 * Live's Approve script: the script checked as live's form checks it (422 at `script`
 * with live's words), approved, and the shot director started. A spec that breaks the
 * script is redone once, then refused (`problem`) and the draft goes back to its
 * script.
 * @summary Approve Podcast Ad Script
 */
export const approvePodcastAdScript = async (teamId: string,
    brandId: string,
    podcastAdApproval: PodcastAdApproval, options?: Parameters<typeof apiRequest>[1]): Promise<PodcastAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PodcastAdDraft>(getApprovePodcastAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(podcastAdApproval)
  }
);}





export const getApprovePodcastAdScriptMutationKey = () => ['approvePodcastAdScript'] as const;

export const getApprovePodcastAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePodcastAdScript>>, TError,ApprovePodcastAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approvePodcastAdScript>>, TError,ApprovePodcastAdScriptMutationVariables, TContext> => {

const mutationKey = getApprovePodcastAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approvePodcastAdScript>>, ApprovePodcastAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approvePodcastAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApprovePodcastAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approvePodcastAdScript>>>
    export type ApprovePodcastAdScriptMutationBody = PodcastAdApproval
    export type ApprovePodcastAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApprovePodcastAdScriptMutationVariables = {teamId: string;brandId: string;data: PodcastAdApproval}

    /**
 * @summary Approve Podcast Ad Script
 */
export const useApprovePodcastAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approvePodcastAdScript>>, TError,ApprovePodcastAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approvePodcastAdScript>>,
        TError,
        ApprovePodcastAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApprovePodcastAdScriptMutationOptions(options), queryClient);
    }
    export const getFixPodcastAdLabelUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/podcast-ad/draft/fix-label`
}

/**
 * Live's Fix label: the master drawn again from itself and the packshot, its label
 * made the product's, and the close-ups drawn from it again. `TEMPLATE_DRAFT_LOCKED` (409)
 * unless the master is done and nothing works.
 * @summary Fix Podcast Ad Label
 */
export const fixPodcastAdLabel = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<PodcastAdDraft> => {

  return apiRequest<PodcastAdDraft>(getFixPodcastAdLabelUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getFixPodcastAdLabelMutationKey = () => ['fixPodcastAdLabel'] as const;

export const getFixPodcastAdLabelMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fixPodcastAdLabel>>, TError,FixPodcastAdLabelMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fixPodcastAdLabel>>, TError,FixPodcastAdLabelMutationVariables, TContext> => {

const mutationKey = getFixPodcastAdLabelMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fixPodcastAdLabel>>, FixPodcastAdLabelMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  fixPodcastAdLabel(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FixPodcastAdLabelMutationResult = NonNullable<Awaited<ReturnType<typeof fixPodcastAdLabel>>>

    export type FixPodcastAdLabelMutationError = ErrorType<ErrorEnvelope>
    export type FixPodcastAdLabelMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Fix Podcast Ad Label
 */
export const useFixPodcastAdLabel = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fixPodcastAdLabel>>, TError,FixPodcastAdLabelMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof fixPodcastAdLabel>>,
        TError,
        FixPodcastAdLabelMutationVariables,
        TContext
      > => {
      return useMutation(getFixPodcastAdLabelMutationOptions(options), queryClient);
    }
    export const getWritePodcastAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/podcast-ad/draft/script`
}

/**
 * Live's Generate script: the script director on the product's page (a product and
 * its packshot first, live's "Pick a product and its packshot", 422). Its answer fills
 * the draft when it ends: a claim not quoted from the page is redone once, then flagged
 * (`script_warning`).
 * @summary Write Podcast Ad Script
 */
export const writePodcastAdScript = async (teamId: string,
    brandId: string,
    podcastAdScriptAsk: PodcastAdScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<PodcastAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<PodcastAdDraft>(getWritePodcastAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(podcastAdScriptAsk)
  }
);}





export const getWritePodcastAdScriptMutationKey = () => ['writePodcastAdScript'] as const;

export const getWritePodcastAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePodcastAdScript>>, TError,WritePodcastAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writePodcastAdScript>>, TError,WritePodcastAdScriptMutationVariables, TContext> => {

const mutationKey = getWritePodcastAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writePodcastAdScript>>, WritePodcastAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writePodcastAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WritePodcastAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writePodcastAdScript>>>
    export type WritePodcastAdScriptMutationBody = PodcastAdScriptAsk
    export type WritePodcastAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WritePodcastAdScriptMutationVariables = {teamId: string;brandId: string;data: PodcastAdScriptAsk}

    /**
 * @summary Write Podcast Ad Script
 */
export const useWritePodcastAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writePodcastAdScript>>, TError,WritePodcastAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writePodcastAdScript>>,
        TError,
        WritePodcastAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWritePodcastAdScriptMutationOptions(options), queryClient);
    }
    export const getRegeneratePodcastAdStillUrl = (teamId: string,
    brandId: string,
    name: 'master' | 'host_close' | 'guest_close' | 'guest_hold' | 'end_card',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/podcast-ad/draft/stills/${name}/regenerate`
}

/**
 * Live's ↻ on a cast still (`master`, `host_close`, `guest_close`, `guest_hold`,
 * `end_card`): it and every still drawn from it drawn again, each a paid image as the
 * first was. `TEMPLATE_DRAFT_LOCKED` (409) before the cast or while anything works.
 * @summary Regenerate Podcast Ad Still
 */
export const regeneratePodcastAdStill = async (teamId: string,
    brandId: string,
    name: 'master' | 'host_close' | 'guest_close' | 'guest_hold' | 'end_card', options?: Parameters<typeof apiRequest>[1]): Promise<PodcastAdDraft> => {

  return apiRequest<PodcastAdDraft>(getRegeneratePodcastAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegeneratePodcastAdStillMutationKey = () => ['regeneratePodcastAdStill'] as const;

export const getRegeneratePodcastAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePodcastAdStill>>, TError,RegeneratePodcastAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regeneratePodcastAdStill>>, TError,RegeneratePodcastAdStillMutationVariables, TContext> => {

const mutationKey = getRegeneratePodcastAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regeneratePodcastAdStill>>, RegeneratePodcastAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regeneratePodcastAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegeneratePodcastAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regeneratePodcastAdStill>>>

    export type RegeneratePodcastAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegeneratePodcastAdStillMutationVariables = {teamId: string;brandId: string;name: 'master' | 'host_close' | 'guest_close' | 'guest_hold' | 'end_card'}

    /**
 * @summary Regenerate Podcast Ad Still
 */
export const useRegeneratePodcastAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regeneratePodcastAdStill>>, TError,RegeneratePodcastAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regeneratePodcastAdStill>>,
        TError,
        RegeneratePodcastAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegeneratePodcastAdStillMutationOptions(options), queryClient);
    }
    export const getResetStreetInterviewAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/street-interview-ad/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while anything works.
 * @summary Reset Street Interview Ad Draft
 */
export const resetStreetInterviewAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<StreetInterviewAdDraft> => {

  return apiRequest<StreetInterviewAdDraft>(getResetStreetInterviewAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetStreetInterviewAdDraftMutationKey = () => ['resetStreetInterviewAdDraft'] as const;

export const getResetStreetInterviewAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetStreetInterviewAdDraft>>, TError,ResetStreetInterviewAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetStreetInterviewAdDraft>>, TError,ResetStreetInterviewAdDraftMutationVariables, TContext> => {

const mutationKey = getResetStreetInterviewAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetStreetInterviewAdDraft>>, ResetStreetInterviewAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetStreetInterviewAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetStreetInterviewAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetStreetInterviewAdDraft>>>

    export type ResetStreetInterviewAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetStreetInterviewAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Street Interview Ad Draft
 */
export const useResetStreetInterviewAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetStreetInterviewAdDraft>>, TError,ResetStreetInterviewAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetStreetInterviewAdDraft>>,
        TError,
        ResetStreetInterviewAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetStreetInterviewAdDraftMutationOptions(options), queryClient);
    }
    export const getGetStreetInterviewAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/street-interview-ad/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Street Interview Ad Draft
 */
export const getStreetInterviewAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<StreetInterviewAdDraft> => {

  return apiRequest<StreetInterviewAdDraft>(getGetStreetInterviewAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStreetInterviewAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/street-interview-ad/draft`
    ] as const;
    }


export const getGetStreetInterviewAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStreetInterviewAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStreetInterviewAdDraft>>> = ({ signal }) => getStreetInterviewAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetStreetInterviewAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getStreetInterviewAdDraft>>>
export type GetStreetInterviewAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetStreetInterviewAdDraft<TData = Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreetInterviewAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getStreetInterviewAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreetInterviewAdDraft<TData = Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStreetInterviewAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getStreetInterviewAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetStreetInterviewAdDraft<TData = Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Street Interview Ad Draft
 */

export function useGetStreetInterviewAdDraft<TData = Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getStreetInterviewAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetStreetInterviewAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteStreetInterviewAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/street-interview-ad/draft`
}

/**
 * The form as it stands and its script as edited. `TEMPLATE_DRAFT_LOCKED` (409) while
 * a director works or once the script is approved, as live locks the form.
 * @summary Write Street Interview Ad Draft
 */
export const writeStreetInterviewAdDraft = async (teamId: string,
    brandId: string,
    streetInterviewAdDraftWrite: StreetInterviewAdDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<StreetInterviewAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<StreetInterviewAdDraft>(getWriteStreetInterviewAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(streetInterviewAdDraftWrite)
  }
);}





export const getWriteStreetInterviewAdDraftMutationKey = () => ['writeStreetInterviewAdDraft'] as const;

export const getWriteStreetInterviewAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeStreetInterviewAdDraft>>, TError,WriteStreetInterviewAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeStreetInterviewAdDraft>>, TError,WriteStreetInterviewAdDraftMutationVariables, TContext> => {

const mutationKey = getWriteStreetInterviewAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeStreetInterviewAdDraft>>, WriteStreetInterviewAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeStreetInterviewAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteStreetInterviewAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeStreetInterviewAdDraft>>>
    export type WriteStreetInterviewAdDraftMutationBody = StreetInterviewAdDraftWrite
    export type WriteStreetInterviewAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteStreetInterviewAdDraftMutationVariables = {teamId: string;brandId: string;data: StreetInterviewAdDraftWrite}

    /**
 * @summary Write Street Interview Ad Draft
 */
export const useWriteStreetInterviewAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeStreetInterviewAdDraft>>, TError,WriteStreetInterviewAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeStreetInterviewAdDraft>>,
        TError,
        WriteStreetInterviewAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteStreetInterviewAdDraftMutationOptions(options), queryClient);
    }
    export const getApproveStreetInterviewAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/street-interview-ad/draft/approve`
}

/**
 * Live's Approve script: its 17 lines in their beats, each with its text (422 at
 * `script` with live's words), approved; the shot director, then the location and the
 * five people. A spec that breaks the script is redone once, then refused (`problem`).
 * @summary Approve Street Interview Ad Script
 */
export const approveStreetInterviewAdScript = async (teamId: string,
    brandId: string,
    streetInterviewAdApproval: StreetInterviewAdApproval, options?: Parameters<typeof apiRequest>[1]): Promise<StreetInterviewAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<StreetInterviewAdDraft>(getApproveStreetInterviewAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(streetInterviewAdApproval)
  }
);}





export const getApproveStreetInterviewAdScriptMutationKey = () => ['approveStreetInterviewAdScript'] as const;

export const getApproveStreetInterviewAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveStreetInterviewAdScript>>, TError,ApproveStreetInterviewAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveStreetInterviewAdScript>>, TError,ApproveStreetInterviewAdScriptMutationVariables, TContext> => {

const mutationKey = getApproveStreetInterviewAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveStreetInterviewAdScript>>, ApproveStreetInterviewAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveStreetInterviewAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveStreetInterviewAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveStreetInterviewAdScript>>>
    export type ApproveStreetInterviewAdScriptMutationBody = StreetInterviewAdApproval
    export type ApproveStreetInterviewAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveStreetInterviewAdScriptMutationVariables = {teamId: string;brandId: string;data: StreetInterviewAdApproval}

    /**
 * @summary Approve Street Interview Ad Script
 */
export const useApproveStreetInterviewAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveStreetInterviewAdScript>>, TError,ApproveStreetInterviewAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveStreetInterviewAdScript>>,
        TError,
        ApproveStreetInterviewAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveStreetInterviewAdScriptMutationOptions(options), queryClient);
    }
    export const getApproveStreetInterviewAdCastUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/street-interview-ad/draft/approve-cast`
}

/**
 * Live's Approve cast: the keyframes, each as the stills it is drawn from are done.
 * `TEMPLATE_DRAFT_LOCKED` (409) until the location and the five people are.
 * @summary Approve Street Interview Ad Cast
 */
export const approveStreetInterviewAdCast = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<StreetInterviewAdDraft> => {

  return apiRequest<StreetInterviewAdDraft>(getApproveStreetInterviewAdCastUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveStreetInterviewAdCastMutationKey = () => ['approveStreetInterviewAdCast'] as const;

export const getApproveStreetInterviewAdCastMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveStreetInterviewAdCast>>, TError,ApproveStreetInterviewAdCastMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveStreetInterviewAdCast>>, TError,ApproveStreetInterviewAdCastMutationVariables, TContext> => {

const mutationKey = getApproveStreetInterviewAdCastMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveStreetInterviewAdCast>>, ApproveStreetInterviewAdCastMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  approveStreetInterviewAdCast(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveStreetInterviewAdCastMutationResult = NonNullable<Awaited<ReturnType<typeof approveStreetInterviewAdCast>>>

    export type ApproveStreetInterviewAdCastMutationError = ErrorType<ErrorEnvelope>
    export type ApproveStreetInterviewAdCastMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Approve Street Interview Ad Cast
 */
export const useApproveStreetInterviewAdCast = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveStreetInterviewAdCast>>, TError,ApproveStreetInterviewAdCastMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveStreetInterviewAdCast>>,
        TError,
        ApproveStreetInterviewAdCastMutationVariables,
        TContext
      > => {
      return useMutation(getApproveStreetInterviewAdCastMutationOptions(options), queryClient);
    }
    export const getWriteStreetInterviewAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/street-interview-ad/draft/script`
}

/**
 * Live's Generate Script: an uploaded packshot with no name or no text typed is read
 * first (`pack_director`; an unreadable one sets `pack_warning`), then the script
 * director; a script off its beats or quoting off the product text is redone once, then
 * flagged (`script_warning`).
 * @summary Write Street Interview Ad Script
 */
export const writeStreetInterviewAdScript = async (teamId: string,
    brandId: string,
    streetInterviewAdScriptAsk: StreetInterviewAdScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<StreetInterviewAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<StreetInterviewAdDraft>(getWriteStreetInterviewAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(streetInterviewAdScriptAsk)
  }
);}





export const getWriteStreetInterviewAdScriptMutationKey = () => ['writeStreetInterviewAdScript'] as const;

export const getWriteStreetInterviewAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeStreetInterviewAdScript>>, TError,WriteStreetInterviewAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeStreetInterviewAdScript>>, TError,WriteStreetInterviewAdScriptMutationVariables, TContext> => {

const mutationKey = getWriteStreetInterviewAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeStreetInterviewAdScript>>, WriteStreetInterviewAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeStreetInterviewAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteStreetInterviewAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeStreetInterviewAdScript>>>
    export type WriteStreetInterviewAdScriptMutationBody = StreetInterviewAdScriptAsk
    export type WriteStreetInterviewAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteStreetInterviewAdScriptMutationVariables = {teamId: string;brandId: string;data: StreetInterviewAdScriptAsk}

    /**
 * @summary Write Street Interview Ad Script
 */
export const useWriteStreetInterviewAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeStreetInterviewAdScript>>, TError,WriteStreetInterviewAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeStreetInterviewAdScript>>,
        TError,
        WriteStreetInterviewAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteStreetInterviewAdScriptMutationOptions(options), queryClient);
    }
    export const getRegenerateStreetInterviewAdStillUrl = (teamId: string,
    brandId: string,
    name: 'street' | 'sheet_int' | 'sheet_p1' | 'sheet_p2' | 'sheet_p3' | 'sheet_p4' | 'two_1' | 'single_2' | 'single_3' | 'single_4' | 'handover_3' | 'hold_2' | 'hold_1' | 'two_3_hold' | 'hold_3' | 'signoff' | 'end_card',) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/street-interview-ad/draft/stills/${name}/regenerate`
}

/**
 * Live's ↻ on a still: it and every still drawn from it in the stage drawn again,
 * each a paid image as the first was. `TEMPLATE_DRAFT_LOCKED` (409) before the cast, for
 * a keyframe before Approve cast, or while anything works.
 * @summary Regenerate Street Interview Ad Still
 */
export const regenerateStreetInterviewAdStill = async (teamId: string,
    brandId: string,
    name: 'street' | 'sheet_int' | 'sheet_p1' | 'sheet_p2' | 'sheet_p3' | 'sheet_p4' | 'two_1' | 'single_2' | 'single_3' | 'single_4' | 'handover_3' | 'hold_2' | 'hold_1' | 'two_3_hold' | 'hold_3' | 'signoff' | 'end_card', options?: Parameters<typeof apiRequest>[1]): Promise<StreetInterviewAdDraft> => {

  return apiRequest<StreetInterviewAdDraft>(getRegenerateStreetInterviewAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateStreetInterviewAdStillMutationKey = () => ['regenerateStreetInterviewAdStill'] as const;

export const getRegenerateStreetInterviewAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateStreetInterviewAdStill>>, TError,RegenerateStreetInterviewAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateStreetInterviewAdStill>>, TError,RegenerateStreetInterviewAdStillMutationVariables, TContext> => {

const mutationKey = getRegenerateStreetInterviewAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateStreetInterviewAdStill>>, RegenerateStreetInterviewAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateStreetInterviewAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateStreetInterviewAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateStreetInterviewAdStill>>>

    export type RegenerateStreetInterviewAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateStreetInterviewAdStillMutationVariables = {teamId: string;brandId: string;name: 'street' | 'sheet_int' | 'sheet_p1' | 'sheet_p2' | 'sheet_p3' | 'sheet_p4' | 'two_1' | 'single_2' | 'single_3' | 'single_4' | 'handover_3' | 'hold_2' | 'hold_1' | 'two_3_hold' | 'hold_3' | 'signoff' | 'end_card'}

    /**
 * @summary Regenerate Street Interview Ad Still
 */
export const useRegenerateStreetInterviewAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateStreetInterviewAdStill>>, TError,RegenerateStreetInterviewAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateStreetInterviewAdStill>>,
        TError,
        RegenerateStreetInterviewAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateStreetInterviewAdStillMutationOptions(options), queryClient);
    }
    export const getResetYapperAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/yapper-ad/draft`
}

/**
 * Start over: an empty draft. `TEMPLATE_DRAFT_LOCKED` (409) while a director works.
 * @summary Reset Yapper Ad Draft
 */
export const resetYapperAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<YapperAdDraft> => {

  return apiRequest<YapperAdDraft>(getResetYapperAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getResetYapperAdDraftMutationKey = () => ['resetYapperAdDraft'] as const;

export const getResetYapperAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetYapperAdDraft>>, TError,ResetYapperAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof resetYapperAdDraft>>, TError,ResetYapperAdDraftMutationVariables, TContext> => {

const mutationKey = getResetYapperAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetYapperAdDraft>>, ResetYapperAdDraftMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  resetYapperAdDraft(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResetYapperAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof resetYapperAdDraft>>>

    export type ResetYapperAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type ResetYapperAdDraftMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Reset Yapper Ad Draft
 */
export const useResetYapperAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetYapperAdDraft>>, TError,ResetYapperAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetYapperAdDraft>>,
        TError,
        ResetYapperAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getResetYapperAdDraftMutationOptions(options), queryClient);
    }
    export const getGetYapperAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/yapper-ad/draft`
}

/**
 * The member's draft, or an empty one: what the form opens with.
 * @summary Get Yapper Ad Draft
 */
export const getYapperAdDraft = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<YapperAdDraft> => {

  return apiRequest<YapperAdDraft>(getGetYapperAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetYapperAdDraftQueryKey = (teamId: string,
    brandId: string,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/templates/yapper-ad/draft`
    ] as const;
    }


export const getGetYapperAdDraftQueryOptions = <TData = Awaited<ReturnType<typeof getYapperAdDraft>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYapperAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetYapperAdDraftQueryKey(teamId,brandId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getYapperAdDraft>>> = ({ signal }) => getYapperAdDraft(teamId,brandId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getYapperAdDraft>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetYapperAdDraftQueryResult = NonNullable<Awaited<ReturnType<typeof getYapperAdDraft>>>
export type GetYapperAdDraftQueryError = ErrorType<ErrorEnvelope>


export function useGetYapperAdDraft<TData = Awaited<ReturnType<typeof getYapperAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYapperAdDraft>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getYapperAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getYapperAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetYapperAdDraft<TData = Awaited<ReturnType<typeof getYapperAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYapperAdDraft>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getYapperAdDraft>>,
          TError,
          Awaited<ReturnType<typeof getYapperAdDraft>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetYapperAdDraft<TData = Awaited<ReturnType<typeof getYapperAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYapperAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Yapper Ad Draft
 */

export function useGetYapperAdDraft<TData = Awaited<ReturnType<typeof getYapperAdDraft>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getYapperAdDraft>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetYapperAdDraftQueryOptions(teamId,brandId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getWriteYapperAdDraftUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/yapper-ad/draft`
}

/**
 * The form as it stands and its script as edited, the script's problems read again.
 * `TEMPLATE_DRAFT_LOCKED` (409) while a director works, as live locks the form.
 * @summary Write Yapper Ad Draft
 */
export const writeYapperAdDraft = async (teamId: string,
    brandId: string,
    yapperAdDraftWrite: YapperAdDraftWrite, options?: Parameters<typeof apiRequest>[1]): Promise<YapperAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<YapperAdDraft>(getWriteYapperAdDraftUrl(teamId,brandId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(yapperAdDraftWrite)
  }
);}





export const getWriteYapperAdDraftMutationKey = () => ['writeYapperAdDraft'] as const;

export const getWriteYapperAdDraftMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeYapperAdDraft>>, TError,WriteYapperAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeYapperAdDraft>>, TError,WriteYapperAdDraftMutationVariables, TContext> => {

const mutationKey = getWriteYapperAdDraftMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeYapperAdDraft>>, WriteYapperAdDraftMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeYapperAdDraft(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteYapperAdDraftMutationResult = NonNullable<Awaited<ReturnType<typeof writeYapperAdDraft>>>
    export type WriteYapperAdDraftMutationBody = YapperAdDraftWrite
    export type WriteYapperAdDraftMutationError = ErrorType<ErrorEnvelope>
    export type WriteYapperAdDraftMutationVariables = {teamId: string;brandId: string;data: YapperAdDraftWrite}

    /**
 * @summary Write Yapper Ad Draft
 */
export const useWriteYapperAdDraft = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeYapperAdDraft>>, TError,WriteYapperAdDraftMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeYapperAdDraft>>,
        TError,
        WriteYapperAdDraftMutationVariables,
        TContext
      > => {
      return useMutation(getWriteYapperAdDraftMutationOptions(options), queryClient);
    }
    export const getApproveYapperAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/yapper-ad/draft/approve`
}

/**
 * Live's approval 1: the script checked (422 at `script` in live's words: 4 to 10
 * clips, none empty, the first a talk clip), kept, and the stage the stills'; then the
 * shot director: the locks, then the clip plan (2 tries each, the best kept), the product
 * settled. Either failing for good: `shot_director` `failed` with live's words, the
 * draft kept at its stills.
 * @summary Approve Yapper Ad Script
 */
export const approveYapperAdScript = async (teamId: string,
    brandId: string,
    yapperAdApproval: YapperAdApproval, options?: Parameters<typeof apiRequest>[1]): Promise<YapperAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<YapperAdDraft>(getApproveYapperAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(yapperAdApproval)
  }
);}





export const getApproveYapperAdScriptMutationKey = () => ['approveYapperAdScript'] as const;

export const getApproveYapperAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveYapperAdScript>>, TError,ApproveYapperAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof approveYapperAdScript>>, TError,ApproveYapperAdScriptMutationVariables, TContext> => {

const mutationKey = getApproveYapperAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveYapperAdScript>>, ApproveYapperAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  approveYapperAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveYapperAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof approveYapperAdScript>>>
    export type ApproveYapperAdScriptMutationBody = YapperAdApproval
    export type ApproveYapperAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type ApproveYapperAdScriptMutationVariables = {teamId: string;brandId: string;data: YapperAdApproval}

    /**
 * @summary Approve Yapper Ad Script
 */
export const useApproveYapperAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveYapperAdScript>>, TError,ApproveYapperAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveYapperAdScript>>,
        TError,
        ApproveYapperAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getApproveYapperAdScriptMutationOptions(options), queryClient);
    }
    export const getBackToYapperAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/yapper-ad/draft/back`
}

/**
 * Live's Back to script: the script kept, the shot let go, the form open again.
 * `TEMPLATE_DRAFT_LOCKED` (409) before approval 1 or while anything works.
 * @summary Back To Yapper Ad Script
 */
export const backToYapperAdScript = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<YapperAdDraft> => {

  return apiRequest<YapperAdDraft>(getBackToYapperAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getBackToYapperAdScriptMutationKey = () => ['backToYapperAdScript'] as const;

export const getBackToYapperAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToYapperAdScript>>, TError,BackToYapperAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof backToYapperAdScript>>, TError,BackToYapperAdScriptMutationVariables, TContext> => {

const mutationKey = getBackToYapperAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof backToYapperAdScript>>, BackToYapperAdScriptMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  backToYapperAdScript(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BackToYapperAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof backToYapperAdScript>>>

    export type BackToYapperAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type BackToYapperAdScriptMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Back To Yapper Ad Script
 */
export const useBackToYapperAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof backToYapperAdScript>>, TError,BackToYapperAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof backToYapperAdScript>>,
        TError,
        BackToYapperAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getBackToYapperAdScriptMutationOptions(options), queryClient);
    }
    export const getWriteYapperAdScriptUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/yapper-ad/draft/script`
}

/**
 * Live's ✦ Generate script: for Auto the setting director (2 tries), then the script
 * director (3 tries), each try told what the last failed; the try with the fewest failed
 * checks kept, with live's warning where it still fails (`script_warning`).
 * @summary Write Yapper Ad Script
 */
export const writeYapperAdScript = async (teamId: string,
    brandId: string,
    yapperAdScriptAsk: YapperAdScriptAsk, options?: Parameters<typeof apiRequest>[1]): Promise<YapperAdDraft> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<YapperAdDraft>(getWriteYapperAdScriptUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(yapperAdScriptAsk)
  }
);}





export const getWriteYapperAdScriptMutationKey = () => ['writeYapperAdScript'] as const;

export const getWriteYapperAdScriptMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeYapperAdScript>>, TError,WriteYapperAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof writeYapperAdScript>>, TError,WriteYapperAdScriptMutationVariables, TContext> => {

const mutationKey = getWriteYapperAdScriptMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof writeYapperAdScript>>, WriteYapperAdScriptMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  writeYapperAdScript(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WriteYapperAdScriptMutationResult = NonNullable<Awaited<ReturnType<typeof writeYapperAdScript>>>
    export type WriteYapperAdScriptMutationBody = YapperAdScriptAsk
    export type WriteYapperAdScriptMutationError = ErrorType<ErrorEnvelope>
    export type WriteYapperAdScriptMutationVariables = {teamId: string;brandId: string;data: YapperAdScriptAsk}

    /**
 * @summary Write Yapper Ad Script
 */
export const useWriteYapperAdScript = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof writeYapperAdScript>>, TError,WriteYapperAdScriptMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof writeYapperAdScript>>,
        TError,
        WriteYapperAdScriptMutationVariables,
        TContext
      > => {
      return useMutation(getWriteYapperAdScriptMutationOptions(options), queryClient);
    }
    export const getRetryYapperAdShotUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/yapper-ad/draft/shot`
}

/**
 * Live's retry of a failed shot director: the locks asked again, then the clip plan.
 * `TEMPLATE_DRAFT_LOCKED` (409) unless the shot director failed and nothing works.
 * @summary Retry Yapper Ad Shot
 */
export const retryYapperAdShot = async (teamId: string,
    brandId: string, options?: Parameters<typeof apiRequest>[1]): Promise<YapperAdDraft> => {

  return apiRequest<YapperAdDraft>(getRetryYapperAdShotUrl(teamId,brandId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRetryYapperAdShotMutationKey = () => ['retryYapperAdShot'] as const;

export const getRetryYapperAdShotMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryYapperAdShot>>, TError,RetryYapperAdShotMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof retryYapperAdShot>>, TError,RetryYapperAdShotMutationVariables, TContext> => {

const mutationKey = getRetryYapperAdShotMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryYapperAdShot>>, RetryYapperAdShotMutationVariables> = (props) => {
          const {teamId,brandId} = props ?? {};

          return  retryYapperAdShot(teamId,brandId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryYapperAdShotMutationResult = NonNullable<Awaited<ReturnType<typeof retryYapperAdShot>>>

    export type RetryYapperAdShotMutationError = ErrorType<ErrorEnvelope>
    export type RetryYapperAdShotMutationVariables = {teamId: string;brandId: string}

    /**
 * @summary Retry Yapper Ad Shot
 */
export const useRetryYapperAdShot = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryYapperAdShot>>, TError,RetryYapperAdShotMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof retryYapperAdShot>>,
        TError,
        RetryYapperAdShotMutationVariables,
        TContext
      > => {
      return useMutation(getRetryYapperAdShotMutationOptions(options), queryClient);
    }
    export const getRegenerateYapperAdStillUrl = (teamId: string,
    brandId: string,
    name: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/templates/yapper-ad/draft/stills/${name}/regenerate`
}

/**
 * Live's ↻ on a still: it and every still drawn from it drawn again, each a paid image
 * as the first was (a new sheet draws every clip's still again, the end card and the
 * bubble are drawn alone). `TEMPLATE_DRAFT_LOCKED` (409) before approval 1, for a still
 * the draft does not draw (yet), or while anything works.
 * @summary Regenerate Yapper Ad Still
 */
export const regenerateYapperAdStill = async (teamId: string,
    brandId: string,
    name: string, options?: Parameters<typeof apiRequest>[1]): Promise<YapperAdDraft> => {

  return apiRequest<YapperAdDraft>(getRegenerateYapperAdStillUrl(teamId,brandId,name),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRegenerateYapperAdStillMutationKey = () => ['regenerateYapperAdStill'] as const;

export const getRegenerateYapperAdStillMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateYapperAdStill>>, TError,RegenerateYapperAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof regenerateYapperAdStill>>, TError,RegenerateYapperAdStillMutationVariables, TContext> => {

const mutationKey = getRegenerateYapperAdStillMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof regenerateYapperAdStill>>, RegenerateYapperAdStillMutationVariables> = (props) => {
          const {teamId,brandId,name} = props ?? {};

          return  regenerateYapperAdStill(teamId,brandId,name,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RegenerateYapperAdStillMutationResult = NonNullable<Awaited<ReturnType<typeof regenerateYapperAdStill>>>

    export type RegenerateYapperAdStillMutationError = ErrorType<ErrorEnvelope>
    export type RegenerateYapperAdStillMutationVariables = {teamId: string;brandId: string;name: string}

    /**
 * @summary Regenerate Yapper Ad Still
 */
export const useRegenerateYapperAdStill = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof regenerateYapperAdStill>>, TError,RegenerateYapperAdStillMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof regenerateYapperAdStill>>,
        TError,
        RegenerateYapperAdStillMutationVariables,
        TContext
      > => {
      return useMutation(getRegenerateYapperAdStillMutationOptions(options), queryClient);
    }
    export const getListVoicesUrl = (teamId: string,
    brandId: string,
    params?: ListVoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/brands/${brandId}/voices?${stringifiedParams}` : `/api/v1/teams/${teamId}/brands/${brandId}/voices`
}

/**
 * Live's voice picker: the global voices (its actors') by name, narrowed by gender, age
 * and part of a name, each with its sample's signed URL; `kind=team`, the brand's own,
 * newest first.
 * @summary List Voices
 */
export const listVoices = async (teamId: string,
    brandId: string,
    params?: ListVoicesParams, options?: Parameters<typeof apiRequest>[1]): Promise<VoicePage> => {

  return apiRequest<VoicePage>(getListVoicesUrl(teamId,brandId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListVoicesQueryKey = (teamId: string,
    brandId: string,
    params?: ListVoicesParams,) => {
    return [
    `/api/v1/teams/${teamId}/brands/${brandId}/voices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListVoicesQueryOptions = <TData = Awaited<ReturnType<typeof listVoices>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    brandId: string,
    params?: ListVoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVoices>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListVoicesQueryKey(teamId,brandId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listVoices>>> = ({ signal }) => listVoices(teamId,brandId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && brandId !== null && brandId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listVoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListVoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listVoices>>>
export type ListVoicesQueryError = ErrorType<ErrorEnvelope>


export function useListVoices<TData = Awaited<ReturnType<typeof listVoices>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params: undefined |  ListVoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVoices>>,
          TError,
          Awaited<ReturnType<typeof listVoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVoices<TData = Awaited<ReturnType<typeof listVoices>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListVoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVoices>>,
          TError,
          Awaited<ReturnType<typeof listVoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListVoices<TData = Awaited<ReturnType<typeof listVoices>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListVoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVoices>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Voices
 */

export function useListVoices<TData = Awaited<ReturnType<typeof listVoices>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    brandId: string,
    params?: ListVoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listVoices>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListVoicesQueryOptions(teamId,brandId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSaveDesignedVoiceUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/voices/from-design`
}

/**
 * Keep a designed voice (a delivered `voice.design` job of the brand) as the brand's:
 * its preview becomes the sample. A second save returns the same voice. 404 when the job is
 * missing, not a voice design or another brand's; 422 while it is not designed yet or once
 * its preview has expired.
 * @summary Save Designed Voice
 */
export const saveDesignedVoice = async (teamId: string,
    brandId: string,
    voiceFromDesignRequest: VoiceFromDesignRequest, options?: Parameters<typeof apiRequest>[1]): Promise<Voice> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Voice>(getSaveDesignedVoiceUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(voiceFromDesignRequest)
  }
);}





export const getSaveDesignedVoiceMutationKey = () => ['saveDesignedVoice'] as const;

export const getSaveDesignedVoiceMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveDesignedVoice>>, TError,SaveDesignedVoiceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof saveDesignedVoice>>, TError,SaveDesignedVoiceMutationVariables, TContext> => {

const mutationKey = getSaveDesignedVoiceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveDesignedVoice>>, SaveDesignedVoiceMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  saveDesignedVoice(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveDesignedVoiceMutationResult = NonNullable<Awaited<ReturnType<typeof saveDesignedVoice>>>
    export type SaveDesignedVoiceMutationBody = VoiceFromDesignRequest
    export type SaveDesignedVoiceMutationError = ErrorType<ErrorEnvelope>
    export type SaveDesignedVoiceMutationVariables = {teamId: string;brandId: string;data: VoiceFromDesignRequest}

    /**
 * @summary Save Designed Voice
 */
export const useSaveDesignedVoice = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveDesignedVoice>>, TError,SaveDesignedVoiceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveDesignedVoice>>,
        TError,
        SaveDesignedVoiceMutationVariables,
        TContext
      > => {
      return useMutation(getSaveDesignedVoiceMutationOptions(options), queryClient);
    }
    export const getPrepareVoiceUploadUrl = (teamId: string,
    brandId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/voices/uploads`
}

/**
 * A new voice's id and the form to post its sample with (an upload or a recording): an
 * MP3, M4A or WAV of up to 20 MB. Nothing is kept until `complete`.
 * @summary Prepare Voice Upload
 */
export const prepareVoiceUpload = async (teamId: string,
    brandId: string,
    voiceUploadRequest: VoiceUploadRequest, options?: Parameters<typeof apiRequest>[1]): Promise<VoiceUploadTicket> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<VoiceUploadTicket>(getPrepareVoiceUploadUrl(teamId,brandId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(voiceUploadRequest)
  }
);}





export const getPrepareVoiceUploadMutationKey = () => ['prepareVoiceUpload'] as const;

export const getPrepareVoiceUploadMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareVoiceUpload>>, TError,PrepareVoiceUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof prepareVoiceUpload>>, TError,PrepareVoiceUploadMutationVariables, TContext> => {

const mutationKey = getPrepareVoiceUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof prepareVoiceUpload>>, PrepareVoiceUploadMutationVariables> = (props) => {
          const {teamId,brandId,data} = props ?? {};

          return  prepareVoiceUpload(teamId,brandId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PrepareVoiceUploadMutationResult = NonNullable<Awaited<ReturnType<typeof prepareVoiceUpload>>>
    export type PrepareVoiceUploadMutationBody = VoiceUploadRequest
    export type PrepareVoiceUploadMutationError = ErrorType<ErrorEnvelope>
    export type PrepareVoiceUploadMutationVariables = {teamId: string;brandId: string;data: VoiceUploadRequest}

    /**
 * @summary Prepare Voice Upload
 */
export const usePrepareVoiceUpload = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof prepareVoiceUpload>>, TError,PrepareVoiceUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof prepareVoiceUpload>>,
        TError,
        PrepareVoiceUploadMutationVariables,
        TContext
      > => {
      return useMutation(getPrepareVoiceUploadMutationOptions(options), queryClient);
    }
    export const getDeleteVoiceUrl = (teamId: string,
    brandId: string,
    voiceId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/voices/${voiceId}`
}

/**
 * One of the brand's voices, by its creator, an admin or the owner. A global voice is
 * not found here.
 * @summary Delete Voice
 */
export const deleteVoice = async (teamId: string,
    brandId: string,
    voiceId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteVoiceUrl(teamId,brandId,voiceId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteVoiceMutationKey = () => ['deleteVoice'] as const;

export const getDeleteVoiceMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVoice>>, TError,DeleteVoiceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteVoice>>, TError,DeleteVoiceMutationVariables, TContext> => {

const mutationKey = getDeleteVoiceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteVoice>>, DeleteVoiceMutationVariables> = (props) => {
          const {teamId,brandId,voiceId} = props ?? {};

          return  deleteVoice(teamId,brandId,voiceId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteVoiceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteVoice>>>

    export type DeleteVoiceMutationError = ErrorType<ErrorEnvelope>
    export type DeleteVoiceMutationVariables = {teamId: string;brandId: string;voiceId: string}

    /**
 * @summary Delete Voice
 */
export const useDeleteVoice = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteVoice>>, TError,DeleteVoiceMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteVoice>>,
        TError,
        DeleteVoiceMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteVoiceMutationOptions(options), queryClient);
    }
    export const getCompleteVoiceUploadUrl = (teamId: string,
    brandId: string,
    voiceId: string,) => {




  return `/api/v1/teams/${teamId}/brands/${brandId}/voices/${voiceId}/complete`
}

/**
 * The posted sample becomes the brand's voice, once read: 15 to 60 seconds, as live's.
 * 404 while no file is there (none uploaded under this id, or another team's id); 422 for a
 * file of another length.
 * @summary Complete Voice Upload
 */
export const completeVoiceUpload = async (teamId: string,
    brandId: string,
    voiceId: string,
    voiceCompleteRequest: VoiceCompleteRequest, options?: Parameters<typeof apiRequest>[1]): Promise<Voice> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<Voice>(getCompleteVoiceUploadUrl(teamId,brandId,voiceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(voiceCompleteRequest)
  }
);}





export const getCompleteVoiceUploadMutationKey = () => ['completeVoiceUpload'] as const;

export const getCompleteVoiceUploadMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeVoiceUpload>>, TError,CompleteVoiceUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof completeVoiceUpload>>, TError,CompleteVoiceUploadMutationVariables, TContext> => {

const mutationKey = getCompleteVoiceUploadMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeVoiceUpload>>, CompleteVoiceUploadMutationVariables> = (props) => {
          const {teamId,brandId,voiceId,data} = props ?? {};

          return  completeVoiceUpload(teamId,brandId,voiceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteVoiceUploadMutationResult = NonNullable<Awaited<ReturnType<typeof completeVoiceUpload>>>
    export type CompleteVoiceUploadMutationBody = VoiceCompleteRequest
    export type CompleteVoiceUploadMutationError = ErrorType<ErrorEnvelope>
    export type CompleteVoiceUploadMutationVariables = {teamId: string;brandId: string;voiceId: string;data: VoiceCompleteRequest}

    /**
 * @summary Complete Voice Upload
 */
export const useCompleteVoiceUpload = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeVoiceUpload>>, TError,CompleteVoiceUploadMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeVoiceUpload>>,
        TError,
        CompleteVoiceUploadMutationVariables,
        TContext
      > => {
      return useMutation(getCompleteVoiceUploadMutationOptions(options), queryClient);
    }
    export const getRunTeamFirstAdProductUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/first-ad-product`
}

/**
 * @summary Run Team First Ad Product
 */
export const runTeamFirstAdProduct = async (teamId: string,
    firstAdProductRequest: FirstAdProductRequest, options?: Parameters<typeof apiRequest>[1]): Promise<FirstAdProductIntake> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiRequest<FirstAdProductIntake>(getRunTeamFirstAdProductUrl(teamId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(firstAdProductRequest)
  }
);}





export const getRunTeamFirstAdProductMutationKey = () => ['runTeamFirstAdProduct'] as const;

export const getRunTeamFirstAdProductMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runTeamFirstAdProduct>>, TError,RunTeamFirstAdProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof runTeamFirstAdProduct>>, TError,RunTeamFirstAdProductMutationVariables, TContext> => {

const mutationKey = getRunTeamFirstAdProductMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runTeamFirstAdProduct>>, RunTeamFirstAdProductMutationVariables> = (props) => {
          const {teamId,data} = props ?? {};

          return  runTeamFirstAdProduct(teamId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunTeamFirstAdProductMutationResult = NonNullable<Awaited<ReturnType<typeof runTeamFirstAdProduct>>>
    export type RunTeamFirstAdProductMutationBody = FirstAdProductRequest
    export type RunTeamFirstAdProductMutationError = ErrorType<ErrorEnvelope>
    export type RunTeamFirstAdProductMutationVariables = {teamId: string;data: FirstAdProductRequest}

    /**
 * @summary Run Team First Ad Product
 */
export const useRunTeamFirstAdProduct = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runTeamFirstAdProduct>>, TError,RunTeamFirstAdProductMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof runTeamFirstAdProduct>>,
        TError,
        RunTeamFirstAdProductMutationVariables,
        TContext
      > => {
      return useMutation(getRunTeamFirstAdProductMutationOptions(options), queryClient);
    }
    export const getListJobsUrl = (teamId: string,
    params?: ListJobsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["type"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/jobs?${stringifiedParams}` : `/api/v1/teams/${teamId}/jobs`
}

/**
 * The team's jobs, newest first: the Studio's (every type but `image.actor`, as
 * live's), or those of the types `type` names (`image.actor`: the AI Actors page's My
 * Generations; `image.template` and `video.template`: the Templates page's); `medium` keeps
 * those of one medium (the Image, Video and Sounds pages' My Generations, a page of their
 * own jobs alone: live's 5 at a time); `status=active` after missed events, `after` for the
 * next page (its cursor is `next` of the previous one).
 * @summary List Jobs
 */
export const listJobs = async (teamId: string,
    params?: ListJobsParams, options?: Parameters<typeof apiRequest>[1]): Promise<JobPage> => {

  return apiRequest<JobPage>(getListJobsUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListJobsQueryKey = (teamId: string,
    params?: ListJobsParams,) => {
    return [
    `/api/v1/teams/${teamId}/jobs`, ...(params ? [params] : [])
    ] as const;
    }


export const getListJobsQueryOptions = <TData = Awaited<ReturnType<typeof listJobs>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    params?: ListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListJobsQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listJobs>>> = ({ signal }) => listJobs(teamId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListJobsQueryResult = NonNullable<Awaited<ReturnType<typeof listJobs>>>
export type ListJobsQueryError = ErrorType<ErrorEnvelope>


export function useListJobs<TData = Awaited<ReturnType<typeof listJobs>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params: undefined |  ListJobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobs>>,
          TError,
          Awaited<ReturnType<typeof listJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobs<TData = Awaited<ReturnType<typeof listJobs>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params?: ListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listJobs>>,
          TError,
          Awaited<ReturnType<typeof listJobs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListJobs<TData = Awaited<ReturnType<typeof listJobs>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params?: ListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Jobs
 */

export function useListJobs<TData = Awaited<ReturnType<typeof listJobs>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params?: ListJobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listJobs>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListJobsQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getDeleteJobUrl = (teamId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/jobs/${jobId}`
}

/**
 * Live's "Delete generation": its maker hides a settled job for good (404 after);
 * `JOB_ACTIVE` (409) while it runs, `PERMISSION_DENIED` (403) for anyone else.
 * @summary Delete Job
 */
export const deleteJob = async (teamId: string,
    jobId: string, options?: Parameters<typeof apiRequest>[1]): Promise<void> => {

  return apiRequest<void>(getDeleteJobUrl(teamId,jobId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteJobMutationKey = () => ['deleteJob'] as const;

export const getDeleteJobMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJob>>, TError,DeleteJobMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteJob>>, TError,DeleteJobMutationVariables, TContext> => {

const mutationKey = getDeleteJobMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteJob>>, DeleteJobMutationVariables> = (props) => {
          const {teamId,jobId} = props ?? {};

          return  deleteJob(teamId,jobId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteJobMutationResult = NonNullable<Awaited<ReturnType<typeof deleteJob>>>

    export type DeleteJobMutationError = ErrorType<ErrorEnvelope>
    export type DeleteJobMutationVariables = {teamId: string;jobId: string}

    /**
 * @summary Delete Job
 */
export const useDeleteJob = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteJob>>, TError,DeleteJobMutationVariables, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteJob>>,
        TError,
        DeleteJobMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteJobMutationOptions(options), queryClient);
    }
    export const getGetJobUrl = (teamId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/jobs/${jobId}`
}

/**
 * @summary Get Job
 */
export const getJob = async (teamId: string,
    jobId: string, options?: Parameters<typeof apiRequest>[1]): Promise<Job> => {

  return apiRequest<Job>(getGetJobUrl(teamId,jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobQueryKey = (teamId: string,
    jobId: string,) => {
    return [
    `/api/v1/teams/${teamId}/jobs/${jobId}`
    ] as const;
    }


export const getGetJobQueryOptions = <TData = Awaited<ReturnType<typeof getJob>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobQueryKey(teamId,jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJob>>> = ({ signal }) => getJob(teamId,jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobQueryResult = NonNullable<Awaited<ReturnType<typeof getJob>>>
export type GetJobQueryError = ErrorType<ErrorEnvelope>


export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJob>>,
          TError,
          Awaited<ReturnType<typeof getJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJob>>,
          TError,
          Awaited<ReturnType<typeof getJob>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Job
 */

export function useGetJob<TData = Awaited<ReturnType<typeof getJob>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJob>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobQueryOptions(teamId,jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetJobDetailsUrl = (teamId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/jobs/${jobId}/details`
}

/**
 * What the lightbox's ⓘ shows beyond the job (G1 decision 30): the credits charged,
 * null until charged; the names of its voices; its global actors with their portraits.
 * @summary Get Job Details
 */
export const getJobDetails = async (teamId: string,
    jobId: string, options?: Parameters<typeof apiRequest>[1]): Promise<JobDetails> => {

  return apiRequest<JobDetails>(getGetJobDetailsUrl(teamId,jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetJobDetailsQueryKey = (teamId: string,
    jobId: string,) => {
    return [
    `/api/v1/teams/${teamId}/jobs/${jobId}/details`
    ] as const;
    }


export const getGetJobDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getJobDetails>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobDetails>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetJobDetailsQueryKey(teamId,jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getJobDetails>>> = ({ signal }) => getJobDetails(teamId,jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getJobDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetJobDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getJobDetails>>>
export type GetJobDetailsQueryError = ErrorType<ErrorEnvelope>


export function useGetJobDetails<TData = Awaited<ReturnType<typeof getJobDetails>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobDetails>>,
          TError,
          Awaited<ReturnType<typeof getJobDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobDetails<TData = Awaited<ReturnType<typeof getJobDetails>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getJobDetails>>,
          TError,
          Awaited<ReturnType<typeof getJobDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetJobDetails<TData = Awaited<ReturnType<typeof getJobDetails>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobDetails>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Job Details
 */

export function useGetJobDetails<TData = Awaited<ReturnType<typeof getJobDetails>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getJobDetails>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetJobDetailsQueryOptions(teamId,jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListLayerEditsUrl = (teamId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/jobs/${jobId}/layer-edits`
}

/**
 * A Layerize's AI edits, newest first, at most 200, for the layer editor (G13b PR B1);
 * 404 for any job that is not a Layerize of the team.
 * @summary List Layer Edits
 */
export const listLayerEdits = async (teamId: string,
    jobId: string, options?: Parameters<typeof apiRequest>[1]): Promise<LayerEditList> => {

  return apiRequest<LayerEditList>(getListLayerEditsUrl(teamId,jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLayerEditsQueryKey = (teamId: string,
    jobId: string,) => {
    return [
    `/api/v1/teams/${teamId}/jobs/${jobId}/layer-edits`
    ] as const;
    }


export const getListLayerEditsQueryOptions = <TData = Awaited<ReturnType<typeof listLayerEdits>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLayerEdits>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLayerEditsQueryKey(teamId,jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLayerEdits>>> = ({ signal }) => listLayerEdits(teamId,jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLayerEdits>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLayerEditsQueryResult = NonNullable<Awaited<ReturnType<typeof listLayerEdits>>>
export type ListLayerEditsQueryError = ErrorType<ErrorEnvelope>


export function useListLayerEdits<TData = Awaited<ReturnType<typeof listLayerEdits>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLayerEdits>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLayerEdits>>,
          TError,
          Awaited<ReturnType<typeof listLayerEdits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLayerEdits<TData = Awaited<ReturnType<typeof listLayerEdits>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLayerEdits>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLayerEdits>>,
          TError,
          Awaited<ReturnType<typeof listLayerEdits>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLayerEdits<TData = Awaited<ReturnType<typeof listLayerEdits>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLayerEdits>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Layer Edits
 */

export function useListLayerEdits<TData = Awaited<ReturnType<typeof listLayerEdits>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLayerEdits>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLayerEditsQueryOptions(teamId,jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetLayerDocumentUrl = (teamId: string,
    jobId: string,) => {




  return `/api/v1/teams/${teamId}/jobs/${jobId}/layers`
}

/**
 * A finished Layerize's layers and where each sits, for the layer editor (G13b PR A);
 * 404 for any other job, and for a Layerize from before its document was kept.
 * @summary Get Layer Document
 */
export const getLayerDocument = async (teamId: string,
    jobId: string, options?: Parameters<typeof apiRequest>[1]): Promise<LayerDocument> => {

  return apiRequest<LayerDocument>(getGetLayerDocumentUrl(teamId,jobId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLayerDocumentQueryKey = (teamId: string,
    jobId: string,) => {
    return [
    `/api/v1/teams/${teamId}/jobs/${jobId}/layers`
    ] as const;
    }


export const getGetLayerDocumentQueryOptions = <TData = Awaited<ReturnType<typeof getLayerDocument>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLayerDocument>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLayerDocumentQueryKey(teamId,jobId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLayerDocument>>> = ({ signal }) => getLayerDocument(teamId,jobId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && jobId !== null && jobId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLayerDocument>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetLayerDocumentQueryResult = NonNullable<Awaited<ReturnType<typeof getLayerDocument>>>
export type GetLayerDocumentQueryError = ErrorType<ErrorEnvelope>


export function useGetLayerDocument<TData = Awaited<ReturnType<typeof getLayerDocument>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLayerDocument>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLayerDocument>>,
          TError,
          Awaited<ReturnType<typeof getLayerDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLayerDocument<TData = Awaited<ReturnType<typeof getLayerDocument>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLayerDocument>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLayerDocument>>,
          TError,
          Awaited<ReturnType<typeof getLayerDocument>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetLayerDocument<TData = Awaited<ReturnType<typeof getLayerDocument>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLayerDocument>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Layer Document
 */

export function useGetLayerDocument<TData = Awaited<ReturnType<typeof getLayerDocument>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    jobId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLayerDocument>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetLayerDocumentQueryOptions(teamId,jobId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTemplatesUrl = (teamId: string,
    params?: ListTemplatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/teams/${teamId}/templates?${stringifiedParams}` : `/api/v1/teams/${teamId}/templates`
}

/**
 * The library, 24 a page, in live's order (its templates, then Coming soon). `search`
 * in the title (live's "Search by templates name"), one category, one medium, `available`
 * for the cards that can be run. A live template whose run is not built shows as Coming
 * soon in its place. `next` names the last card of the page. Covers and examples are
 * signed until `urls_expire_at`.
 * @summary List Templates
 */
export const listTemplates = async (teamId: string,
    params?: ListTemplatesParams, options?: Parameters<typeof apiRequest>[1]): Promise<TemplatePage> => {

  return apiRequest<TemplatePage>(getListTemplatesUrl(teamId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTemplatesQueryKey = (teamId: string,
    params?: ListTemplatesParams,) => {
    return [
    `/api/v1/teams/${teamId}/templates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof listTemplates>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplatesQueryKey(teamId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplates>>> = ({ signal }) => listTemplates(teamId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplates>>>
export type ListTemplatesQueryError = ErrorType<ErrorEnvelope>


export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params: undefined |  ListTemplatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplates>>,
          TError,
          Awaited<ReturnType<typeof listTemplates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Templates
 */

export function useListTemplates<TData = Awaited<ReturnType<typeof listTemplates>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    params?: ListTemplatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplates>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTemplatesQueryOptions(teamId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTemplateCaptionStylesUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/templates/caption-styles`
}

/**
 * Live's caption styles a template's subtitles picker offers, in live's order, and the
 * one a fresh form picks (Promote Your Product's picker; its run burns the one picked).
 * @summary List Template Caption Styles
 */
export const listTemplateCaptionStyles = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<TemplateCaptionStyleList> => {

  return apiRequest<TemplateCaptionStyleList>(getListTemplateCaptionStylesUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTemplateCaptionStylesQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/templates/caption-styles`
    ] as const;
    }


export const getListTemplateCaptionStylesQueryOptions = <TData = Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplateCaptionStylesQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplateCaptionStyles>>> = ({ signal }) => listTemplateCaptionStyles(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTemplateCaptionStylesQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplateCaptionStyles>>>
export type ListTemplateCaptionStylesQueryError = ErrorType<ErrorEnvelope>


export function useListTemplateCaptionStyles<TData = Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateCaptionStyles>>,
          TError,
          Awaited<ReturnType<typeof listTemplateCaptionStyles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateCaptionStyles<TData = Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateCaptionStyles>>,
          TError,
          Awaited<ReturnType<typeof listTemplateCaptionStyles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateCaptionStyles<TData = Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Template Caption Styles
 */

export function useListTemplateCaptionStyles<TData = Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCaptionStyles>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTemplateCaptionStylesQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getListTemplateCategoriesUrl = (teamId: string,) => {




  return `/api/v1/teams/${teamId}/templates/categories`
}

/**
 * The categories that hold a card, in live's order: the page's pills after "All".
 * @summary List Template Categories
 */
export const listTemplateCategories = async (teamId: string, options?: Parameters<typeof apiRequest>[1]): Promise<TemplateCategoryList> => {

  return apiRequest<TemplateCategoryList>(getListTemplateCategoriesUrl(teamId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTemplateCategoriesQueryKey = (teamId: string,) => {
    return [
    `/api/v1/teams/${teamId}/templates/categories`
    ] as const;
    }


export const getListTemplateCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof listTemplateCategories>>, TError = ErrorType<ErrorEnvelope>>(teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCategories>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTemplateCategoriesQueryKey(teamId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTemplateCategories>>> = ({ signal }) => listTemplateCategories(teamId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTemplateCategories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListTemplateCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof listTemplateCategories>>>
export type ListTemplateCategoriesQueryError = ErrorType<ErrorEnvelope>


export function useListTemplateCategories<TData = Awaited<ReturnType<typeof listTemplateCategories>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCategories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateCategories>>,
          TError,
          Awaited<ReturnType<typeof listTemplateCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateCategories<TData = Awaited<ReturnType<typeof listTemplateCategories>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCategories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTemplateCategories>>,
          TError,
          Awaited<ReturnType<typeof listTemplateCategories>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListTemplateCategories<TData = Awaited<ReturnType<typeof listTemplateCategories>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCategories>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Template Categories
 */

export function useListTemplateCategories<TData = Awaited<ReturnType<typeof listTemplateCategories>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listTemplateCategories>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListTemplateCategoriesQueryOptions(teamId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTemplateUrl = (teamId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/templates/${templateId}`
}

/**
 * One template as Use and Replicate open it: its card and its example's inputs. No
 * such template, or a retired one, is 404.
 * @summary Get Template
 */
export const getTemplate = async (teamId: string,
    templateId: string, options?: Parameters<typeof apiRequest>[1]): Promise<TemplateDetail> => {

  return apiRequest<TemplateDetail>(getGetTemplateUrl(teamId,templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTemplateQueryKey = (teamId: string,
    templateId: string,) => {
    return [
    `/api/v1/teams/${teamId}/templates/${templateId}`
    ] as const;
    }


export const getGetTemplateQueryOptions = <TData = Awaited<ReturnType<typeof getTemplate>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTemplateQueryKey(teamId,templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplate>>> = ({ signal }) => getTemplate(teamId,templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTemplateQueryResult = NonNullable<Awaited<ReturnType<typeof getTemplate>>>
export type GetTemplateQueryError = ErrorType<ErrorEnvelope>


export function useGetTemplate<TData = Awaited<ReturnType<typeof getTemplate>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    templateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplate<TData = Awaited<ReturnType<typeof getTemplate>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplate<TData = Awaited<ReturnType<typeof getTemplate>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Template
 */

export function useGetTemplate<TData = Awaited<ReturnType<typeof getTemplate>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTemplateQueryOptions(teamId,templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetTemplateFormUrl = (teamId: string,
    templateId: string,) => {




  return `/api/v1/teams/${teamId}/templates/${templateId}/form`
}

/**
 * What a run of one template takes, its inputs model as JSON Schema (spec
 * platform/mcp-server, PR 3): for a client with no example, as Talking Head Overlay's.
 * A template no recipe of ours runs, a retired one or a Coming soon card is 404.
 * @summary Get Template Form
 */
export const getTemplateForm = async (teamId: string,
    templateId: string, options?: Parameters<typeof apiRequest>[1]): Promise<TemplateForm> => {

  return apiRequest<TemplateForm>(getGetTemplateFormUrl(teamId,templateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetTemplateFormQueryKey = (teamId: string,
    templateId: string,) => {
    return [
    `/api/v1/teams/${teamId}/templates/${templateId}/form`
    ] as const;
    }


export const getGetTemplateFormQueryOptions = <TData = Awaited<ReturnType<typeof getTemplateForm>>, TError = ErrorType<ErrorEnvelope>>(teamId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateForm>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTemplateFormQueryKey(teamId,templateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplateForm>>> = ({ signal }) => getTemplateForm(teamId,templateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: teamId !== null && teamId !== undefined && templateId !== null && templateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTemplateForm>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTemplateFormQueryResult = NonNullable<Awaited<ReturnType<typeof getTemplateForm>>>
export type GetTemplateFormQueryError = ErrorType<ErrorEnvelope>


export function useGetTemplateForm<TData = Awaited<ReturnType<typeof getTemplateForm>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    templateId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateForm>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateForm>>,
          TError,
          Awaited<ReturnType<typeof getTemplateForm>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplateForm<TData = Awaited<ReturnType<typeof getTemplateForm>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateForm>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateForm>>,
          TError,
          Awaited<ReturnType<typeof getTemplateForm>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTemplateForm<TData = Awaited<ReturnType<typeof getTemplateForm>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateForm>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Template Form
 */

export function useGetTemplateForm<TData = Awaited<ReturnType<typeof getTemplateForm>>, TError = ErrorType<ErrorEnvelope>>(
 teamId: string,
    templateId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTemplateForm>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTemplateFormQueryOptions(teamId,templateId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






